const page_title = {
    "status": true,
    "data": {
        "page_title_setting": {
            "label": "",
            "font": "Poppins",
            "font_size": 38,
            "font_bold": true,
            "color": "#f52b2b"
        },
        "url_key": "shop-by-brand",
        "meta_title": "Brand",
        "meta_keywords": "Brand list",
        "meta_description": "String",
        "featured_brand": 0,
        "search_box": 0,
        "brand_list": 0,
        "alphabet_list": 1,
        "redirect_url": "",
        "_id": "6095abc845a52836f8ad0b60",
        "shop_id": "6095abc845a52836f8ad0b54",
        "createdAt": "2021-05-07T21:06:16.292Z",
        "updatedAt": "2021-05-12T12:19:03.927Z"
    }
};
const setting = {
    "status": true,
    "data": {
        "featured_brand_setting": {
            "_id": "6095abc845a52836f8ad0b5c",
            "general_setting": {
                "background": "#ffffff",
                "border_size": 0,
                "border_color": "#ffffff",
                "margin_top": 50,
                "margin_bottom": 25,
                "padding_top": 15,
                "padding_right": 0,
                "padding_bottom": 20,
                "padding_left": 0
            },
            "title_setting": {
                "label": "Feature brand",
                "font": "Poppins",
                "font_size": 18,
                "color": "#3a4892",
                "font_bold": true,
                "align": 3,
                "margin_top": 0,
                "margin_bottom": 10,
                "border_size": 0,
                "border_color": "#515482",
                "border_margin": 0
            },
            "brand_setting": {
                "limit": 10,
                "brand_per_row": 5,
                "brand_per_row_mobile": 2,
                "brand_per_row_tablet": 3,
                "image_width": 200,
                "image_height": 200,
                "hover_efect": "effect-3",
                "use_slider": true,
                "slide_by": 1,
                "rtl": true,
                "margin": 30,
                "autoplay": true,
                "autoplay_timeout": "1000",
                "mouseover_stop": "string",
                "loop": true,
                "display_navigation": true,
                "hide_navigation": false,
                "navigation_position": 1,
                "navigation_size": 35,
                "navigation_color": "#e9ecef",
                "navigation_hover_color": "#5d6cc1",
                "display_Pagination": false,
                "pagination_width": 12,
                "pagination_height": 12,
                "pagination_border_radius": 7,
                "pagination_color": "#e9ecef",
                "pagination_active_color": "#5d6cc1",
                "pagination_margin": 30,
                "pagination_margin_top": 50
            },
            "brand_name_setting": {
                "display": true,
                "font": "Poppins",
                "font_size": 14,
                "color": "#000000",
                "position": 1,
                "background": "#000000",
                "background_opacity": 0.4,
                "auto_hide": false,
                "text_align": 1,
                "margin_top": 10,
                "margin_bottom": 0,
                "display_product_count": 0,
                "pc_text_format": " (%s products)",
                "pc_font_size": 14,
                "pc_color": "#5f5c5c",
                "pc_position": 2
            },
            "position": 1,
            "visible": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "created_at": "2021-05-07T21:06:16.257Z",
            "updated_at": "2021-05-12T12:19:04.096Z"
        },
        "search_box_setting": {
            "_id": "6095abc845a52836f8ad0b5d",
            "general_setting": {
                "background": "#6a4ffb",
                "border_size": 0,
                "border_color": "#ffffff",
                "border_radius": 0,
                "margin_top": 40,
                "margin_bottom": 40,
                "padding_top": 25,
                "padding_right": 20,
                "padding_bottom": 30,
                "padding_left": 20,
                "content_align": 2
            },
            "title_setting": {
                "label": "Search",
                "font": "Poppins",
                "font_size": 18,
                "color": "#f6f6f6",
                "font_bold": true,
                "align": 3,
                "margin_top": 0,
                "margin_bottom": 20,
                "border_size": 0,
                "border_color": "#969393",
                "border_margin": 0
            },
            "search_input_setting": {
                "placeholder": "Search for...",
                "color": "#e6e4f3",
                "font_size": 16,
                "background": "#5c45e7",
                "padding_top": 20,
                "padding_right": 40,
                "padding_bottom": 20,
                "padding_left": 40,
                "margin_top": 0,
                "margin_right": 0,
                "margin_bottom": 0,
                "margin_left": 0,
                "border_size": 0,
                "border_color": "#b66a6a",
                "border_radius": 30
            },
            "search_suggest_setting": {
                "background": "#ffffff",
                "hover_background": "#e6f4ff",
                "box_shadow": "0px 20px 45px 0px rgba(19, 25, 59, 0.1)",
                "bottom": 10,
                "show_brand_image": true,
                "image_width": 150,
                "image_height": 150,
                "image_margin": 20,
                "show_brand_name": true,
                "br_font": "Poppins",
                "br_font_size": 18,
                "br_color": "#2d2e2f",
                "br_font_bold": true,
                "br_uppercase": false,
                "br_margin_top": 0,
                "br_margin_bottom": 0,
                "show_short_description": true,
                "sd_font": "Poppins",
                "sd_font_size": 14,
                "sd_color": "#2d2e2f",
                "sd_margin_top": 10,
                "sd_margin_bottom": 0,
                "divider_color": "#ffffff",
                "padding_top": 20,
                "padding_bottom": 20
            },
            "position": 2,
            "visible": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "created_at": "2021-05-07T21:06:16.266Z",
            "updated_at": "2021-05-12T12:19:04.096Z"
        },
        "brand_list_setting": {
            "_id": "6095abc845a52836f8ad0b5e",
            "general_setting": {
                "margin_top": 20,
                "margin_bottom": 20,
                "limit": 10,
                "brand_per_row": 5,
                "brand_per_row_mobile": 2,
                "brand_per_row_tablet": 3,
                "image_width": 155,
                "image_height": 155,
                "hover_effect": "effect-1",
                "ajax_load": true,
                "load_limit": 4,
                "loadmore_text": "View More",
                "loadmore_font": "Poppins",
                "loadmore_font_size": 14,
                "loadmore_color": "#ffffff",
                "loadmore_hover_color": "#ffffff",
                "loadmore_font_bold": false,
                "loadmore_background": "#5d6cc1",
                "loadmore_hover_background": "#6886d8",
                "loadmore_border_color": "#5d6cc1",
                "loadmore_border_hover_color": "#6886d8",
                "loadmore_border_size": 1,
                "loadmore_padding_top": 10,
                "loadmore_padding_right": 20,
                "loadmore_padding_bottom": 10,
                "loadmore_padding_left": 20,
                "loadmore_border_radius": 3,
                "loadmore_margin_top": 25,
                "loadmore_margin_bottom": 1
            },
            "title_setting": {
                "label": "",
                "font": "Poppins",
                "font_size": 18,
                "font_color": "#3a4892",
                "font_bold": true,
                "align": 3,
                "margin_top": 0,
                "margin_bottom": 0,
                "border_size": 0,
                "border_color": "#ffffff",
                "border_margin": 0
            },
            "brand_name_setting": {
                "font": "Poppins",
                "font_size": 14,
                "color": "#2d2c45",
                "position": 1,
                "background": "#000000",
                "background_opacity": 0.3,
                "auto_hide": false,
                "text_align": 1,
                "margin_top": 10,
                "margin_bottom": 1,
                "display_product_count": 1,
                "pc_text_format": "%s products",
                "pc_font_size": 17,
                "pc_color": "#000000",
                "pc_position": 2
            },
            "alphabet_search_setting": {
                "text_all": "All",
                "display_alphabet": true,
                "alphabet": "A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,Y,X,Z,W",
                "color": "#ffffff",
                "text_color": "#000",
                "text_color_active": "#fff",
                "color_active": "#ee400a",
                "color_disable": "#f0f0f0",
                "border_color": "#e0e0e0",
                "padding_top_bottom": 10,
                "padding_right_left": 5,
                "font_family": "Poppins",
                "font_size": 14,
                "width_height": 35,
                "margin_top_bottom": 10,
                "margin_right_left": 5
            },
            "position": 3,
            "visible": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "createdAt": "2021-05-07T21:06:16.275Z",
            "updatedAt": "2021-05-12T12:19:04.096Z"
        },
        "alphabet_list_setting": {
            "_id": "6095abc845a52836f8ad0b5f",
            "general_setting": {
                "margin_top": 15,
                "margin_bottom": 60,
                "alphabet": "A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,X,Y,W",
                "character_per_row": 1,
                "brand_per_row": 5,
                "brand_per_row_mobile": 2,
                "brand_per_row_tablet": 4,
                "brand_per_character": 30,
                "viewmore_text": "View More",
                "viewmore_color": "#c98a8a",
                "viewmore_hover_color": "#c91c1c"
            },
            "title_setting": {
                "label": "Brand Names by Alphabet",
                "font": "Poppins",
                "font_size": 33,
                "color": "#f52b2b",
                "font_bold": false,
                "uppercase": false,
                "align": 1,
                "margin_top": 0,
                "margin_bottom": 0,
                "border_size": 0,
                "border_color": "#e21c1c",
                "border_margin": 13
            },
            "character_setting": {
                "font": "PT Serif",
                "font_size": 35,
                "color": "#e42711",
                "margin_top": 55,
                "margin_bottom": 10
            },
            "brand_link_setting": {
                "font": "Roboto",
                "font_size": 18,
                "color": "#374b5d",
                "hovercolor": "#ee3c04",
                "line_height": 30
            },
            "position": 4,
            "visible": true,
            "shop_id": "6095abc845a52836f8ad0b54",
            "createdAt": "2021-05-07T21:06:16.284Z",
            "updatedAt": "2021-05-12T12:19:04.096Z"
        }
    }
};
const brands = {
    "status": true,
    "data": [{
        "_id": "6095abe445a52836f8ad1259",
        "products": ["6095abcb45a52836f8ad0b82", "6095abcb45a52836f8ad0b83", "6095abcb45a52836f8ad0b84", "6095abcb45a52836f8ad0b8b", "6095abcb45a52836f8ad0b8c", "6095abcb45a52836f8ad0b8d", "6095abe445a52836f8ad123e", "6095abe445a52836f8ad123f", "6095abe445a52836f8ad1240", "6095abe445a52836f8ad1241", "6095abe445a52836f8ad1242", "6095abe445a52836f8ad1243", "6095abe445a52836f8ad1244", "6095abe445a52836f8ad1245"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe445a52836f8ad1258",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Kuza",
            "brand_key": "kuza",
            "createdAt": "2021-05-07T21:06:44.579Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30318
        },
        "createdAt": "2021-05-07T21:06:44.633Z",
        "updatedAt": "2021-05-07T21:09:16.866Z"
    }, {
        "_id": "6095abe445a52836f8ad125b",
        "products": ["6095abcb45a52836f8ad0b85", "6095abcb45a52836f8ad0b8a", "6095abcb45a52836f8ad0b8e", "6095abcb45a52836f8ad0b8f", "6095abcb45a52836f8ad0b90", "6095abec45a52836f8ad147e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe445a52836f8ad125a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Me Gorgeous",
            "brand_key": "Me-Gorgeous",
            "createdAt": "2021-05-07T21:06:44.697Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30319
        },
        "createdAt": "2021-05-07T21:06:44.721Z",
        "updatedAt": "2021-05-07T21:09:17.370Z"
    },{
        "_id": "6095abe445a52836f8ad125b",
        "products": ["6095abcb45a52836f8ad0b85", "6095abcb45a52836f8ad0b8a", "6095abcb45a52836f8ad0b8e", "6095abcb45a52836f8ad0b8f", "6095abcb45a52836f8ad0b90", "6095abec45a52836f8ad147e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe445a52836f8ad125a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Morimax Oil",
            "brand_key": "morimax-oil",
            "createdAt": "2021-05-07T21:06:44.697Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30319
        },
        "createdAt": "2021-05-07T21:06:44.721Z",
        "updatedAt": "2021-05-07T21:09:17.370Z"
    }, {
        "_id": "6095abe445a52836f8ad125d",
        "products": ["6095abcb45a52836f8ad0b86", "6095abcb45a52836f8ad0b87", "6095abcb45a52836f8ad0b88", "6095abcb45a52836f8ad0b89", "6095abcb45a52836f8ad0b92", "6095abcb45a52836f8ad0b93", "6095abd345a52836f8ad0d98", "6095abd345a52836f8ad0d99", "6095abd345a52836f8ad0d9a", "6095abdf45a52836f8ad10ae", "6095abdf45a52836f8ad10af", "6095abdf45a52836f8ad10b0", "6095abf745a52836f8ad180a", "6095ac0145a52836f8ad1aa9", "6095ac0145a52836f8ad1aaa", "6095ac0145a52836f8ad1aab"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe445a52836f8ad125c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Bajaj",
            "brand_key": "Bajaj",
            "createdAt": "2021-05-07T21:06:44.835Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30320
        },
        "createdAt": "2021-05-07T21:06:44.863Z",
        "updatedAt": "2021-05-07T21:09:23.306Z"
    }, {
        "_id": "6095abe445a52836f8ad125d",
        "products": ["6095abcb45a52836f8ad0b86", "6095abcb45a52836f8ad0b87", "6095abcb45a52836f8ad0b88", "6095abcb45a52836f8ad0b89", "6095abcb45a52836f8ad0b92", "6095abcb45a52836f8ad0b93", "6095abd345a52836f8ad0d98", "6095abd345a52836f8ad0d99", "6095abd345a52836f8ad0d9a", "6095abdf45a52836f8ad10ae", "6095abdf45a52836f8ad10af", "6095abdf45a52836f8ad10b0", "6095abf745a52836f8ad180a", "6095ac0145a52836f8ad1aa9", "6095ac0145a52836f8ad1aaa", "6095ac0145a52836f8ad1aab"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe445a52836f8ad125c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Brazilian Hair",
            "brand_key": "brazilian-hair",
            "createdAt": "2021-05-07T21:06:44.835Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30320
        },
        "createdAt": "2021-05-07T21:06:44.863Z",
        "updatedAt": "2021-05-07T21:09:23.306Z"
    }, {
        "_id": "6095abe445a52836f8ad125f",
        "products": ["6095abcb45a52836f8ad0b91", "6095abcf45a52836f8ad0c87", "6095abcf45a52836f8ad0ca0", "6095abcf45a52836f8ad0d12", "6095abd345a52836f8ad0e39", "6095abd345a52836f8ad0e3a", "6095abd345a52836f8ad0e47", "6095abdb45a52836f8ad1011", "6095abdf45a52836f8ad106d", "6095abdf45a52836f8ad1073", "6095abdf45a52836f8ad109c", "6095abe445a52836f8ad1229", "6095abf045a52836f8ad1550", "6095abf045a52836f8ad1575", "6095abf045a52836f8ad15dc", "6095abf045a52836f8ad15dd", "6095abf045a52836f8ad15df", "6095abf445a52836f8ad170f", "6095abf445a52836f8ad1737", "6095abf445a52836f8ad1739", "6095abf745a52836f8ad1809", "6095abf745a52836f8ad1820", "6095abfa45a52836f8ad190f", "6095abfa45a52836f8ad1910", "6095abfa45a52836f8ad1911", "6095abfa45a52836f8ad1912", "6095abfa45a52836f8ad1913", "6095abfa45a52836f8ad1914", "6095abfa45a52836f8ad1915", "6095abfa45a52836f8ad1916", "6095abfa45a52836f8ad1917", "6095abfa45a52836f8ad1918", "6095abfa45a52836f8ad1919", "6095abfa45a52836f8ad191a", "6095abfa45a52836f8ad191b", "6095abfa45a52836f8ad191c", "6095abfa45a52836f8ad191d", "6095abfa45a52836f8ad191e", "6095abfa45a52836f8ad191f", "6095abfa45a52836f8ad1920", "6095abfa45a52836f8ad1921", "6095abfa45a52836f8ad1922", "6095abfa45a52836f8ad1923", "6095abfa45a52836f8ad1924", "6095abfa45a52836f8ad1925", "6095abfa45a52836f8ad1926", "6095abfa45a52836f8ad1927", "6095abfa45a52836f8ad1928", "6095abfa45a52836f8ad1929", "6095abfa45a52836f8ad192a", "6095abfa45a52836f8ad192b", "6095abfa45a52836f8ad192c", "6095abfa45a52836f8ad192d", "6095abfe45a52836f8ad192e", "6095abfe45a52836f8ad192f", "6095abfe45a52836f8ad1930", "6095abfe45a52836f8ad1931", "6095abfe45a52836f8ad1932", "6095abfe45a52836f8ad1933", "6095abfe45a52836f8ad1934", "6095abfe45a52836f8ad1935", "6095abfe45a52836f8ad1936", "6095abfe45a52836f8ad1937", "6095abfe45a52836f8ad1938", "6095abfe45a52836f8ad1939", "6095abfe45a52836f8ad193a", "6095abfe45a52836f8ad193b", "6095abfe45a52836f8ad193c", "6095abfe45a52836f8ad193d", "6095abfe45a52836f8ad193e", "6095abfe45a52836f8ad193f", "6095abfe45a52836f8ad1940", "6095abfe45a52836f8ad1941", "6095abfe45a52836f8ad1942", "6095abfe45a52836f8ad1943", "6095abfe45a52836f8ad1944", "6095abfe45a52836f8ad1945", "6095abfe45a52836f8ad1946", "6095abfe45a52836f8ad1947", "6095abfe45a52836f8ad1948", "6095abfe45a52836f8ad1949", "6095abfe45a52836f8ad194a", "6095abfe45a52836f8ad194b", "6095abfe45a52836f8ad194c", "6095abfe45a52836f8ad194d", "6095abfe45a52836f8ad194e", "6095abfe45a52836f8ad194f", "6095abfe45a52836f8ad1950", "6095abfe45a52836f8ad1951", "6095abfe45a52836f8ad1952", "6095abfe45a52836f8ad1953", "6095abfe45a52836f8ad1954", "6095abfe45a52836f8ad1955", "6095abfe45a52836f8ad1956", "6095abfe45a52836f8ad1957", "6095abfe45a52836f8ad1958", "6095abfe45a52836f8ad1959", "6095abfe45a52836f8ad195a", "6095abfe45a52836f8ad195b", "6095abfe45a52836f8ad195c", "6095abfe45a52836f8ad195d", "6095abfe45a52836f8ad195e", "6095abfe45a52836f8ad195f", "6095abfe45a52836f8ad1960", "6095abfe45a52836f8ad1961", "6095abfe45a52836f8ad1962", "6095abfe45a52836f8ad1963", "6095abfe45a52836f8ad1964", "6095abfe45a52836f8ad1965", "6095abfe45a52836f8ad1966", "6095abfe45a52836f8ad1967", "6095abfe45a52836f8ad1968", "6095abfe45a52836f8ad1969", "6095abfe45a52836f8ad196a", "6095abfe45a52836f8ad196b", "6095abfe45a52836f8ad196c", "6095abfe45a52836f8ad196d", "6095abfe45a52836f8ad196e", "6095abfe45a52836f8ad196f", "6095abfe45a52836f8ad1970", "6095abfe45a52836f8ad1971", "6095abfe45a52836f8ad1972", "6095abfe45a52836f8ad1973", "6095abfe45a52836f8ad1974", "6095abfe45a52836f8ad1975", "6095abfe45a52836f8ad1976", "6095abfe45a52836f8ad1977"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe445a52836f8ad125e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Silka",
            "brand_key": "silka",
            "createdAt": "2021-05-07T21:06:44.925Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30321
        },
        "createdAt": "2021-05-07T21:06:44.947Z",
        "updatedAt": "2021-05-07T21:09:16.570Z"
    }, {
        "_id": "6095abe445a52836f8ad125f",
        "products": ["6095abcb45a52836f8ad0b91", "6095abcf45a52836f8ad0c87", "6095abcf45a52836f8ad0ca0", "6095abcf45a52836f8ad0d12", "6095abd345a52836f8ad0e39", "6095abd345a52836f8ad0e3a", "6095abd345a52836f8ad0e47", "6095abdb45a52836f8ad1011", "6095abdf45a52836f8ad106d", "6095abdf45a52836f8ad1073", "6095abdf45a52836f8ad109c", "6095abe445a52836f8ad1229", "6095abf045a52836f8ad1550", "6095abf045a52836f8ad1575", "6095abf045a52836f8ad15dc", "6095abf045a52836f8ad15dd", "6095abf045a52836f8ad15df", "6095abf445a52836f8ad170f", "6095abf445a52836f8ad1737", "6095abf445a52836f8ad1739", "6095abf745a52836f8ad1809", "6095abf745a52836f8ad1820", "6095abfa45a52836f8ad190f", "6095abfa45a52836f8ad1910", "6095abfa45a52836f8ad1911", "6095abfa45a52836f8ad1912", "6095abfa45a52836f8ad1913", "6095abfa45a52836f8ad1914", "6095abfa45a52836f8ad1915", "6095abfa45a52836f8ad1916", "6095abfa45a52836f8ad1917", "6095abfa45a52836f8ad1918", "6095abfa45a52836f8ad1919", "6095abfa45a52836f8ad191a", "6095abfa45a52836f8ad191b", "6095abfa45a52836f8ad191c", "6095abfa45a52836f8ad191d", "6095abfa45a52836f8ad191e", "6095abfa45a52836f8ad191f", "6095abfa45a52836f8ad1920", "6095abfa45a52836f8ad1921", "6095abfa45a52836f8ad1922", "6095abfa45a52836f8ad1923", "6095abfa45a52836f8ad1924", "6095abfa45a52836f8ad1925", "6095abfa45a52836f8ad1926", "6095abfa45a52836f8ad1927", "6095abfa45a52836f8ad1928", "6095abfa45a52836f8ad1929", "6095abfa45a52836f8ad192a", "6095abfa45a52836f8ad192b", "6095abfa45a52836f8ad192c", "6095abfa45a52836f8ad192d", "6095abfe45a52836f8ad192e", "6095abfe45a52836f8ad192f", "6095abfe45a52836f8ad1930", "6095abfe45a52836f8ad1931", "6095abfe45a52836f8ad1932", "6095abfe45a52836f8ad1933", "6095abfe45a52836f8ad1934", "6095abfe45a52836f8ad1935", "6095abfe45a52836f8ad1936", "6095abfe45a52836f8ad1937", "6095abfe45a52836f8ad1938", "6095abfe45a52836f8ad1939", "6095abfe45a52836f8ad193a", "6095abfe45a52836f8ad193b", "6095abfe45a52836f8ad193c", "6095abfe45a52836f8ad193d", "6095abfe45a52836f8ad193e", "6095abfe45a52836f8ad193f", "6095abfe45a52836f8ad1940", "6095abfe45a52836f8ad1941", "6095abfe45a52836f8ad1942", "6095abfe45a52836f8ad1943", "6095abfe45a52836f8ad1944", "6095abfe45a52836f8ad1945", "6095abfe45a52836f8ad1946", "6095abfe45a52836f8ad1947", "6095abfe45a52836f8ad1948", "6095abfe45a52836f8ad1949", "6095abfe45a52836f8ad194a", "6095abfe45a52836f8ad194b", "6095abfe45a52836f8ad194c", "6095abfe45a52836f8ad194d", "6095abfe45a52836f8ad194e", "6095abfe45a52836f8ad194f", "6095abfe45a52836f8ad1950", "6095abfe45a52836f8ad1951", "6095abfe45a52836f8ad1952", "6095abfe45a52836f8ad1953", "6095abfe45a52836f8ad1954", "6095abfe45a52836f8ad1955", "6095abfe45a52836f8ad1956", "6095abfe45a52836f8ad1957", "6095abfe45a52836f8ad1958", "6095abfe45a52836f8ad1959", "6095abfe45a52836f8ad195a", "6095abfe45a52836f8ad195b", "6095abfe45a52836f8ad195c", "6095abfe45a52836f8ad195d", "6095abfe45a52836f8ad195e", "6095abfe45a52836f8ad195f", "6095abfe45a52836f8ad1960", "6095abfe45a52836f8ad1961", "6095abfe45a52836f8ad1962", "6095abfe45a52836f8ad1963", "6095abfe45a52836f8ad1964", "6095abfe45a52836f8ad1965", "6095abfe45a52836f8ad1966", "6095abfe45a52836f8ad1967", "6095abfe45a52836f8ad1968", "6095abfe45a52836f8ad1969", "6095abfe45a52836f8ad196a", "6095abfe45a52836f8ad196b", "6095abfe45a52836f8ad196c", "6095abfe45a52836f8ad196d", "6095abfe45a52836f8ad196e", "6095abfe45a52836f8ad196f", "6095abfe45a52836f8ad1970", "6095abfe45a52836f8ad1971", "6095abfe45a52836f8ad1972", "6095abfe45a52836f8ad1973", "6095abfe45a52836f8ad1974", "6095abfe45a52836f8ad1975", "6095abfe45a52836f8ad1976", "6095abfe45a52836f8ad1977"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe445a52836f8ad125e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Sleek Hair",
            "brand_key": "sleek-hair",
            "createdAt": "2021-05-07T21:06:44.925Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30321
        },
        "createdAt": "2021-05-07T21:06:44.947Z",
        "updatedAt": "2021-05-07T21:09:16.570Z"
    }, {
        "_id": "6095abe545a52836f8ad1261",
        "products": ["6095abcb45a52836f8ad0b94", "6095abcb45a52836f8ad0b95", "6095abfe45a52836f8ad198d", "6095abfe45a52836f8ad198e", "6095abfe45a52836f8ad198f", "6095abfe45a52836f8ad1990", "6095abfe45a52836f8ad1991", "6095abfe45a52836f8ad1992", "6095abfe45a52836f8ad1993", "6095abfe45a52836f8ad1994", "6095abfe45a52836f8ad1995"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad1260",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Soft & Precious",
            "brand_key": "soft-&-precious",
            "createdAt": "2021-05-07T21:06:45.005Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30322
        },
        "createdAt": "2021-05-07T21:06:45.029Z",
        "updatedAt": "2021-05-07T21:09:25.512Z"
    }, {
        "_id": "6095abe545a52836f8ad1263",
        "products": ["6095abcb45a52836f8ad0b96", "6095ac0145a52836f8ad1a5e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad1262",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Darbro",
            "brand_key": "Darbro",
            "createdAt": "2021-05-07T21:06:45.090Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30323
        },
        "createdAt": "2021-05-07T21:06:45.111Z",
        "updatedAt": "2021-05-07T21:09:27.560Z"
    }, {
        "_id": "6095abe545a52836f8ad1263",
        "products": ["6095abcb45a52836f8ad0b96", "6095ac0145a52836f8ad1a5e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad1262",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Dudu Osun",
            "brand_key": "dudu-osun",
            "createdAt": "2021-05-07T21:06:45.090Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30323
        },
        "createdAt": "2021-05-07T21:06:45.111Z",
        "updatedAt": "2021-05-07T21:09:27.560Z"
    }, {
        "_id": "6095abe545a52836f8ad1265",
        "products": ["6095abcb45a52836f8ad0b97", "6095abcb45a52836f8ad0b98", "6095abcb45a52836f8ad0b99", "6095abcb45a52836f8ad0b9a", "6095abcb45a52836f8ad0b9b", "6095abcb45a52836f8ad0b9c", "6095abcb45a52836f8ad0b9d", "6095abcb45a52836f8ad0b9e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad1264",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "A & M",
            "brand_key": "a-&-m",
            "createdAt": "2021-05-07T21:06:45.176Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30324
        },
        "createdAt": "2021-05-07T21:06:45.201Z",
        "updatedAt": "2021-05-07T21:06:45.201Z"
    }, {
        "_id": "6095abe545a52836f8ad1267",
        "products": ["6095abcb45a52836f8ad0b9f", "6095abcb45a52836f8ad0ba0", "6095abcb45a52836f8ad0ba1", "6095abcb45a52836f8ad0ba2", "6095abcb45a52836f8ad0ba3", "6095abcb45a52836f8ad0ba4", "6095abcb45a52836f8ad0ba5", "6095abcb45a52836f8ad0ba6", "6095abcb45a52836f8ad0ba7", "6095abcb45a52836f8ad0ba8"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad1266",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "A3 Lemon",
            "brand_key": "a3-lemon",
            "createdAt": "2021-05-07T21:06:45.264Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30325
        },
        "createdAt": "2021-05-07T21:06:45.287Z",
        "updatedAt": "2021-05-07T21:06:45.287Z"
    }, {
        "_id": "6095abe545a52836f8ad1269",
        "products": ["6095abcb45a52836f8ad0ba9", "6095abcb45a52836f8ad0baa", "6095abcb45a52836f8ad0bab", "6095abcb45a52836f8ad0bac", "6095abcb45a52836f8ad0bad", "6095abcb45a52836f8ad0bae", "6095abcb45a52836f8ad0baf", "6095abcb45a52836f8ad0bb0", "6095abcb45a52836f8ad0bb1", "6095abcb45a52836f8ad0bb2", "6095abcb45a52836f8ad0bb3", "6095abcb45a52836f8ad0bb4", "6095abcb45a52836f8ad0bb5", "6095abcb45a52836f8ad0bb6", "6095abcb45a52836f8ad0bb7", "6095abcb45a52836f8ad0bb8", "6095abcb45a52836f8ad0bb9", "6095abcb45a52836f8ad0bba", "6095abcb45a52836f8ad0bbb", "6095abcb45a52836f8ad0bbc", "6095abcb45a52836f8ad0bbd", "6095abcb45a52836f8ad0bbe", "6095abcb45a52836f8ad0bbf", "6095abcb45a52836f8ad0bc0", "6095abcb45a52836f8ad0bc1", "6095abcb45a52836f8ad0bc2", "6095abcb45a52836f8ad0bc3", "6095abcb45a52836f8ad0bc4", "6095abcb45a52836f8ad0bc5", "6095abcb45a52836f8ad0bc6", "6095abcb45a52836f8ad0bc7", "6095abcb45a52836f8ad0bc8", "6095abcb45a52836f8ad0bc9", "6095abcb45a52836f8ad0bca", "6095abcb45a52836f8ad0bcb", "6095abcb45a52836f8ad0bcc", "6095abcb45a52836f8ad0bcd", "6095abcb45a52836f8ad0bce", "6095abcb45a52836f8ad0bcf", "6095abcb45a52836f8ad0bd0", "6095abcb45a52836f8ad0bd1", "6095abcb45a52836f8ad0bd2", "6095abcb45a52836f8ad0bd3", "6095abcb45a52836f8ad0bd4", "6095abcb45a52836f8ad0bd5", "6095abcb45a52836f8ad0bd6", "6095abcb45a52836f8ad0bd7", "6095abcb45a52836f8ad0bd8", "6095abcb45a52836f8ad0bd9", "6095abcb45a52836f8ad0bda", "6095abcb45a52836f8ad0bdb", "6095abcb45a52836f8ad0bdc", "6095abcb45a52836f8ad0bdd", "6095abcb45a52836f8ad0bde", "6095abcb45a52836f8ad0bdf", "6095abcb45a52836f8ad0be0", "6095abcb45a52836f8ad0be1", "6095abcb45a52836f8ad0be2", "6095abcb45a52836f8ad0be3", "6095abcb45a52836f8ad0be4", "6095abcb45a52836f8ad0be5", "6095abcb45a52836f8ad0be6", "6095abcb45a52836f8ad0be7", "6095abfe45a52836f8ad19ad"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad1268",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "ABONIKI",
            "brand_key": "ABONIKI",
            "createdAt": "2021-05-07T21:06:45.353Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30326
        },
        "createdAt": "2021-05-07T21:06:45.379Z",
        "updatedAt": "2021-05-07T21:09:26.251Z"
    }, {
        "_id": "6095abe545a52836f8ad1269",
        "products": ["6095abcb45a52836f8ad0ba9", "6095abcb45a52836f8ad0baa", "6095abcb45a52836f8ad0bab", "6095abcb45a52836f8ad0bac", "6095abcb45a52836f8ad0bad", "6095abcb45a52836f8ad0bae", "6095abcb45a52836f8ad0baf", "6095abcb45a52836f8ad0bb0", "6095abcb45a52836f8ad0bb1", "6095abcb45a52836f8ad0bb2", "6095abcb45a52836f8ad0bb3", "6095abcb45a52836f8ad0bb4", "6095abcb45a52836f8ad0bb5", "6095abcb45a52836f8ad0bb6", "6095abcb45a52836f8ad0bb7", "6095abcb45a52836f8ad0bb8", "6095abcb45a52836f8ad0bb9", "6095abcb45a52836f8ad0bba", "6095abcb45a52836f8ad0bbb", "6095abcb45a52836f8ad0bbc", "6095abcb45a52836f8ad0bbd", "6095abcb45a52836f8ad0bbe", "6095abcb45a52836f8ad0bbf", "6095abcb45a52836f8ad0bc0", "6095abcb45a52836f8ad0bc1", "6095abcb45a52836f8ad0bc2", "6095abcb45a52836f8ad0bc3", "6095abcb45a52836f8ad0bc4", "6095abcb45a52836f8ad0bc5", "6095abcb45a52836f8ad0bc6", "6095abcb45a52836f8ad0bc7", "6095abcb45a52836f8ad0bc8", "6095abcb45a52836f8ad0bc9", "6095abcb45a52836f8ad0bca", "6095abcb45a52836f8ad0bcb", "6095abcb45a52836f8ad0bcc", "6095abcb45a52836f8ad0bcd", "6095abcb45a52836f8ad0bce", "6095abcb45a52836f8ad0bcf", "6095abcb45a52836f8ad0bd0", "6095abcb45a52836f8ad0bd1", "6095abcb45a52836f8ad0bd2", "6095abcb45a52836f8ad0bd3", "6095abcb45a52836f8ad0bd4", "6095abcb45a52836f8ad0bd5", "6095abcb45a52836f8ad0bd6", "6095abcb45a52836f8ad0bd7", "6095abcb45a52836f8ad0bd8", "6095abcb45a52836f8ad0bd9", "6095abcb45a52836f8ad0bda", "6095abcb45a52836f8ad0bdb", "6095abcb45a52836f8ad0bdc", "6095abcb45a52836f8ad0bdd", "6095abcb45a52836f8ad0bde", "6095abcb45a52836f8ad0bdf", "6095abcb45a52836f8ad0be0", "6095abcb45a52836f8ad0be1", "6095abcb45a52836f8ad0be2", "6095abcb45a52836f8ad0be3", "6095abcb45a52836f8ad0be4", "6095abcb45a52836f8ad0be5", "6095abcb45a52836f8ad0be6", "6095abcb45a52836f8ad0be7", "6095abfe45a52836f8ad19ad"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad1268",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Adore",
            "brand_key": "adore",
            "createdAt": "2021-05-07T21:06:45.353Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30326
        },
        "createdAt": "2021-05-07T21:06:45.379Z",
        "updatedAt": "2021-05-07T21:09:26.251Z"
    }, {
        "_id": "6095abe545a52836f8ad126b",
        "products": ["6095abcb45a52836f8ad0be8", "6095abcb45a52836f8ad0be9", "6095abcb45a52836f8ad0bea", "6095abcb45a52836f8ad0beb", "6095abcb45a52836f8ad0bec", "6095abcb45a52836f8ad0bed", "6095abcb45a52836f8ad0bee", "6095abcb45a52836f8ad0bef", "6095abcb45a52836f8ad0bf0", "6095abcb45a52836f8ad0bf1", "6095abcb45a52836f8ad0bf2", "6095abcb45a52836f8ad0bf3", "6095abcb45a52836f8ad0bf4", "6095abcb45a52836f8ad0bf5", "6095abcb45a52836f8ad0bf6", "6095abcb45a52836f8ad0bf7", "6095abcb45a52836f8ad0bf8", "6095abcb45a52836f8ad0bf9", "6095abcb45a52836f8ad0bfa", "6095abcb45a52836f8ad0bfb", "6095abcb45a52836f8ad0bfc", "6095abcb45a52836f8ad0bfd", "6095abcb45a52836f8ad0bfe", "6095abcb45a52836f8ad0bff", "6095abcb45a52836f8ad0c00", "6095abcb45a52836f8ad0c01", "6095abcb45a52836f8ad0c02"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad126a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Africa's Best",
            "brand_key": "africa's-best",
            "createdAt": "2021-05-07T21:06:45.444Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30327
        },
        "createdAt": "2021-05-07T21:06:45.469Z",
        "updatedAt": "2021-05-07T21:06:45.469Z"
    }, {
        "_id": "6095abe545a52836f8ad126d",
        "products": ["6095abcb45a52836f8ad0c03", "6095abdf45a52836f8ad106e", "6095abdf45a52836f8ad106f", "6095abdf45a52836f8ad1070", "6095abdf45a52836f8ad1071", "6095abdf45a52836f8ad1072", "6095abec45a52836f8ad14ec", "6095abfa45a52836f8ad1873", "6095abfa45a52836f8ad1874", "6095abfa45a52836f8ad1875", "6095abfa45a52836f8ad1876", "6095abfa45a52836f8ad1877", "6095abfa45a52836f8ad1878", "6095abfa45a52836f8ad1879", "6095abfa45a52836f8ad187a", "6095abfa45a52836f8ad187b", "6095abfa45a52836f8ad187c", "6095abfa45a52836f8ad187d", "6095abfa45a52836f8ad187e", "6095abfa45a52836f8ad187f", "6095abfa45a52836f8ad1880", "6095abfa45a52836f8ad1881", "6095abfa45a52836f8ad1882", "6095abfa45a52836f8ad1883", "6095abfe45a52836f8ad19d9", "6095abfe45a52836f8ad19da", "6095abfe45a52836f8ad1a24"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad126c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Sensationnel",
            "brand_key": "sensationnel",
            "createdAt": "2021-05-07T21:06:45.532Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30328
        },
        "createdAt": "2021-05-07T21:06:45.554Z",
        "updatedAt": "2021-05-07T21:09:18.677Z"
    }, {
        "_id": "6095abe545a52836f8ad126f",
        "products": ["6095abcb45a52836f8ad0c04", "6095abcb45a52836f8ad0c05", "6095abcb45a52836f8ad0c06"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad126e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "African Essence",
            "brand_key": "african-essence",
            "createdAt": "2021-05-07T21:06:45.612Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30329
        },
        "createdAt": "2021-05-07T21:06:45.634Z",
        "updatedAt": "2021-05-07T21:06:45.634Z"
    }, {
        "_id": "6095abe545a52836f8ad1271",
        "products": ["6095abcb45a52836f8ad0c07", "6095abcb45a52836f8ad0c08", "6095abcb45a52836f8ad0c09", "6095abcb45a52836f8ad0c0a", "6095abcb45a52836f8ad0c0b", "6095abcb45a52836f8ad0c0c", "6095abcb45a52836f8ad0c0d", "6095abcb45a52836f8ad0c0e", "6095abcb45a52836f8ad0c0f", "6095abcb45a52836f8ad0c10", "6095abcb45a52836f8ad0c11", "6095abcb45a52836f8ad0c12", "6095abcb45a52836f8ad0c13", "6095abcb45a52836f8ad0c14", "6095abcb45a52836f8ad0c15", "6095abcb45a52836f8ad0c16", "6095abcb45a52836f8ad0c17", "6095abcb45a52836f8ad0c18", "6095abcb45a52836f8ad0c19", "6095abcb45a52836f8ad0c1a", "6095abcb45a52836f8ad0c1b", "6095abcb45a52836f8ad0c1c", "6095abcb45a52836f8ad0c1d", "6095abcb45a52836f8ad0c1e", "6095abcb45a52836f8ad0c1f", "6095abcb45a52836f8ad0c20", "6095abcb45a52836f8ad0c21", "6095abcb45a52836f8ad0c22", "6095abcb45a52836f8ad0c23", "6095abcb45a52836f8ad0c24", "6095abcb45a52836f8ad0c25", "6095abcb45a52836f8ad0c26", "6095abcb45a52836f8ad0c27", "6095abcb45a52836f8ad0c28", "6095abcb45a52836f8ad0c29", "6095abcb45a52836f8ad0c2a", "6095abcb45a52836f8ad0c2b", "6095abcb45a52836f8ad0c2c", "6095abcb45a52836f8ad0c2d", "6095abcb45a52836f8ad0c2e", "6095abcb45a52836f8ad0c35", "6095abcb45a52836f8ad0c36"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad1270",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "African Pride",
            "brand_key": "african-pride",
            "createdAt": "2021-05-07T21:06:45.692Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30330
        },
        "createdAt": "2021-05-07T21:06:45.717Z",
        "updatedAt": "2021-05-07T21:06:45.717Z"
    }, {
        "_id": "6095abe545a52836f8ad1273",
        "products": ["6095abcb45a52836f8ad0c2f", "6095abcb45a52836f8ad0c30", "6095abcb45a52836f8ad0c31", "6095abcb45a52836f8ad0c32", "6095abcb45a52836f8ad0c33", "6095abcb45a52836f8ad0c34", "6095abcb45a52836f8ad0c37", "6095abcb45a52836f8ad0c38", "6095abcb45a52836f8ad0c39", "6095abcb45a52836f8ad0c3a", "6095abcb45a52836f8ad0c3b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad1272",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Dream Kids",
            "brand_key": "dream-kids",
            "createdAt": "2021-05-07T21:06:45.781Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30331
        },
        "createdAt": "2021-05-07T21:06:45.803Z",
        "updatedAt": "2021-05-07T21:06:45.803Z"
    }, {
        "_id": "6095abe545a52836f8ad1275",
        "products": ["6095abcb45a52836f8ad0c3c", "6095abcb45a52836f8ad0c3d", "6095abcb45a52836f8ad0c3e", "6095abcb45a52836f8ad0c3f", "6095abcb45a52836f8ad0c40", "6095abcb45a52836f8ad0c41", "6095abcb45a52836f8ad0c42", "6095abcb45a52836f8ad0c43", "6095abcb45a52836f8ad0c44", "6095abcb45a52836f8ad0c45"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad1274",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Afro & Rizo",
            "brand_key": "afro-&-rizo",
            "createdAt": "2021-05-07T21:06:45.859Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30332
        },
        "createdAt": "2021-05-07T21:06:45.880Z",
        "updatedAt": "2021-05-07T21:06:45.880Z"
    }, {
        "_id": "6095abe545a52836f8ad1277",
        "products": ["6095abcb45a52836f8ad0c46", "6095abcb45a52836f8ad0c47", "6095abcb45a52836f8ad0c48", "6095abcb45a52836f8ad0c49", "6095abcb45a52836f8ad0c4a", "6095abcb45a52836f8ad0c4b", "6095abcb45a52836f8ad0c4c", "6095abcb45a52836f8ad0c4d", "6095abcb45a52836f8ad0c4e", "6095abcb45a52836f8ad0c4f", "6095abcb45a52836f8ad0c50", "6095abcb45a52836f8ad0c51", "6095abcb45a52836f8ad0c52", "6095abcb45a52836f8ad0c53"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe545a52836f8ad1276",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Afro Love",
            "brand_key": "afro-love",
            "createdAt": "2021-05-07T21:06:45.937Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30333
        },
        "createdAt": "2021-05-07T21:06:45.959Z",
        "updatedAt": "2021-05-07T21:06:45.959Z"
    }, {
        "_id": "6095abe645a52836f8ad1279",
        "products": ["6095abcb45a52836f8ad0c54", "6095abcb45a52836f8ad0c55", "6095abcb45a52836f8ad0c56", "6095abcb45a52836f8ad0c57", "6095abcb45a52836f8ad0c58", "6095abcb45a52836f8ad0c59", "6095abcb45a52836f8ad0c5a", "6095abcb45a52836f8ad0c5b", "6095abcb45a52836f8ad0c5c", "6095abcb45a52836f8ad0c5d", "6095abcb45a52836f8ad0c5e", "6095abcb45a52836f8ad0c5f", "6095abcb45a52836f8ad0c60", "6095abcb45a52836f8ad0c61", "6095abcb45a52836f8ad0c62", "6095abcb45a52836f8ad0c63", "6095abcb45a52836f8ad0c64", "6095abcb45a52836f8ad0c65", "6095abcb45a52836f8ad0c66", "6095abcb45a52836f8ad0c67", "6095abcb45a52836f8ad0c68", "6095abcb45a52836f8ad0c69", "6095abcb45a52836f8ad0c6a"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad1278",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Agadir Argan Oil",
            "brand_key": "agadir-argan-oil",
            "createdAt": "2021-05-07T21:06:46.019Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30334
        },
        "createdAt": "2021-05-07T21:06:46.042Z",
        "updatedAt": "2021-05-07T21:06:46.042Z"
    }, {
        "_id": "6095abe645a52836f8ad127b",
        "products": ["6095abcb45a52836f8ad0c6b", "6095abcb45a52836f8ad0c6c", "6095abcb45a52836f8ad0c6d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad127a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Alaffia",
            "brand_key": "Alaffia",
            "createdAt": "2021-05-07T21:06:46.104Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30335
        },
        "createdAt": "2021-05-07T21:06:46.126Z",
        "updatedAt": "2021-05-07T21:06:46.126Z"
    }, {
        "_id": "6095abe645a52836f8ad127b",
        "products": ["6095abcb45a52836f8ad0c6b", "6095abcb45a52836f8ad0c6c", "6095abcb45a52836f8ad0c6d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad127a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Alcolado",
            "brand_key": "alcolado",
            "createdAt": "2021-05-07T21:06:46.104Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30335
        },
        "createdAt": "2021-05-07T21:06:46.126Z",
        "updatedAt": "2021-05-07T21:06:46.126Z"
    }, {
        "_id": "6095abe645a52836f8ad127d",
        "products": ["6095abcb45a52836f8ad0c6e", "6095abcb45a52836f8ad0c6f", "6095abcb45a52836f8ad0c70", "6095abcb45a52836f8ad0c71", "6095abcb45a52836f8ad0c72", "6095abcb45a52836f8ad0c73", "6095abcb45a52836f8ad0c74", "6095abcb45a52836f8ad0c75", "6095abcb45a52836f8ad0c76", "6095abcb45a52836f8ad0c77"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad127c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Alikay Naturals",
            "brand_key": "alikay-naturals",
            "createdAt": "2021-05-07T21:06:46.186Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30336
        },
        "createdAt": "2021-05-07T21:06:46.208Z",
        "updatedAt": "2021-05-07T21:06:46.208Z"
    },
             {
        "_id": "6095abe645a52836f8ad127d",
        "products": ["6095abcb45a52836f8ad0c6e", "6095abcb45a52836f8ad0c6f", "6095abcb45a52836f8ad0c70", "6095abcb45a52836f8ad0c71", "6095abcb45a52836f8ad0c72", "6095abcb45a52836f8ad0c73", "6095abcb45a52836f8ad0c74", "6095abcb45a52836f8ad0c75", "6095abcb45a52836f8ad0c76", "6095abcb45a52836f8ad0c77"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad127c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Albaso",
            "brand_key": "albaso",
            "createdAt": "2021-05-07T21:06:46.186Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30336
        },
        "createdAt": "2021-05-07T21:06:46.208Z",
        "updatedAt": "2021-05-07T21:06:46.208Z"
    },{
        "_id": "6095abe645a52836f8ad127f",
        "products": ["6095abcb45a52836f8ad0c78", "6095abcb45a52836f8ad0c79"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad127e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Ambi",
            "brand_key": "ambi",
            "createdAt": "2021-05-07T21:06:46.268Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30337
        },
        "createdAt": "2021-05-07T21:06:46.292Z",
        "updatedAt": "2021-05-07T21:06:46.292Z"
    }, {
        "_id": "6095abe645a52836f8ad1281",
        "products": ["6095abcb45a52836f8ad0c7a", "6095abcb45a52836f8ad0c7b", "6095abcf45a52836f8ad0c7c", "6095abcf45a52836f8ad0c7d", "6095abcf45a52836f8ad0c7e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad1280",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "American Crew",
            "brand_key": "american-crew",
            "createdAt": "2021-05-07T21:06:46.353Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30338
        },
        "createdAt": "2021-05-07T21:06:46.375Z",
        "updatedAt": "2021-05-07T21:06:46.375Z"
    }, {
        "_id": "6095abe645a52836f8ad1283",
        "products": ["6095abcf45a52836f8ad0c7f", "6095abcf45a52836f8ad0c80"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad1282",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Ampro",
            "brand_key": "ampro",
            "createdAt": "2021-05-07T21:06:46.436Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30339
        },
        "createdAt": "2021-05-07T21:06:46.459Z",
        "updatedAt": "2021-05-07T21:06:46.459Z"
    }, {
        "_id": "6095abe645a52836f8ad1285",
        "products": ["6095abcf45a52836f8ad0c81", "6095abcf45a52836f8ad0c82", "6095abcf45a52836f8ad0c83", "6095abcf45a52836f8ad0c84", "6095abcf45a52836f8ad0c85", "6095abcf45a52836f8ad0c86"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad1284",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Andis",
            "brand_key": "andis",
            "createdAt": "2021-05-07T21:06:46.520Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30340
        },
        "createdAt": "2021-05-07T21:06:46.543Z",
        "updatedAt": "2021-05-07T21:06:46.543Z"
    }, {
        "_id": "6095abe645a52836f8ad1287",
        "products": ["6095abcf45a52836f8ad0c88", "6095abcf45a52836f8ad0c89"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad1286",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Annie",
            "brand_key": "annie",
            "createdAt": "2021-05-07T21:06:46.605Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30341
        },
        "createdAt": "2021-05-07T21:06:46.627Z",
        "updatedAt": "2021-05-07T21:06:46.627Z"
    }, {
        "_id": "6095abe645a52836f8ad1289",
        "products": ["6095abcf45a52836f8ad0c8a", "6095abcf45a52836f8ad0c8b", "6095abcf45a52836f8ad0c8c", "6095abcf45a52836f8ad0c8d", "6095abcf45a52836f8ad0c8e", "6095abcf45a52836f8ad0c8f", "6095abcf45a52836f8ad0c90", "6095abcf45a52836f8ad0c91", "6095abcf45a52836f8ad0c92", "6095abcf45a52836f8ad0c93", "6095abcf45a52836f8ad0c94", "6095abcf45a52836f8ad0c95", "6095abcf45a52836f8ad0c96", "6095abcf45a52836f8ad0c97", "6095abcf45a52836f8ad0c98", "6095abcf45a52836f8ad0c99", "6095abcf45a52836f8ad0c9a", "6095abcf45a52836f8ad0c9b", "6095abcf45a52836f8ad0c9c", "6095abcf45a52836f8ad0c9d", "6095abcf45a52836f8ad0c9e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad1288",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "ApHogee",
            "brand_key": "aphogee",
            "createdAt": "2021-05-07T21:06:46.687Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30342
        },
        "createdAt": "2021-05-07T21:06:46.711Z",
        "updatedAt": "2021-05-07T21:06:46.711Z"
    }, {
        "_id": "6095abe645a52836f8ad128b",
        "products": ["6095abcf45a52836f8ad0c9f"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad128a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Argan Smooth",
            "brand_key": "argan-smooth",
            "createdAt": "2021-05-07T21:06:46.772Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30343
        },
        "createdAt": "2021-05-07T21:06:46.795Z",
        "updatedAt": "2021-05-07T21:06:46.795Z"
    }, {
        "_id": "6095abe645a52836f8ad128d",
        "products": ["6095abcf45a52836f8ad0ca1", "6095abcf45a52836f8ad0ca2", "6095abcf45a52836f8ad0ca3", "6095abcf45a52836f8ad0ca4", "6095abcf45a52836f8ad0ca5", "6095abcf45a52836f8ad0ca6", "6095abcf45a52836f8ad0ca7", "6095abcf45a52836f8ad0ca8", "6095abcf45a52836f8ad0ca9", "6095abcf45a52836f8ad0caa", "6095abcf45a52836f8ad0cab", "6095abcf45a52836f8ad0cac", "6095abcf45a52836f8ad0cad", "6095abcf45a52836f8ad0cae", "6095abcf45a52836f8ad0caf", "6095abcf45a52836f8ad0cb0", "6095abcf45a52836f8ad0cb1", "6095abcf45a52836f8ad0cb2", "6095abcf45a52836f8ad0cb3", "6095abcf45a52836f8ad0cb4", "6095abcf45a52836f8ad0cb5", "6095abcf45a52836f8ad0cb6", "6095abcf45a52836f8ad0cb7", "6095abcf45a52836f8ad0cb8", "6095abcf45a52836f8ad0cb9", "6095abcf45a52836f8ad0cba", "6095abcf45a52836f8ad0cbb", "6095abcf45a52836f8ad0cbc", "6095abcf45a52836f8ad0cbd", "6095abcf45a52836f8ad0cbe", "6095abcf45a52836f8ad0cbf", "6095abcf45a52836f8ad0cc0", "6095abcf45a52836f8ad0cc1", "6095abcf45a52836f8ad0cc2", "6095abcf45a52836f8ad0cc3", "6095abcf45a52836f8ad0cc4", "6095abcf45a52836f8ad0cc5", "6095abcf45a52836f8ad0cc6", "6095abcf45a52836f8ad0cc7", "6095abcf45a52836f8ad0cc8", "6095abcf45a52836f8ad0cc9", "6095abcf45a52836f8ad0cca"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad128c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "As I Am",
            "brand_key": "as-i-am",
            "createdAt": "2021-05-07T21:06:46.854Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30344
        },
        "createdAt": "2021-05-07T21:06:46.877Z",
        "updatedAt": "2021-05-07T21:06:46.877Z"
    }, {
        "_id": "6095abe645a52836f8ad128f",
        "products": ["6095abcf45a52836f8ad0ccb", "6095abcf45a52836f8ad0ccc", "6095abcf45a52836f8ad0ccd"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe645a52836f8ad128e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Astral",
            "brand_key": "astral",
            "createdAt": "2021-05-07T21:06:46.944Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30345
        },
        "createdAt": "2021-05-07T21:06:46.971Z",
        "updatedAt": "2021-05-07T21:06:46.971Z"
    }, {
        "_id": "6095abe745a52836f8ad1291",
        "products": ["6095abcf45a52836f8ad0cce", "6095abcf45a52836f8ad0ccf"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe745a52836f8ad1290",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "At One",
            "brand_key": "at-one",
            "createdAt": "2021-05-07T21:06:47.029Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30346
        },
        "createdAt": "2021-05-07T21:06:47.050Z",
        "updatedAt": "2021-05-07T21:06:47.050Z"
    }, {
        "_id": "6095abe745a52836f8ad1293",
        "products": ["6095abcf45a52836f8ad0cd0", "6095abcf45a52836f8ad0cd1", "6095abcf45a52836f8ad0cd2", "6095abcf45a52836f8ad0cd3", "6095abcf45a52836f8ad0cd4", "6095abcf45a52836f8ad0cd5", "6095abcf45a52836f8ad0cd6", "6095abcf45a52836f8ad0cd7", "6095abcf45a52836f8ad0cd8", "6095abcf45a52836f8ad0cd9", "6095abcf45a52836f8ad0cda", "6095abcf45a52836f8ad0cdb", "6095abcf45a52836f8ad0cdc", "6095abcf45a52836f8ad0cdd", "6095abcf45a52836f8ad0cde", "6095abcf45a52836f8ad0cdf", "6095abcf45a52836f8ad0ce0", "6095abcf45a52836f8ad0ce1", "6095abcf45a52836f8ad0ce2", "6095abcf45a52836f8ad0ce3", "6095abcf45a52836f8ad0ce4", "6095abcf45a52836f8ad0ce5", "6095abcf45a52836f8ad0ce6", "6095abcf45a52836f8ad0ce7", "6095abcf45a52836f8ad0ce8", "6095abcf45a52836f8ad0ce9", "6095abcf45a52836f8ad0cea", "6095abcf45a52836f8ad0ceb", "6095abcf45a52836f8ad0cec", "6095abcf45a52836f8ad0ced", "6095abcf45a52836f8ad0cee", "6095abcf45a52836f8ad0cef"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe745a52836f8ad1292",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Aunt Jackie's",
            "brand_key": "aunt-jackie's",
            "createdAt": "2021-05-07T21:06:47.108Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30347
        },
        "createdAt": "2021-05-07T21:06:47.133Z",
        "updatedAt": "2021-05-07T21:06:47.133Z"
    }, {
        "_id": "6095abe745a52836f8ad1295",
        "products": ["6095abcf45a52836f8ad0cf0", "6095abcf45a52836f8ad0cf1"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe745a52836f8ad1294",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Aveeno",
            "brand_key": "aveeno",
            "createdAt": "2021-05-07T21:06:47.193Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30348
        },
        "createdAt": "2021-05-07T21:06:47.214Z",
        "updatedAt": "2021-05-07T21:06:47.214Z"
    }, {
        "_id": "6095abe745a52836f8ad1297",
        "products": ["6095abcf45a52836f8ad0cf2"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe745a52836f8ad1296",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Aztec Secret",
            "brand_key": "aztec-secret",
            "createdAt": "2021-05-07T21:06:47.274Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30349
        },
        "createdAt": "2021-05-07T21:06:47.296Z",
        "updatedAt": "2021-05-07T21:06:47.296Z"
    }, {
        "_id": "6095abe745a52836f8ad1299",
        "products": ["6095abcf45a52836f8ad0cf3"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe745a52836f8ad1298",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Barbicide",
            "brand_key": "barbicide",
            "createdAt": "2021-05-07T21:06:47.355Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30350
        },
        "createdAt": "2021-05-07T21:06:47.377Z",
        "updatedAt": "2021-05-07T21:06:47.377Z"
    }, {
        "_id": "6095abe745a52836f8ad129b",
        "products": ["6095abcf45a52836f8ad0cf4", "6095abcf45a52836f8ad0cf5", "6095abcf45a52836f8ad0cf6", "6095abcf45a52836f8ad0cf7", "6095abcf45a52836f8ad0cf8", "6095abcf45a52836f8ad0cf9", "6095abcf45a52836f8ad0cfa", "6095abcf45a52836f8ad0cfb", "6095abcf45a52836f8ad0cfc"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe745a52836f8ad129a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "BB",
            "brand_key": "bb",
            "createdAt": "2021-05-07T21:06:47.435Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30351
        },
        "createdAt": "2021-05-07T21:06:47.455Z",
        "updatedAt": "2021-05-07T21:06:47.455Z"
    }, {
        "_id": "6095abe745a52836f8ad129d",
        "products": ["6095abcf45a52836f8ad0cfd", "6095abcf45a52836f8ad0cfe", "6095abcf45a52836f8ad0cff", "6095abcf45a52836f8ad0d00", "6095abcf45a52836f8ad0d01", "6095abcf45a52836f8ad0d02"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe745a52836f8ad129c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Beautiful Beginnings",
            "brand_key": "beautiful-beginnings",
            "createdAt": "2021-05-07T21:06:47.516Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30352
        },
        "createdAt": "2021-05-07T21:06:47.539Z",
        "updatedAt": "2021-05-07T21:06:47.539Z"
    }, {
        "_id": "6095abe745a52836f8ad129f",
        "products": ["6095abcf45a52836f8ad0d03", "6095abcf45a52836f8ad0d04", "6095abcf45a52836f8ad0d05", "6095abcf45a52836f8ad0d06", "6095abcf45a52836f8ad0d07", "6095abcf45a52836f8ad0d08", "6095abcf45a52836f8ad0d09", "6095abcf45a52836f8ad0d0a", "6095abcf45a52836f8ad0d0b", "6095abcf45a52836f8ad0d0c", "6095abcf45a52836f8ad0d0d", "6095abcf45a52836f8ad0d0e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe745a52836f8ad129e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Beautiful Textures",
            "brand_key": "beautiful-textures",
            "createdAt": "2021-05-07T21:06:47.600Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30353
        },
        "createdAt": "2021-05-07T21:06:47.623Z",
        "updatedAt": "2021-05-07T21:06:47.623Z"
    }, {
        "_id": "6095abe745a52836f8ad12a1",
        "products": ["6095abcf45a52836f8ad0d0f", "6095abcf45a52836f8ad0d10"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe745a52836f8ad12a0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Bel Dam",
            "brand_key": "bel-dam",
            "createdAt": "2021-05-07T21:06:47.684Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30354
        },
        "createdAt": "2021-05-07T21:06:47.714Z",
        "updatedAt": "2021-05-07T21:06:47.714Z"
    },{
        "_id": "6095abe745a52836f8ad12a1",
        "products": ["6095abcf45a52836f8ad0d0f", "6095abcf45a52836f8ad0d10"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe745a52836f8ad12a0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Bella Curls",
            "brand_key": "bella-curls",
            "createdAt": "2021-05-07T21:06:47.684Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30354
        },
        "createdAt": "2021-05-07T21:06:47.714Z",
        "updatedAt": "2021-05-07T21:06:47.714Z"
    },
             {
        "_id": "6095abe745a52836f8ad12a3",
        "products": ["6095abcf45a52836f8ad0d11"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe745a52836f8ad12a2",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Betty Hutton",
            "brand_key": "betty-hutton",
            "createdAt": "2021-05-07T21:06:47.774Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30355
        },
        "createdAt": "2021-05-07T21:06:47.795Z",
        "updatedAt": "2021-05-07T21:06:47.795Z"
    }, {
        "_id": "6095abe745a52836f8ad12a5",
        "products": ["6095abcf45a52836f8ad0d13", "6095abcf45a52836f8ad0d14", "6095abcf45a52836f8ad0d15", "6095abcf45a52836f8ad0d16", "6095abcf45a52836f8ad0d17", "6095abcf45a52836f8ad0d18", "6095abcf45a52836f8ad0d19", "6095abcf45a52836f8ad0d1a", "6095abcf45a52836f8ad0d1b", "6095abcf45a52836f8ad0d1c", "6095abcf45a52836f8ad0d1d", "6095abcf45a52836f8ad0d1e", "6095abcf45a52836f8ad0d1f", "6095abcf45a52836f8ad0d20", "6095abcf45a52836f8ad0d21", "6095abcf45a52836f8ad0d22", "6095abcf45a52836f8ad0d23", "6095abcf45a52836f8ad0d24"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe745a52836f8ad12a4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Bigen",
            "brand_key": "bigen",
            "createdAt": "2021-05-07T21:06:47.854Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30356
        },
        "createdAt": "2021-05-07T21:06:47.877Z",
        "updatedAt": "2021-05-07T21:06:47.877Z"
    }, {
        "_id": "6095abe745a52836f8ad12a7",
        "products": ["6095abcf45a52836f8ad0d25", "6095abcf45a52836f8ad0d26"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe745a52836f8ad12a6",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Bio Oil",
            "brand_key": "bio-oil",
            "createdAt": "2021-05-07T21:06:47.937Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30357
        },
        "createdAt": "2021-05-07T21:06:47.959Z",
        "updatedAt": "2021-05-07T21:06:47.959Z"
    }, {
        "_id": "6095abe845a52836f8ad12a9",
        "products": ["6095abcf45a52836f8ad0d27", "6095abcf45a52836f8ad0d28"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe845a52836f8ad12a8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Biosilk",
            "brand_key": "biosilk",
            "createdAt": "2021-05-07T21:06:48.020Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30358
        },
        "createdAt": "2021-05-07T21:06:48.042Z",
        "updatedAt": "2021-05-07T21:06:48.042Z"
    }, {
        "_id": "6095abe845a52836f8ad12ab",
        "products": ["6095abcf45a52836f8ad0d29"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe845a52836f8ad12aa",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Black & Red",
            "brand_key": "black-&-red",
            "createdAt": "2021-05-07T21:06:48.100Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30359
        },
        "createdAt": "2021-05-07T21:06:48.122Z",
        "updatedAt": "2021-05-07T21:06:48.122Z"
    }, {
        "_id": "6095abe845a52836f8ad12ad",
        "products": ["6095abcf45a52836f8ad0d2a"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe845a52836f8ad12ac",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Black & White",
            "brand_key": "black-&-white",
            "createdAt": "2021-05-07T21:06:48.180Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30360
        },
        "createdAt": "2021-05-07T21:06:48.201Z",
        "updatedAt": "2021-05-07T21:06:48.201Z"
    }, {
        "_id": "6095abe845a52836f8ad12af",
        "products": ["6095abcf45a52836f8ad0d2b", "6095abcf45a52836f8ad0d2c", "6095abcf45a52836f8ad0d2d", "6095abcf45a52836f8ad0d2e", "6095abcf45a52836f8ad0d2f", "6095abcf45a52836f8ad0d30", "6095abcf45a52836f8ad0d31", "6095abcf45a52836f8ad0d32", "6095abcf45a52836f8ad0d33", "6095abcf45a52836f8ad0d34", "6095abcf45a52836f8ad0d35", "6095abcf45a52836f8ad0d36", "6095abcf45a52836f8ad0d37", "6095abcf45a52836f8ad0d38", "6095abcf45a52836f8ad0d39", "6095abcf45a52836f8ad0d3a", "6095abcf45a52836f8ad0d3b", "6095abcf45a52836f8ad0d3c", "6095abcf45a52836f8ad0d3d", "6095abcf45a52836f8ad0d3e", "6095abcf45a52836f8ad0d3f", "6095abcf45a52836f8ad0d40", "6095abcf45a52836f8ad0d41", "6095abcf45a52836f8ad0d42", "6095abcf45a52836f8ad0d43", "6095abcf45a52836f8ad0d44", "6095abcf45a52836f8ad0d45", "6095abcf45a52836f8ad0d46", "6095abcf45a52836f8ad0d47", "6095abcf45a52836f8ad0d48", "6095abcf45a52836f8ad0d49", "6095abcf45a52836f8ad0d4a", "6095abcf45a52836f8ad0d4b", "6095abcf45a52836f8ad0d4c", "6095abcf45a52836f8ad0d4d", "6095abcf45a52836f8ad0d4e", "6095abcf45a52836f8ad0d4f", "6095abcf45a52836f8ad0d50", "6095abcf45a52836f8ad0d51", "6095abcf45a52836f8ad0d52", "6095abcf45a52836f8ad0d53", "6095abcf45a52836f8ad0d54", "6095abcf45a52836f8ad0d55", "6095abcf45a52836f8ad0d56", "6095abcf45a52836f8ad0d57", "6095abcf45a52836f8ad0d58", "6095abcf45a52836f8ad0d59", "6095abcf45a52836f8ad0d5a", "6095abcf45a52836f8ad0d5b", "6095abcf45a52836f8ad0d5c", "6095abcf45a52836f8ad0d5d", "6095abcf45a52836f8ad0d5e", "6095abcf45a52836f8ad0d5f", "6095abcf45a52836f8ad0d60", "6095abcf45a52836f8ad0d61", "6095abcf45a52836f8ad0d62", "6095abcf45a52836f8ad0d63", "6095abcf45a52836f8ad0d64", "6095abcf45a52836f8ad0d65", "6095abcf45a52836f8ad0d66", "6095abcf45a52836f8ad0d67", "6095abcf45a52836f8ad0d68"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe845a52836f8ad12ae",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Black Opal",
            "brand_key": "black-opal",
            "createdAt": "2021-05-07T21:06:48.260Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30361
        },
        "createdAt": "2021-05-07T21:06:48.283Z",
        "updatedAt": "2021-05-07T21:06:48.283Z"
    }, {
        "_id": "6095abe845a52836f8ad12b1",
        "products": ["6095abcf45a52836f8ad0d69"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe845a52836f8ad12b0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Black Rose",
            "brand_key": "black-rose",
            "createdAt": "2021-05-07T21:06:48.342Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30362
        },
        "createdAt": "2021-05-07T21:06:48.364Z",
        "updatedAt": "2021-05-07T21:06:48.364Z"
    }, {
        "_id": "6095abe845a52836f8ad12b3",
        "products": ["6095abcf45a52836f8ad0d6a"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe845a52836f8ad12b2",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Blue Drops",
            "brand_key": "blue-drops",
            "createdAt": "2021-05-07T21:06:48.422Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30363
        },
        "createdAt": "2021-05-07T21:06:48.445Z",
        "updatedAt": "2021-05-07T21:06:48.445Z"
    }, {
        "_id": "6095abe845a52836f8ad13af",
        "products": ["6095abcf45a52836f8ad0d6b", "6095abcf45a52836f8ad0d6c", "6095abcf45a52836f8ad0d6d", "6095abcf45a52836f8ad0d6e", "6095abcf45a52836f8ad0d6f", "6095abcf45a52836f8ad0d70", "6095abcf45a52836f8ad0d71", "6095abcf45a52836f8ad0d72", "6095abcf45a52836f8ad0d73", "6095abcf45a52836f8ad0d74", "6095abcf45a52836f8ad0d75"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe845a52836f8ad13ae",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Blue Magic",
            "brand_key": "blue-magic",
            "createdAt": "2021-05-07T21:06:48.728Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30364
        },
        "createdAt": "2021-05-07T21:06:48.751Z",
        "updatedAt": "2021-05-07T21:06:48.751Z"
    }, {
        "_id": "6095abe845a52836f8ad13b1",
        "products": ["6095abd345a52836f8ad0d76"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe845a52836f8ad13b0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Bold Hold",
            "brand_key": "bold-hold",
            "createdAt": "2021-05-07T21:06:48.832Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30365
        },
        "createdAt": "2021-05-07T21:06:48.853Z",
        "updatedAt": "2021-05-07T21:06:48.853Z"
    }, {
        "_id": "6095abe845a52836f8ad13b3",
        "products": ["6095abd345a52836f8ad0d77"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe845a52836f8ad13b2",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Bonfi Natural",
            "brand_key": "bonfi-natural",
            "createdAt": "2021-05-07T21:06:48.914Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30366
        },
        "createdAt": "2021-05-07T21:06:48.936Z",
        "updatedAt": "2021-05-07T21:06:48.936Z"
    }, {
        "_id": "6095abe945a52836f8ad13b5",
        "products": ["6095abd345a52836f8ad0d78", "6095abd345a52836f8ad0d79", "6095abd345a52836f8ad0d7a", "6095abd345a52836f8ad0d7b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe845a52836f8ad13b4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "BonHair",
            "brand_key": "bonhair",
            "createdAt": "2021-05-07T21:06:48.996Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30367
        },
        "createdAt": "2021-05-07T21:06:49.022Z",
        "updatedAt": "2021-05-07T21:06:49.022Z"
    }, {
        "_id": "6095abe945a52836f8ad13b7",
        "products": ["6095abd345a52836f8ad0d7c", "6095abd345a52836f8ad0d7d", "6095abd345a52836f8ad0d7e", "6095abd345a52836f8ad0d7f", "6095abd345a52836f8ad0d80", "6095abd345a52836f8ad0d81", "6095abd345a52836f8ad0d82"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe945a52836f8ad13b6",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Botanicals",
            "brand_key": "botanicals",
            "createdAt": "2021-05-07T21:06:49.080Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30368
        },
        "createdAt": "2021-05-07T21:06:49.103Z",
        "updatedAt": "2021-05-07T21:06:49.103Z"
    }, {
        "_id": "6095abe945a52836f8ad13b9",
        "products": ["6095abd345a52836f8ad0d83", "6095abd345a52836f8ad0d84", "6095abd345a52836f8ad0d85", "6095abd345a52836f8ad0d86", "6095abd345a52836f8ad0d87", "6095abd345a52836f8ad0d88"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe945a52836f8ad13b8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Boucleme",
            "brand_key": "boucleme",
            "createdAt": "2021-05-07T21:06:49.162Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30369
        },
        "createdAt": "2021-05-07T21:06:49.183Z",
        "updatedAt": "2021-05-07T21:06:49.183Z"
    }, {
        "_id": "6095abe945a52836f8ad13bb",
        "products": ["6095abd345a52836f8ad0d89", "6095abd345a52836f8ad0d8a", "6095abd345a52836f8ad0d8b", "6095abd345a52836f8ad0d8c", "6095abd345a52836f8ad0d8d", "6095abd345a52836f8ad0d8e", "6095abd345a52836f8ad0d8f", "6095abd345a52836f8ad0d90", "6095abd345a52836f8ad0d91", "6095abd345a52836f8ad0d92", "6095abd345a52836f8ad0d93", "6095abd345a52836f8ad0d94", "6095abd345a52836f8ad0d95"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe945a52836f8ad13ba",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Bounce curl",
            "brand_key": "bounce-curl",
            "createdAt": "2021-05-07T21:06:49.244Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30370
        },
        "createdAt": "2021-05-07T21:06:49.268Z",
        "updatedAt": "2021-05-07T21:06:49.268Z"
    }, {
        "_id": "6095abe945a52836f8ad13bd",
        "products": ["6095abd345a52836f8ad0d96", "6095abd345a52836f8ad0d97"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe945a52836f8ad13bc",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Bragg",
            "brand_key": "bragg",
            "createdAt": "2021-05-07T21:06:49.331Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30371
        },
        "createdAt": "2021-05-07T21:06:49.351Z",
        "updatedAt": "2021-05-07T21:06:49.351Z"
    }, {
        "_id": "6095abe945a52836f8ad13bf",
        "products": ["6095abd345a52836f8ad0d9b", "6095abd345a52836f8ad0d9c", "6095abd345a52836f8ad0d9d", "6095abd345a52836f8ad0d9e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe945a52836f8ad13be",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Bump Patrol",
            "brand_key": "bump-patrol",
            "createdAt": "2021-05-07T21:06:49.408Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30372
        },
        "createdAt": "2021-05-07T21:06:49.429Z",
        "updatedAt": "2021-05-07T21:06:49.429Z"
    }, {
        "_id": "6095abe945a52836f8ad13c1",
        "products": ["6095abd345a52836f8ad0d9f", "6095abd345a52836f8ad0da0", "6095abd345a52836f8ad0da1", "6095abd345a52836f8ad0da2", "6095abd345a52836f8ad0da3", "6095abd345a52836f8ad0da4", "6095abd345a52836f8ad0da5", "6095abd345a52836f8ad0da6", "6095abd345a52836f8ad0da7", "6095abd345a52836f8ad0da8", "6095abd345a52836f8ad0da9", "6095abd345a52836f8ad0daa", "6095abd345a52836f8ad0dab", "6095abd345a52836f8ad0dac", "6095abd345a52836f8ad0dad", "6095abd345a52836f8ad0dae", "6095abd345a52836f8ad0daf", "6095abd345a52836f8ad0db0", "6095abd345a52836f8ad0db1", "6095abd345a52836f8ad0db2", "6095abd345a52836f8ad0db3", "6095abd345a52836f8ad0db4", "6095abd345a52836f8ad0db5", "6095abd345a52836f8ad0db6", "6095abd345a52836f8ad0db7", "6095abd345a52836f8ad0db8", "6095abd345a52836f8ad0db9"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe945a52836f8ad13c0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Camille Rose",
            "brand_key": "camille-rose",
            "createdAt": "2021-05-07T21:06:49.487Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30373
        },
        "createdAt": "2021-05-07T21:06:49.509Z",
        "updatedAt": "2021-05-07T21:06:49.509Z"
    }, {
        "_id": "6095abe945a52836f8ad13c3",
        "products": ["6095abd345a52836f8ad0dba", "6095abd345a52836f8ad0dbb", "6095abd345a52836f8ad0dbc", "6095abd345a52836f8ad0dbd", "6095abd345a52836f8ad0dbe", "6095abd345a52836f8ad0dbf", "6095abd345a52836f8ad0dc0", "6095abd345a52836f8ad0dc1", "6095abd345a52836f8ad0dc2", "6095abd345a52836f8ad0dc3", "6095abd345a52836f8ad0dc4", "6095abd345a52836f8ad0dc5", "6095abd345a52836f8ad0dc6", "6095abd345a52836f8ad0dc7", "6095abd345a52836f8ad0dc8", "6095abd345a52836f8ad0dc9", "6095abd345a52836f8ad0dca", "6095abd345a52836f8ad0dcb", "6095abd345a52836f8ad0dcc", "6095abd345a52836f8ad0dcd", "6095abd345a52836f8ad0dce", "6095abd345a52836f8ad0dcf", "6095abd345a52836f8ad0dd0", "6095abd345a52836f8ad0dd1", "6095abd345a52836f8ad0dd2", "6095abd345a52836f8ad0dd3", "6095abd345a52836f8ad0dd4", "6095abd345a52836f8ad0dd5", "6095abd345a52836f8ad0dd6", "6095abd345a52836f8ad0dd7", "6095abd345a52836f8ad0dd8", "6095abd345a52836f8ad0dd9", "6095abd345a52836f8ad0dda", "6095abd345a52836f8ad0ddb", "6095abd345a52836f8ad0ddc", "6095abd345a52836f8ad0ddd", "6095abd345a52836f8ad0dde", "6095abd345a52836f8ad0ddf", "6095abd345a52836f8ad0de0", "6095abd345a52836f8ad0de1", "6095abd345a52836f8ad0de2", "6095abd345a52836f8ad0de3", "6095abd345a52836f8ad0de4", "6095abd345a52836f8ad0de5", "6095abd345a52836f8ad0de6", "6095abd345a52836f8ad0de7", "6095abd345a52836f8ad0de8", "6095abd345a52836f8ad0de9", "6095abd345a52836f8ad0dea", "6095abd345a52836f8ad0deb", "6095abd345a52836f8ad0dec", "6095abd345a52836f8ad0ded", "6095abd345a52836f8ad0dee", "6095abd345a52836f8ad0def", "6095abd345a52836f8ad0df0", "6095abd345a52836f8ad0df1", "6095abd345a52836f8ad0df2", "6095abd345a52836f8ad0df3", "6095abd345a52836f8ad0df4", "6095abd345a52836f8ad0df5", "6095abd345a52836f8ad0df6", "6095abd345a52836f8ad0df7", "6095abd345a52836f8ad0df8", "6095abd345a52836f8ad0df9", "6095abd345a52836f8ad0dfa", "6095abd345a52836f8ad0dfb", "6095abd345a52836f8ad0dfc", "6095abd345a52836f8ad0dfd", "6095abd345a52836f8ad0dfe", "6095abd345a52836f8ad0dff", "6095abd345a52836f8ad0e00", "6095abd345a52836f8ad0e01", "6095abd345a52836f8ad0e02", "6095abd345a52836f8ad0e03", "6095abd345a52836f8ad0e04", "6095abd345a52836f8ad0e05", "6095abd345a52836f8ad0e06", "6095abd345a52836f8ad0e07", "6095abd345a52836f8ad0e08", "6095abd345a52836f8ad0e09", "6095abd345a52836f8ad0e0a", "6095abd345a52836f8ad0e0b", "6095abd345a52836f8ad0e0c", "6095abd345a52836f8ad0e0d", "6095abd345a52836f8ad0e0e", "6095abd345a52836f8ad0e0f", "6095abd345a52836f8ad0e10", "6095abd345a52836f8ad0e11", "6095abd345a52836f8ad0e12", "6095abd345a52836f8ad0e13"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe945a52836f8ad13c2",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Cantu",
            "brand_key": "cantu",
            "createdAt": "2021-05-07T21:06:49.565Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30374
        },
        "createdAt": "2021-05-07T21:06:49.589Z",
        "updatedAt": "2021-05-07T21:06:49.589Z"
    }, {
        "_id": "6095abe945a52836f8ad13c5",
        "products": ["6095abd345a52836f8ad0e14", "6095abd345a52836f8ad0e15", "6095abd345a52836f8ad0e16", "6095abd345a52836f8ad0e17", "6095abd345a52836f8ad0e18", "6095abd345a52836f8ad0e19", "6095abd345a52836f8ad0e1a", "6095abd345a52836f8ad0e1b", "6095abd345a52836f8ad0e1c", "6095abd345a52836f8ad0e1d", "6095abd345a52836f8ad0e1e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe945a52836f8ad13c4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Care Free Curl",
            "brand_key": "care-free-curl",
            "createdAt": "2021-05-07T21:06:49.647Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30375
        },
        "createdAt": "2021-05-07T21:06:49.668Z",
        "updatedAt": "2021-05-07T21:06:49.668Z"
    }, {
        "_id": "6095abe945a52836f8ad13c7",
        "products": ["6095abd345a52836f8ad0e1f", "6095abd345a52836f8ad0e20", "6095abd345a52836f8ad0e21", "6095abd345a52836f8ad0e22", "6095abd345a52836f8ad0e23", "6095abd345a52836f8ad0e24", "6095abd345a52836f8ad0e25", "6095abd345a52836f8ad0e26", "6095abd345a52836f8ad0e27", "6095abd345a52836f8ad0e28", "6095abd345a52836f8ad0e29", "6095abd345a52836f8ad0e2a", "6095abd345a52836f8ad0e2b", "6095abd345a52836f8ad0e2c", "6095abd345a52836f8ad0e2d", "6095abd345a52836f8ad0e2e", "6095abd345a52836f8ad0e2f", "6095abd345a52836f8ad0e30", "6095abd345a52836f8ad0e31"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe945a52836f8ad13c6",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Carol's Daughter",
            "brand_key": "carol's-daughter",
            "createdAt": "2021-05-07T21:06:49.727Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30376
        },
        "createdAt": "2021-05-07T21:06:49.752Z",
        "updatedAt": "2021-05-07T21:06:49.752Z"
    }, {
        "_id": "6095abe945a52836f8ad13c9",
        "products": ["6095abd345a52836f8ad0e32", "6095abd345a52836f8ad0e33", "6095abd345a52836f8ad0e34", "6095abd345a52836f8ad0e35"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe945a52836f8ad13c8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Carotein",
            "brand_key": "carotein",
            "createdAt": "2021-05-07T21:06:49.828Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30377
        },
        "createdAt": "2021-05-07T21:06:49.855Z",
        "updatedAt": "2021-05-07T21:06:49.855Z"
    }, {
        "_id": "6095abe945a52836f8ad13cb",
        "products": ["6095abd345a52836f8ad0e36", "6095abd345a52836f8ad0e37", "6095abd345a52836f8ad0e38"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe945a52836f8ad13ca",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "CHI",
            "brand_key": "chi",
            "createdAt": "2021-05-07T21:06:49.915Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30378
        },
        "createdAt": "2021-05-07T21:06:49.937Z",
        "updatedAt": "2021-05-07T21:06:49.937Z"
    }, {
        "_id": "6095abea45a52836f8ad13cd",
        "products": ["6095abd345a52836f8ad0e3b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abe945a52836f8ad13cc",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Clairol",
            "brand_key": "clairol",
            "createdAt": "2021-05-07T21:06:49.996Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30379
        },
        "createdAt": "2021-05-07T21:06:50.017Z",
        "updatedAt": "2021-05-07T21:06:50.017Z"
    }, {
        "_id": "6095abea45a52836f8ad13cf",
        "products": ["6095abd345a52836f8ad0e3c", "6095abd345a52836f8ad0e3d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13ce",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Clairol Professional",
            "brand_key": "clairol-professional",
            "createdAt": "2021-05-07T21:06:50.076Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30380
        },
        "createdAt": "2021-05-07T21:06:50.101Z",
        "updatedAt": "2021-05-07T21:06:50.101Z"
    }, {
        "_id": "6095abea45a52836f8ad13d1",
        "products": ["6095abd345a52836f8ad0e3e", "6095abd345a52836f8ad0e3f", "6095abd345a52836f8ad0e40", "6095abd345a52836f8ad0e41"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13d0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Clear Essence",
            "brand_key": "clear-essence",
            "createdAt": "2021-05-07T21:06:50.159Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30381
        },
        "createdAt": "2021-05-07T21:06:50.181Z",
        "updatedAt": "2021-05-07T21:06:50.181Z"
    }, {
        "_id": "6095abea45a52836f8ad13d3",
        "products": ["6095abd345a52836f8ad0e42", "6095abd345a52836f8ad0e43", "6095abd345a52836f8ad0e44", "6095abd345a52836f8ad0e45", "6095abd345a52836f8ad0e46"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13d2",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Click n Curl",
            "brand_key": "click-n-curl",
            "createdAt": "2021-05-07T21:06:50.241Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30382
        },
        "createdAt": "2021-05-07T21:06:50.262Z",
        "updatedAt": "2021-05-07T21:06:50.262Z"
    }, {
        "_id": "6095abea45a52836f8ad13d5",
        "products": ["6095abd345a52836f8ad0e48", "6095abd345a52836f8ad0e5f", "6095abd345a52836f8ad0e60", "6095abd345a52836f8ad0e61", "6095abd345a52836f8ad0e62", "6095abd345a52836f8ad0e63", "6095abd345a52836f8ad0e64", "6095abd345a52836f8ad0e65", "6095abd345a52836f8ad0e66", "6095abd345a52836f8ad0e67", "6095abd345a52836f8ad0e68", "6095abd345a52836f8ad0e69", "6095abd345a52836f8ad0e6a", "6095abd345a52836f8ad0e6b", "6095abd345a52836f8ad0e6c", "6095abd345a52836f8ad0e6d", "6095abd345a52836f8ad0e6e", "6095abd345a52836f8ad0e6f", "6095abd745a52836f8ad0e70", "6095abd745a52836f8ad0e71", "6095abd745a52836f8ad0e72", "6095abd745a52836f8ad0e73", "6095abd745a52836f8ad0e74", "6095abd745a52836f8ad0e75", "6095abd745a52836f8ad0e76", "6095abd745a52836f8ad0e77", "6095abd745a52836f8ad0e78", "6095abd745a52836f8ad0e79", "6095abd745a52836f8ad0e7a", "6095abd745a52836f8ad0e7b", "6095abd745a52836f8ad0e7c", "6095abd745a52836f8ad0e7d", "6095abd745a52836f8ad0e7e", "6095abd745a52836f8ad0e7f", "6095abd745a52836f8ad0e80", "6095abd745a52836f8ad0e81", "6095abd745a52836f8ad0e82", "6095abd745a52836f8ad0e83", "6095abd745a52836f8ad0e84", "6095abd745a52836f8ad0e85", "6095abd745a52836f8ad0e86", "6095abd745a52836f8ad0e87", "6095abd745a52836f8ad0e88", "6095abd745a52836f8ad0e89", "6095abd745a52836f8ad0e8a", "6095abd745a52836f8ad0e8b", "6095abd745a52836f8ad0e8c", "6095abd745a52836f8ad0e8d", "6095abd745a52836f8ad0e8e", "6095abd745a52836f8ad0e8f", "6095abd745a52836f8ad0e90", "6095abd745a52836f8ad0e91", "6095abd745a52836f8ad0e92", "6095abd745a52836f8ad0e93", "6095abd745a52836f8ad0e94", "6095abd745a52836f8ad0e95", "6095abd745a52836f8ad0e96", "6095abd745a52836f8ad0e97", "6095abd745a52836f8ad0e98", "6095abd745a52836f8ad0e99", "6095abd745a52836f8ad0e9a", "6095abd745a52836f8ad0e9b", "6095abd745a52836f8ad0e9c", "6095abd745a52836f8ad0e9d", "6095abd745a52836f8ad0e9e", "6095abd745a52836f8ad0e9f", "6095abd745a52836f8ad0ea0", "6095abd745a52836f8ad0ea1", "6095abd745a52836f8ad0ea2", "6095abd745a52836f8ad0ea3", "6095abd745a52836f8ad0ea4", "6095abd745a52836f8ad0ea5", "6095abd745a52836f8ad0ea6", "6095abd745a52836f8ad0ea7", "6095abd745a52836f8ad0ea8", "6095abd745a52836f8ad0ea9", "6095abd745a52836f8ad0eaa", "6095abd745a52836f8ad0eab", "6095abd745a52836f8ad0eac", "6095abd745a52836f8ad0ead", "6095abd745a52836f8ad0eae", "6095abd745a52836f8ad0eaf", "6095abd745a52836f8ad0eb0"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13d4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Creme of Nature",
            "brand_key": "creme-of-nature",
            "createdAt": "2021-05-07T21:06:50.319Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30383
        },
        "createdAt": "2021-05-07T21:06:50.342Z",
        "updatedAt": "2021-05-07T21:06:50.342Z"
    }, {
        "_id": "6095abea45a52836f8ad13d7",
        "products": ["6095abd345a52836f8ad0e49"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13d6",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Lemisol",
            "brand_key": "Lemisol",
            "createdAt": "2021-05-07T21:06:50.399Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30384
        },
        "createdAt": "2021-05-07T21:06:50.420Z",
        "updatedAt": "2021-05-07T21:06:50.420Z"
    }, {
        "_id": "6095abea45a52836f8ad13d7",
        "products": ["6095abd345a52836f8ad0e49"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13d6",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "London Eyes",
            "brand_key": "london-eyes",
            "createdAt": "2021-05-07T21:06:50.399Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30384
        },
        "createdAt": "2021-05-07T21:06:50.420Z",
        "updatedAt": "2021-05-07T21:06:50.420Z"
    }, {
        "_id": "6095abea45a52836f8ad13d9",
        "products": ["6095abd345a52836f8ad0e4a", "6095abd345a52836f8ad0e4b", "6095abd345a52836f8ad0e4c", "6095abd345a52836f8ad0e4d", "6095abd345a52836f8ad0e4e", "6095abd345a52836f8ad0e4f", "6095abd345a52836f8ad0e50", "6095abd345a52836f8ad0e51", "6095abd345a52836f8ad0e52", "6095abd345a52836f8ad0e53", "6095abd345a52836f8ad0e54"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13d8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Cover Your Gray",
            "brand_key": "cover-your-gray",
            "createdAt": "2021-05-07T21:06:50.479Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30385
        },
        "createdAt": "2021-05-07T21:06:50.504Z",
        "updatedAt": "2021-05-07T21:06:50.504Z"
    }
             , {
        "_id": "6095abea45a52836f8ad13db",
        "products": ["6095abd345a52836f8ad0e55", "6095abd345a52836f8ad0e56", "6095abd345a52836f8ad0e57", "6095abd345a52836f8ad0e58", "6095abd345a52836f8ad0e59", "6095abd345a52836f8ad0e5a", "6095abd345a52836f8ad0e5b", "6095abd345a52836f8ad0e5c", "6095abd345a52836f8ad0e5d", "6095abd345a52836f8ad0e5e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13da",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Crazy Color",
            "brand_key": "crazy-color",
            "createdAt": "2021-05-07T21:06:50.574Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30386
        },
        "createdAt": "2021-05-07T21:06:50.599Z",
        "updatedAt": "2021-05-07T21:06:50.599Z"
    }, {
        "_id": "6095abea45a52836f8ad13db",
        "products": ["6095abd345a52836f8ad0e55", "6095abd345a52836f8ad0e56", "6095abd345a52836f8ad0e57", "6095abd345a52836f8ad0e58", "6095abd345a52836f8ad0e59", "6095abd345a52836f8ad0e5a", "6095abd345a52836f8ad0e5b", "6095abd345a52836f8ad0e5c", "6095abd345a52836f8ad0e5d", "6095abd345a52836f8ad0e5e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13da",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Crecepelo",
            "brand_key": "crecepelo",
            "createdAt": "2021-05-07T21:06:50.574Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30386
        },
        "createdAt": "2021-05-07T21:06:50.599Z",
        "updatedAt": "2021-05-07T21:06:50.599Z"
    }, {
        "_id": "6095abea45a52836f8ad13dd",
        "products": ["6095abd745a52836f8ad0eb1", "6095abd745a52836f8ad0eb2", "6095abd745a52836f8ad0eb3", "6095abd745a52836f8ad0eb4"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13dc",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Culture",
            "brand_key": "culture",
            "createdAt": "2021-05-07T21:06:50.659Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30387
        },
        "createdAt": "2021-05-07T21:06:50.681Z",
        "updatedAt": "2021-05-07T21:06:50.681Z"
    }, {
        "_id": "6095abea45a52836f8ad13df",
        "products": ["6095abd745a52836f8ad0eb5", "6095abd745a52836f8ad0eb6", "6095abd745a52836f8ad0eb7", "6095abd745a52836f8ad0eb8", "6095abd745a52836f8ad0eb9", "6095abd745a52836f8ad0eba", "6095abd745a52836f8ad0ebb", "6095abd745a52836f8ad0ebc", "6095abd745a52836f8ad0ebd", "6095abd745a52836f8ad0ebe", "6095abd745a52836f8ad0ebf", "6095abd745a52836f8ad0ec0", "6095abd745a52836f8ad0ec1", "6095abd745a52836f8ad0ec2", "6095abd745a52836f8ad0ec3", "6095abd745a52836f8ad0ec4", "6095abd745a52836f8ad0ec5", "6095abd745a52836f8ad0ec6"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13de",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Curlessence",
            "brand_key": "curlessence",
            "createdAt": "2021-05-07T21:06:50.747Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30388
        },
        "createdAt": "2021-05-07T21:06:50.770Z",
        "updatedAt": "2021-05-07T21:06:50.770Z"
    },
             {
        "_id": "6095abea45a52836f8ad13df",
        "products": ["6095abd745a52836f8ad0eb5", "6095abd745a52836f8ad0eb6", "6095abd745a52836f8ad0eb7", "6095abd745a52836f8ad0eb8", "6095abd745a52836f8ad0eb9", "6095abd745a52836f8ad0eba", "6095abd745a52836f8ad0ebb", "6095abd745a52836f8ad0ebc", "6095abd745a52836f8ad0ebd", "6095abd745a52836f8ad0ebe", "6095abd745a52836f8ad0ebf", "6095abd745a52836f8ad0ec0", "6095abd745a52836f8ad0ec1", "6095abd745a52836f8ad0ec2", "6095abd745a52836f8ad0ec3", "6095abd745a52836f8ad0ec4", "6095abd745a52836f8ad0ec5", "6095abd745a52836f8ad0ec6"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13de",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Curl Smith",
            "brand_key": "curl-smith",
            "createdAt": "2021-05-07T21:06:50.747Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30388
        },
        "createdAt": "2021-05-07T21:06:50.770Z",
        "updatedAt": "2021-05-07T21:06:50.770Z"
    }, {
        "_id": "6095abea45a52836f8ad13df",
        "products": ["6095abd745a52836f8ad0eb5", "6095abd745a52836f8ad0eb6", "6095abd745a52836f8ad0eb7", "6095abd745a52836f8ad0eb8", "6095abd745a52836f8ad0eb9", "6095abd745a52836f8ad0eba", "6095abd745a52836f8ad0ebb", "6095abd745a52836f8ad0ebc", "6095abd745a52836f8ad0ebd", "6095abd745a52836f8ad0ebe", "6095abd745a52836f8ad0ebf", "6095abd745a52836f8ad0ec0", "6095abd745a52836f8ad0ec1", "6095abd745a52836f8ad0ec2", "6095abd745a52836f8ad0ec3", "6095abd745a52836f8ad0ec4", "6095abd745a52836f8ad0ec5", "6095abd745a52836f8ad0ec6"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13de",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Curl Keeper",
            "brand_key": "curl-keeper",
            "createdAt": "2021-05-07T21:06:50.747Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30388
        },
        "createdAt": "2021-05-07T21:06:50.770Z",
        "updatedAt": "2021-05-07T21:06:50.770Z"
    }, {
        "_id": "6095abea45a52836f8ad13e1",
        "products": ["6095abd745a52836f8ad0ec7", "6095abd745a52836f8ad0ec8", "6095abd745a52836f8ad0ec9", "6095abd745a52836f8ad0eca", "6095abd745a52836f8ad0ecb", "6095abd745a52836f8ad0ecc", "6095abd745a52836f8ad0ecd", "6095abd745a52836f8ad0ece", "6095abd745a52836f8ad0ecf", "6095abd745a52836f8ad0ed0", "6095abd745a52836f8ad0ed1", "6095abd745a52836f8ad0ed2", "6095abd745a52836f8ad0ed3", "6095abd745a52836f8ad0ed4", "6095abd745a52836f8ad0ed5", "6095abd745a52836f8ad0ed6", "6095abd745a52836f8ad0ed7", "6095abd745a52836f8ad0ed8", "6095abd745a52836f8ad0ed9", "6095abd745a52836f8ad0eda", "6095abd745a52836f8ad0edb", "6095abd745a52836f8ad0edc", "6095abd745a52836f8ad0edd", "6095abd745a52836f8ad0ede", "6095abd745a52836f8ad0edf", "6095abd745a52836f8ad0ee0", "6095abd745a52836f8ad0ee1", "6095abd745a52836f8ad0ee2", "6095abd745a52836f8ad0ee3", "6095abd745a52836f8ad0ee4", "6095abd745a52836f8ad0ee5", "6095abd745a52836f8ad0ee6", "6095abd745a52836f8ad0ee7", "6095abd745a52836f8ad0ee8", "6095abd745a52836f8ad0ee9", "6095abd745a52836f8ad0eea", "6095abd745a52836f8ad0eeb", "6095abd745a52836f8ad0eec", "6095abd745a52836f8ad0eed", "6095abd745a52836f8ad0eee", "6095abd745a52836f8ad0eef", "6095abd745a52836f8ad0ef0", "6095abd745a52836f8ad0ef1"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13e0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Curls",
            "brand_key": "curls",
            "createdAt": "2021-05-07T21:06:50.832Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30389
        },
        "createdAt": "2021-05-07T21:06:50.861Z",
        "updatedAt": "2021-05-07T21:06:50.861Z"
    }, {
        "_id": "6095abea45a52836f8ad13e3",
        "products": ["6095abd745a52836f8ad0ef2", "6095abd745a52836f8ad0ef3", "6095abd745a52836f8ad0ef4", "6095abd745a52836f8ad0ef5", "6095abd745a52836f8ad0ef6", "6095abd745a52836f8ad0ef7", "6095abd745a52836f8ad0ef8", "6095abd745a52836f8ad0ef9", "6095abd745a52836f8ad0efa", "6095abd745a52836f8ad0efb", "6095abd745a52836f8ad0efc", "6095abd745a52836f8ad0efd", "6095abd745a52836f8ad0efe"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13e2",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Curls Unleashed",
            "brand_key": "curls-unleashed",
            "createdAt": "2021-05-07T21:06:50.920Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30390
        },
        "createdAt": "2021-05-07T21:06:50.940Z",
        "updatedAt": "2021-05-07T21:06:50.940Z"
    }, {
        "_id": "6095abeb45a52836f8ad13e5",
        "products": ["6095abd745a52836f8ad0eff", "6095abd745a52836f8ad0f00", "6095abd745a52836f8ad0f01", "6095abd745a52836f8ad0f02", "6095abd745a52836f8ad0f03", "6095abd745a52836f8ad0f14", "6095abd745a52836f8ad0f15"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13e4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Curly Secret",
            "brand_key": "curly-secret",
            "createdAt": "2021-05-07T21:06:50.998Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30391
        },
        "createdAt": "2021-05-07T21:06:51.019Z",
        "updatedAt": "2021-05-07T21:06:51.019Z"
    },
             {
        "_id": "6095abeb45a52836f8ad13e5",
        "products": ["6095abd745a52836f8ad0eff", "6095abd745a52836f8ad0f00", "6095abd745a52836f8ad0f01", "6095abd745a52836f8ad0f02", "6095abd745a52836f8ad0f03", "6095abd745a52836f8ad0f14", "6095abd745a52836f8ad0f15"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abea45a52836f8ad13e4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Curly Kids",
            "brand_key": "curly-kids",
            "createdAt": "2021-05-07T21:06:50.998Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30391
        },
        "createdAt": "2021-05-07T21:06:51.019Z",
        "updatedAt": "2021-05-07T21:06:51.019Z"
    },{
        "_id": "6095abeb45a52836f8ad13e7",
        "products": ["6095abd745a52836f8ad0f04", "6095abd745a52836f8ad0f05", "6095abd745a52836f8ad0f06", "6095abd745a52836f8ad0f07", "6095abd745a52836f8ad0f08", "6095abd745a52836f8ad0f09", "6095abd745a52836f8ad0f0a", "6095abd745a52836f8ad0f0b", "6095abd745a52836f8ad0f0c", "6095abd745a52836f8ad0f0d", "6095abd745a52836f8ad0f0e", "6095abd745a52836f8ad0f0f", "6095abd745a52836f8ad0f10"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13e6",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Curly Love",
            "brand_key": "curly-love",
            "createdAt": "2021-05-07T21:06:51.077Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30392
        },
        "createdAt": "2021-05-07T21:06:51.098Z",
        "updatedAt": "2021-05-07T21:06:51.098Z"
    }, {
        "_id": "6095abeb45a52836f8ad13e9",
        "products": ["6095abd745a52836f8ad0f11", "6095abd745a52836f8ad0f12", "6095abd745a52836f8ad0f13"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13e8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "CurlyChic",
            "brand_key": "curlychic",
            "createdAt": "2021-05-07T21:06:51.164Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30393
        },
        "createdAt": "2021-05-07T21:06:51.185Z",
        "updatedAt": "2021-05-07T21:06:51.185Z"
    }, {
        "_id": "6095abeb45a52836f8ad13eb",
        "products": ["6095abd745a52836f8ad0f16", "6095abd745a52836f8ad0f17", "6095abd745a52836f8ad0f18", "6095abd745a52836f8ad0f19", "6095abd745a52836f8ad0f1a"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13ea",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Dabur",
            "brand_key": "dabur",
            "createdAt": "2021-05-07T21:06:51.242Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30394
        },
        "createdAt": "2021-05-07T21:06:51.262Z",
        "updatedAt": "2021-05-07T21:06:51.262Z"
    }, {
        "_id": "6095abeb45a52836f8ad13ed",
        "products": ["6095abd745a52836f8ad0f1b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13ec",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Dark & Natural",
            "brand_key": "dark-&-natural",
            "createdAt": "2021-05-07T21:06:51.323Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30395
        },
        "createdAt": "2021-05-07T21:06:51.344Z",
        "updatedAt": "2021-05-07T21:06:51.344Z"
    }, {
        "_id": "6095abeb45a52836f8ad13ef",
        "products": ["6095abd745a52836f8ad0f1c", "6095abd745a52836f8ad0f1d", "6095abd745a52836f8ad0f1e", "6095abd745a52836f8ad0f1f", "6095abd745a52836f8ad0f20", "6095abd745a52836f8ad0f21", "6095abd745a52836f8ad0f22", "6095abd745a52836f8ad0f23", "6095abd745a52836f8ad0f24", "6095abd745a52836f8ad0f25", "6095abd745a52836f8ad0f26", "6095abd745a52836f8ad0f27", "6095abd745a52836f8ad0f28", "6095abd745a52836f8ad0f29", "6095abd745a52836f8ad0f2a", "6095abd745a52836f8ad0f2b", "6095abd745a52836f8ad0f2c", "6095abd745a52836f8ad0f2d", "6095abd745a52836f8ad0f2e", "6095abd745a52836f8ad0f2f", "6095abd745a52836f8ad0f30", "6095abd745a52836f8ad0f31", "6095abd745a52836f8ad0f32", "6095abd745a52836f8ad0f33", "6095abd745a52836f8ad0f34", "6095abd745a52836f8ad0f35", "6095abd745a52836f8ad0f36", "6095abd745a52836f8ad0f37", "6095abd745a52836f8ad0f38"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13ee",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Dark and Lovely",
            "brand_key": "dark-and-lovely",
            "createdAt": "2021-05-07T21:06:51.405Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30396
        },
        "createdAt": "2021-05-07T21:06:51.428Z",
        "updatedAt": "2021-05-07T21:06:51.428Z"
    }, {
        "_id": "6095abeb45a52836f8ad13f1",
        "products": ["6095abd745a52836f8ad0f39", "6095abd745a52836f8ad0f3a", "6095abd745a52836f8ad0f3b", "6095abd745a52836f8ad0f3c", "6095abd745a52836f8ad0f3d", "6095abd745a52836f8ad0f3e", "6095abd745a52836f8ad0f3f", "6095abd745a52836f8ad0f40", "6095abd745a52836f8ad0f41", "6095abd745a52836f8ad0f42", "6095abd745a52836f8ad0f43", "6095abd745a52836f8ad0f44", "6095abd745a52836f8ad0f45", "6095abd745a52836f8ad0f46", "6095abd745a52836f8ad0f47", "6095abd745a52836f8ad0f48", "6095abd745a52836f8ad0f49", "6095abd745a52836f8ad0f4a", "6095abd745a52836f8ad0f4b", "6095abd745a52836f8ad0f4c", "6095abd745a52836f8ad0f4d", "6095abd745a52836f8ad0f4e", "6095abd745a52836f8ad0f4f", "6095abd745a52836f8ad0f50", "6095abd745a52836f8ad0f51"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13f0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "DAX",
            "brand_key": "dax",
            "createdAt": "2021-05-07T21:06:51.495Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30397
        },
        "createdAt": "2021-05-07T21:06:51.517Z",
        "updatedAt": "2021-05-07T21:06:51.517Z"
    }, {
        "_id": "6095abeb45a52836f8ad13f3",
        "products": ["6095abd745a52836f8ad0f52", "6095abd745a52836f8ad0f53", "6095abd745a52836f8ad0f54", "6095abd745a52836f8ad0f55", "6095abd745a52836f8ad0f56", "6095abd745a52836f8ad0f57", "6095abd745a52836f8ad0f58", "6095abd745a52836f8ad0f59", "6095abd745a52836f8ad0f5a", "6095abd745a52836f8ad0f5b", "6095abd745a52836f8ad0f5c", "6095abd745a52836f8ad0f5d", "6095abd745a52836f8ad0f5e", "6095abd745a52836f8ad0f5f", "6095abd745a52836f8ad0f60", "6095abd745a52836f8ad0f61", "6095abd745a52836f8ad0f62", "6095abd745a52836f8ad0f63", "6095abd745a52836f8ad0f64", "6095abd745a52836f8ad0f65", "6095abd745a52836f8ad0f66", "6095abd745a52836f8ad0f67", "6095abd745a52836f8ad0f68"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13f2",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Denman",
            "brand_key": "denman",
            "createdAt": "2021-05-07T21:06:51.573Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30398
        },
        "createdAt": "2021-05-07T21:06:51.593Z",
        "updatedAt": "2021-05-07T21:06:51.593Z"
    }, {
        "_id": "6095abeb45a52836f8ad13f5",
        "products": ["6095abd745a52836f8ad0f69", "6095abdb45a52836f8ad0f6a"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13f4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Derby",
            "brand_key": "derby",
            "createdAt": "2021-05-07T21:06:51.651Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30399
        },
        "createdAt": "2021-05-07T21:06:51.671Z",
        "updatedAt": "2021-05-07T21:06:51.671Z"
    }, {
        "_id": "6095abeb45a52836f8ad13f7",
        "products": ["6095abdb45a52836f8ad0f6b", "6095abdb45a52836f8ad0f6c", "6095abdb45a52836f8ad0f6d", "6095abdb45a52836f8ad0f6e", "6095abdb45a52836f8ad0f6f", "6095abdb45a52836f8ad0f70", "6095abdb45a52836f8ad0f71", "6095abdb45a52836f8ad0f72", "6095abdb45a52836f8ad0f73", "6095abdb45a52836f8ad0f74", "6095abdb45a52836f8ad0f75", "6095abdb45a52836f8ad0f76", "6095abdb45a52836f8ad0f77", "6095abdb45a52836f8ad0f78", "6095abdb45a52836f8ad0f79", "6095abdb45a52836f8ad0f7a", "6095abdb45a52836f8ad0f7b", "6095abdb45a52836f8ad0f7c", "6095abdb45a52836f8ad0f7d", "6095abdb45a52836f8ad0f7e", "6095abdb45a52836f8ad0f7f", "6095abdb45a52836f8ad0f80", "6095abdb45a52836f8ad0f81", "6095abdb45a52836f8ad0f82", "6095abdb45a52836f8ad0f83", "6095abdb45a52836f8ad0f84", "6095abdb45a52836f8ad0f85", "6095abdb45a52836f8ad0f86", "6095abdb45a52836f8ad0f87", "6095abdb45a52836f8ad0f88", "6095abdb45a52836f8ad0f89", "6095abdb45a52836f8ad0f8a", "6095abdb45a52836f8ad0f8b", "6095abdb45a52836f8ad0f8c", "6095abdb45a52836f8ad0f8d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13f6",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Design Essentials Natural",
            "brand_key": "design-essentials-natural",
            "createdAt": "2021-05-07T21:06:51.729Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30400
        },
        "createdAt": "2021-05-07T21:06:51.751Z",
        "updatedAt": "2021-05-07T21:06:51.751Z"
    }, {
        "_id": "6095abeb45a52836f8ad13f9",
        "products": ["6095abdb45a52836f8ad0f8e", "6095abdb45a52836f8ad0f8f", "6095abdb45a52836f8ad0f90", "6095abdb45a52836f8ad0f91", "6095abdb45a52836f8ad0f92", "6095abdb45a52836f8ad0f93", "6095abdb45a52836f8ad0f94", "6095abdb45a52836f8ad0f95", "6095abdb45a52836f8ad0f96", "6095abdb45a52836f8ad0f97", "6095abdb45a52836f8ad0f98", "6095abdb45a52836f8ad0f99", "6095abdb45a52836f8ad0f9a", "6095abdb45a52836f8ad0f9b", "6095abdb45a52836f8ad0f9c", "6095abdb45a52836f8ad0f9d", "6095abdb45a52836f8ad0f9e", "6095abdb45a52836f8ad0f9f", "6095abdb45a52836f8ad0fa0", "6095abdb45a52836f8ad0fa1", "6095abdb45a52836f8ad0fa2", "6095abdb45a52836f8ad0fa3", "6095abdb45a52836f8ad0fa4", "6095abdb45a52836f8ad0fa5", "6095abdb45a52836f8ad0fa6", "6095abdb45a52836f8ad0fa7", "6095abdb45a52836f8ad0fa8", "6095abdb45a52836f8ad0fa9", "6095abdb45a52836f8ad0faa", "6095abdb45a52836f8ad0fab", "6095abdb45a52836f8ad0fac", "6095abdb45a52836f8ad0fad", "6095abdb45a52836f8ad0fae", "6095abdb45a52836f8ad0faf", "6095abdb45a52836f8ad0fb0", "6095abdb45a52836f8ad0fb1", "6095abdb45a52836f8ad0fb2", "6095abdb45a52836f8ad0fb3", "6095abdb45a52836f8ad0fb4", "6095abdb45a52836f8ad0fb5", "6095abdb45a52836f8ad0fb6", "6095abdb45a52836f8ad0fb7", "6095abdb45a52836f8ad0fb8", "6095abdb45a52836f8ad0fb9"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13f8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Dessata",
            "brand_key": "Dessata",
            "createdAt": "2021-05-07T21:06:51.809Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30401
        },
        "createdAt": "2021-05-07T21:06:51.831Z",
        "updatedAt": "2021-05-07T21:06:51.831Z"
    }, {
        "_id": "6095abeb45a52836f8ad13f9",
        "products": ["6095abdb45a52836f8ad0f8e", "6095abdb45a52836f8ad0f8f", "6095abdb45a52836f8ad0f90", "6095abdb45a52836f8ad0f91", "6095abdb45a52836f8ad0f92", "6095abdb45a52836f8ad0f93", "6095abdb45a52836f8ad0f94", "6095abdb45a52836f8ad0f95", "6095abdb45a52836f8ad0f96", "6095abdb45a52836f8ad0f97", "6095abdb45a52836f8ad0f98", "6095abdb45a52836f8ad0f99", "6095abdb45a52836f8ad0f9a", "6095abdb45a52836f8ad0f9b", "6095abdb45a52836f8ad0f9c", "6095abdb45a52836f8ad0f9d", "6095abdb45a52836f8ad0f9e", "6095abdb45a52836f8ad0f9f", "6095abdb45a52836f8ad0fa0", "6095abdb45a52836f8ad0fa1", "6095abdb45a52836f8ad0fa2", "6095abdb45a52836f8ad0fa3", "6095abdb45a52836f8ad0fa4", "6095abdb45a52836f8ad0fa5", "6095abdb45a52836f8ad0fa6", "6095abdb45a52836f8ad0fa7", "6095abdb45a52836f8ad0fa8", "6095abdb45a52836f8ad0fa9", "6095abdb45a52836f8ad0faa", "6095abdb45a52836f8ad0fab", "6095abdb45a52836f8ad0fac", "6095abdb45a52836f8ad0fad", "6095abdb45a52836f8ad0fae", "6095abdb45a52836f8ad0faf", "6095abdb45a52836f8ad0fb0", "6095abdb45a52836f8ad0fb1", "6095abdb45a52836f8ad0fb2", "6095abdb45a52836f8ad0fb3", "6095abdb45a52836f8ad0fb4", "6095abdb45a52836f8ad0fb5", "6095abdb45a52836f8ad0fb6", "6095abdb45a52836f8ad0fb7", "6095abdb45a52836f8ad0fb8", "6095abdb45a52836f8ad0fb9"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13f8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "DevaCurl",
            "brand_key": "devacurl",
            "createdAt": "2021-05-07T21:06:51.809Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30401
        },
        "createdAt": "2021-05-07T21:06:51.831Z",
        "updatedAt": "2021-05-07T21:06:51.831Z"
    },{
        "_id": "6095abeb45a52836f8ad13f9",
        "products": ["6095abdb45a52836f8ad0f8e", "6095abdb45a52836f8ad0f8f", "6095abdb45a52836f8ad0f90", "6095abdb45a52836f8ad0f91", "6095abdb45a52836f8ad0f92", "6095abdb45a52836f8ad0f93", "6095abdb45a52836f8ad0f94", "6095abdb45a52836f8ad0f95", "6095abdb45a52836f8ad0f96", "6095abdb45a52836f8ad0f97", "6095abdb45a52836f8ad0f98", "6095abdb45a52836f8ad0f99", "6095abdb45a52836f8ad0f9a", "6095abdb45a52836f8ad0f9b", "6095abdb45a52836f8ad0f9c", "6095abdb45a52836f8ad0f9d", "6095abdb45a52836f8ad0f9e", "6095abdb45a52836f8ad0f9f", "6095abdb45a52836f8ad0fa0", "6095abdb45a52836f8ad0fa1", "6095abdb45a52836f8ad0fa2", "6095abdb45a52836f8ad0fa3", "6095abdb45a52836f8ad0fa4", "6095abdb45a52836f8ad0fa5", "6095abdb45a52836f8ad0fa6", "6095abdb45a52836f8ad0fa7", "6095abdb45a52836f8ad0fa8", "6095abdb45a52836f8ad0fa9", "6095abdb45a52836f8ad0faa", "6095abdb45a52836f8ad0fab", "6095abdb45a52836f8ad0fac", "6095abdb45a52836f8ad0fad", "6095abdb45a52836f8ad0fae", "6095abdb45a52836f8ad0faf", "6095abdb45a52836f8ad0fb0", "6095abdb45a52836f8ad0fb1", "6095abdb45a52836f8ad0fb2", "6095abdb45a52836f8ad0fb3", "6095abdb45a52836f8ad0fb4", "6095abdb45a52836f8ad0fb5", "6095abdb45a52836f8ad0fb6", "6095abdb45a52836f8ad0fb7", "6095abdb45a52836f8ad0fb8", "6095abdb45a52836f8ad0fb9"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13f8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Dippity Do",
            "brand_key": "dippity-do",
            "createdAt": "2021-05-07T21:06:51.809Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30401
        },
        "createdAt": "2021-05-07T21:06:51.831Z",
        "updatedAt": "2021-05-07T21:06:51.831Z"
    }, {
        "_id": "6095abeb45a52836f8ad13fb",
        "products": ["6095abdb45a52836f8ad0fba", "6095abdb45a52836f8ad0fbb", "6095abdb45a52836f8ad0fbc"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13fa",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Doctor Clear",
            "brand_key": "doctor-clear",
            "createdAt": "2021-05-07T21:06:51.889Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30402
        },
        "createdAt": "2021-05-07T21:06:51.913Z",
        "updatedAt": "2021-05-07T21:06:51.913Z"
    }, {
        "_id": "6095abeb45a52836f8ad13fd",
        "products": ["6095abdb45a52836f8ad0fbd", "6095abdb45a52836f8ad0fbe", "6095abdb45a52836f8ad0fbf", "6095abdb45a52836f8ad0fc0", "6095abdb45a52836f8ad0fc1", "6095abdb45a52836f8ad0fc2"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abeb45a52836f8ad13fc",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Doo Gro",
            "brand_key": "doo-gro",
            "createdAt": "2021-05-07T21:06:51.971Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30403
        },
        "createdAt": "2021-05-07T21:06:51.993Z",
        "updatedAt": "2021-05-07T21:06:51.993Z"
    }, {
        "_id": "6095abec45a52836f8ad13ff",
        "products": ["6095abdb45a52836f8ad0fc3", "6095abdb45a52836f8ad0fc4", "6095abdb45a52836f8ad0fc5", "6095abdb45a52836f8ad0fc6", "6095abdb45a52836f8ad0fc7", "6095abdb45a52836f8ad0fc8", "6095abdb45a52836f8ad0fc9", "6095abdb45a52836f8ad0fca", "6095abdb45a52836f8ad0fcb", "6095abdb45a52836f8ad0fcc", "6095abdb45a52836f8ad0fcd", "6095abdb45a52836f8ad0fce", "6095abdb45a52836f8ad0fcf", "6095abdb45a52836f8ad0fd0", "6095abdb45a52836f8ad0fd1", "6095abdb45a52836f8ad0fd2", "6095abdb45a52836f8ad0fd3", "6095abdb45a52836f8ad0fd4"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abec45a52836f8ad13fe",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Dove",
            "brand_key": "Dove",
            "createdAt": "2021-05-07T21:06:52.053Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30404
        },
        "createdAt": "2021-05-07T21:06:52.073Z",
        "updatedAt": "2021-05-07T21:06:52.073Z"
    }, {
        "_id": "6095abec45a52836f8ad13ff",
        "products": ["6095abdb45a52836f8ad0fc3", "6095abdb45a52836f8ad0fc4", "6095abdb45a52836f8ad0fc5", "6095abdb45a52836f8ad0fc6", "6095abdb45a52836f8ad0fc7", "6095abdb45a52836f8ad0fc8", "6095abdb45a52836f8ad0fc9", "6095abdb45a52836f8ad0fca", "6095abdb45a52836f8ad0fcb", "6095abdb45a52836f8ad0fcc", "6095abdb45a52836f8ad0fcd", "6095abdb45a52836f8ad0fce", "6095abdb45a52836f8ad0fcf", "6095abdb45a52836f8ad0fd0", "6095abdb45a52836f8ad0fd1", "6095abdb45a52836f8ad0fd2", "6095abdb45a52836f8ad0fd3", "6095abdb45a52836f8ad0fd4"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abec45a52836f8ad13fe",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Dr Miracles",
            "brand_key": "dr-miracles",
            "createdAt": "2021-05-07T21:06:52.053Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30404
        },
        "createdAt": "2021-05-07T21:06:52.073Z",
        "updatedAt": "2021-05-07T21:06:52.073Z"
    }, {
        "_id": "6095abec45a52836f8ad14fb",
        "products": ["6095abdb45a52836f8ad0fd5", "6095abdb45a52836f8ad0fd6", "6095abdb45a52836f8ad0fd7", "6095abdb45a52836f8ad0fd8", "6095abdb45a52836f8ad0fd9", "6095abdb45a52836f8ad0fda", "6095abdb45a52836f8ad0fdb", "6095abdb45a52836f8ad0fdc", "6095abdb45a52836f8ad0fdd", "6095abdb45a52836f8ad0fde", "6095abdb45a52836f8ad0fdf", "6095abdb45a52836f8ad0fe0", "6095abdb45a52836f8ad0fe1", "6095abdb45a52836f8ad0fe2", "6095abdb45a52836f8ad0fe3", "6095abdb45a52836f8ad0fe4", "6095abdb45a52836f8ad0fe5", "6095abdb45a52836f8ad0fe6", "6095abdb45a52836f8ad0fe7", "6095abdb45a52836f8ad0fe8", "6095abdb45a52836f8ad0fe9", "6095abdb45a52836f8ad0fea", "6095abdb45a52836f8ad0feb", "6095abdb45a52836f8ad0fec", "6095abdb45a52836f8ad0fed", "6095abdb45a52836f8ad0fee", "6095abdb45a52836f8ad0fef", "6095abdb45a52836f8ad0ff0", "6095abdb45a52836f8ad0ff1", "6095abdb45a52836f8ad0ff2", "6095abdb45a52836f8ad0ff3", "6095abdb45a52836f8ad0ff4", "6095abdb45a52836f8ad0ff5", "6095abdb45a52836f8ad0ff6", "6095abdb45a52836f8ad0ff7", "6095abdb45a52836f8ad0ff8", "6095abdb45a52836f8ad0ff9", "6095abdb45a52836f8ad0ffa", "6095abdb45a52836f8ad0ffb", "6095abdb45a52836f8ad0ffc", "6095abdb45a52836f8ad0ffd", "6095abdb45a52836f8ad0ffe", "6095abdb45a52836f8ad0fff", "6095abdb45a52836f8ad1000", "6095abdb45a52836f8ad1001", "6095abdb45a52836f8ad1002", "6095abdb45a52836f8ad1003", "6095abdb45a52836f8ad1004", "6095abdb45a52836f8ad1005", "6095abdb45a52836f8ad1006", "6095abdb45a52836f8ad1007"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abec45a52836f8ad14fa",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Dream World",
            "brand_key": "dream-world",
            "createdAt": "2021-05-07T21:06:52.357Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30405
        },
        "createdAt": "2021-05-07T21:06:52.383Z",
        "updatedAt": "2021-05-07T21:06:52.383Z"
    }, {
        "_id": "6095abec45a52836f8ad14fd",
        "products": ["6095abdb45a52836f8ad1008", "6095abdb45a52836f8ad1009", "6095abdb45a52836f8ad100a", "6095abdb45a52836f8ad100b", "6095abdb45a52836f8ad100c", "6095abdb45a52836f8ad100d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abec45a52836f8ad14fc",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Earth Supplied",
            "brand_key": "earth-supplied",
            "createdAt": "2021-05-07T21:06:52.498Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30406
        },
        "createdAt": "2021-05-07T21:06:52.521Z",
        "updatedAt": "2021-05-07T21:06:52.521Z"
    }, {
        "_id": "6095abec45a52836f8ad14ff",
        "products": ["6095abdb45a52836f8ad100e", "6095abdb45a52836f8ad100f", "6095abdb45a52836f8ad1010"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abec45a52836f8ad14fe",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Ebin",
            "brand_key": "ebin",
            "createdAt": "2021-05-07T21:06:52.585Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30407
        },
        "createdAt": "2021-05-07T21:06:52.609Z",
        "updatedAt": "2021-05-07T21:06:52.609Z"
    }, {
        "_id": "6095abec45a52836f8ad1501",
        "products": ["6095abdb45a52836f8ad1012", "6095abdb45a52836f8ad1013", "6095abdb45a52836f8ad1014", "6095abdb45a52836f8ad1015"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abec45a52836f8ad1500",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Eco Natural",
            "brand_key": "eco-natural",
            "createdAt": "2021-05-07T21:06:52.668Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30408
        },
        "createdAt": "2021-05-07T21:06:52.692Z",
        "updatedAt": "2021-05-07T21:06:52.692Z"
    }, {
        "_id": "6095abec45a52836f8ad1503",
        "products": ["6095abdb45a52836f8ad1016", "6095abdb45a52836f8ad1017", "6095abdb45a52836f8ad1018", "6095abdb45a52836f8ad1019", "6095abdb45a52836f8ad101a", "6095abdb45a52836f8ad101b", "6095abdb45a52836f8ad101c", "6095abdb45a52836f8ad101d", "6095abdb45a52836f8ad101e", "6095abdb45a52836f8ad101f", "6095abdb45a52836f8ad1020", "6095abdb45a52836f8ad1021", "6095abdb45a52836f8ad1022", "6095abdb45a52836f8ad1023", "6095abdb45a52836f8ad1024", "6095abdb45a52836f8ad1025", "6095abdb45a52836f8ad1026", "6095abdb45a52836f8ad1027", "6095abdb45a52836f8ad1028", "6095abdb45a52836f8ad1029", "6095abdb45a52836f8ad102a", "6095abdb45a52836f8ad102b", "6095abdb45a52836f8ad102c", "6095abdb45a52836f8ad102d", "6095abdb45a52836f8ad102e", "6095abdb45a52836f8ad102f", "6095abdb45a52836f8ad1030", "6095abdb45a52836f8ad1031", "6095abdb45a52836f8ad1032", "6095abdb45a52836f8ad1033", "6095abdb45a52836f8ad1034", "6095abdb45a52836f8ad1035", "6095abdb45a52836f8ad1036", "6095abdb45a52836f8ad1037", "6095abdb45a52836f8ad1038", "6095abdb45a52836f8ad1039", "6095abdb45a52836f8ad103a", "6095abdb45a52836f8ad103b", "6095abdb45a52836f8ad103c", "6095abdb45a52836f8ad103d", "6095abdb45a52836f8ad103e", "6095abdb45a52836f8ad103f", "6095abdb45a52836f8ad1040", "6095abdb45a52836f8ad1041", "6095abdb45a52836f8ad1042", "6095abdb45a52836f8ad1043", "6095abdb45a52836f8ad1044", "6095abdb45a52836f8ad1045", "6095abdb45a52836f8ad1046", "6095abdb45a52836f8ad1047", "6095abdb45a52836f8ad1048", "6095abdb45a52836f8ad1049", "6095abdb45a52836f8ad104a", "6095abdb45a52836f8ad104b", "6095abdb45a52836f8ad104c", "6095abdb45a52836f8ad104d", "6095abdb45a52836f8ad104e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abec45a52836f8ad1502",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "ECO Styler",
            "brand_key": "eco-styler",
            "createdAt": "2021-05-07T21:06:52.754Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30409
        },
        "createdAt": "2021-05-07T21:06:52.780Z",
        "updatedAt": "2021-05-07T21:06:52.780Z"
    }, {
        "_id": "6095abec45a52836f8ad1505",
        "products": ["6095abdb45a52836f8ad104f", "6095abdb45a52836f8ad1050", "6095abdb45a52836f8ad1051", "6095abdb45a52836f8ad1052", "6095abdb45a52836f8ad1053", "6095abdb45a52836f8ad1054", "6095abdb45a52836f8ad1055", "6095abdb45a52836f8ad1056"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abec45a52836f8ad1504",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Ecoslay",
            "brand_key": "ecoslay",
            "createdAt": "2021-05-07T21:06:52.848Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30410
        },
        "createdAt": "2021-05-07T21:06:52.872Z",
        "updatedAt": "2021-05-07T21:06:52.872Z"
    }, {
        "_id": "6095abec45a52836f8ad1507",
        "products": ["6095abdb45a52836f8ad1057", "6095abdb45a52836f8ad1058", "6095abdb45a52836f8ad1059", "6095abdb45a52836f8ad105a", "6095abdb45a52836f8ad105b", "6095abdb45a52836f8ad105c", "6095abdb45a52836f8ad105d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abec45a52836f8ad1506",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Ecrinal Anp",
            "brand_key": "ecrinal-anp",
            "createdAt": "2021-05-07T21:06:52.938Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30411
        },
        "createdAt": "2021-05-07T21:06:52.963Z",
        "updatedAt": "2021-05-07T21:06:52.963Z"
    }, {
        "_id": "6095abed45a52836f8ad1509",
        "products": ["6095abdb45a52836f8ad105e", "6095abdb45a52836f8ad105f", "6095abdb45a52836f8ad1060", "6095abdb45a52836f8ad1061", "6095abdb45a52836f8ad1062", "6095abdb45a52836f8ad1063", "6095abdf45a52836f8ad1064", "6095abdf45a52836f8ad1065", "6095abdf45a52836f8ad1066", "6095abdf45a52836f8ad1067", "6095abdf45a52836f8ad1068", "6095abdf45a52836f8ad1069", "6095abdf45a52836f8ad106a", "6095abdf45a52836f8ad106b", "6095abdf45a52836f8ad106c"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abed45a52836f8ad1508",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Eden Bodyworks",
            "brand_key": "eden-bodyworks",
            "createdAt": "2021-05-07T21:06:53.024Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30412
        },
        "createdAt": "2021-05-07T21:06:53.048Z",
        "updatedAt": "2021-05-07T21:06:53.048Z"
    }, {
        "_id": "6095abed45a52836f8ad150b",
        "products": ["6095abdf45a52836f8ad1074", "6095abdf45a52836f8ad1075", "6095abdf45a52836f8ad1076"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abed45a52836f8ad150a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Ever Sheen",
            "brand_key": "ever-sheen",
            "createdAt": "2021-05-07T21:06:53.110Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30413
        },
        "createdAt": "2021-05-07T21:06:53.133Z",
        "updatedAt": "2021-05-07T21:06:53.133Z"
    }, {
        "_id": "6095abed45a52836f8ad150d",
        "products": ["6095abdf45a52836f8ad1077", "6095abdf45a52836f8ad1078", "6095abdf45a52836f8ad1079", "6095abdf45a52836f8ad107a", "6095abdf45a52836f8ad107b", "6095abdf45a52836f8ad107c"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abed45a52836f8ad150c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Everlash",
            "brand_key": "everlash",
            "createdAt": "2021-05-07T21:06:53.193Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30414
        },
        "createdAt": "2021-05-07T21:06:53.217Z",
        "updatedAt": "2021-05-07T21:06:53.217Z"
    }, {
        "_id": "6095abed45a52836f8ad150f",
        "products": ["6095abdf45a52836f8ad107d", "6095ac0145a52836f8ad1b07", "6095ac0145a52836f8ad1b08", "6095ac0145a52836f8ad1b09", "6095ac0145a52836f8ad1b0a", "6095ac0145a52836f8ad1b0b", "6095ac0145a52836f8ad1b0c", "6095ac0145a52836f8ad1b0d", "6095ac0145a52836f8ad1b0e", "6095ac0145a52836f8ad1b0f", "6095ac0145a52836f8ad1b07", "6095ac0145a52836f8ad1b08", "6095ac0145a52836f8ad1b09", "6095ac0145a52836f8ad1b0a", "6095ac0145a52836f8ad1b0b", "6095ac0145a52836f8ad1b0c", "6095ac0145a52836f8ad1b0d", "6095ac0145a52836f8ad1b0e", "6095ac0145a52836f8ad1b0f"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abed45a52836f8ad150e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "X-Pression",
            "brand_key": "x-pression",
            "createdAt": "2021-05-07T21:06:53.304Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30415
        },
        "createdAt": "2021-05-07T21:06:53.326Z",
        "updatedAt": "2021-05-07T21:09:29.525Z"
    }, {
        "_id": "6095abed45a52836f8ad1511",
        "products": ["6095abdf45a52836f8ad107e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abed45a52836f8ad1510",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Fair & Lovely",
            "brand_key": "fair-&-lovely",
            "createdAt": "2021-05-07T21:06:53.386Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30416
        },
        "createdAt": "2021-05-07T21:06:53.414Z",
        "updatedAt": "2021-05-07T21:06:53.414Z"
    }, {
        "_id": "6095abed45a52836f8ad1513",
        "products": ["6095abdf45a52836f8ad107f", "6095abdf45a52836f8ad1080", "6095abdf45a52836f8ad1081", "6095abdf45a52836f8ad1082", "6095abdf45a52836f8ad1083", "6095abdf45a52836f8ad1084", "6095abdf45a52836f8ad1085", "6095abdf45a52836f8ad1086", "6095abdf45a52836f8ad1087", "6095abdf45a52836f8ad1088", "6095abdf45a52836f8ad1089", "6095abdf45a52836f8ad108a", "6095abdf45a52836f8ad108b", "6095abdf45a52836f8ad108c", "6095abdf45a52836f8ad108d", "6095abdf45a52836f8ad108e", "6095abdf45a52836f8ad108f", "6095abdf45a52836f8ad1090", "6095abdf45a52836f8ad1091", "6095abdf45a52836f8ad1092", "6095abdf45a52836f8ad1093", "6095abdf45a52836f8ad1094", "6095abdf45a52836f8ad1095", "6095abdf45a52836f8ad1096", "6095abdf45a52836f8ad1097", "6095abdf45a52836f8ad1098", "6095abdf45a52836f8ad1099", "6095abdf45a52836f8ad109a", "6095abdf45a52836f8ad109b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abed45a52836f8ad1512",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Fair & White",
            "brand_key": "fair-&-white",
            "createdAt": "2021-05-07T21:06:53.474Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30417
        },
        "createdAt": "2021-05-07T21:06:53.498Z",
        "updatedAt": "2021-05-07T21:06:53.498Z"
    }, {
        "_id": "6095abed45a52836f8ad1515",
        "products": ["6095abdf45a52836f8ad109d", "6095abdf45a52836f8ad109e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abed45a52836f8ad1514",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Fanola",
            "brand_key": "fanola",
            "createdAt": "2021-05-07T21:06:53.557Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30418
        },
        "createdAt": "2021-05-07T21:06:53.577Z",
        "updatedAt": "2021-05-07T21:06:53.577Z"
    }, {
        "_id": "6095abed45a52836f8ad1517",
        "products": ["6095abdf45a52836f8ad109f"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abed45a52836f8ad1516",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Sibel",
            "brand_key": "sibel",
            "createdAt": "2021-05-07T21:06:53.636Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30419
        },
        "createdAt": "2021-05-07T21:06:53.656Z",
        "updatedAt": "2021-05-07T21:06:53.656Z"
    }, {
        "_id": "6095abed45a52836f8ad1519",
        "products": ["6095abdf45a52836f8ad10a0", "6095abdf45a52836f8ad10a1", "6095abdf45a52836f8ad10a2", "6095abdf45a52836f8ad10a3", "6095abdf45a52836f8ad10a4", "6095abdf45a52836f8ad10a5", "6095abdf45a52836f8ad10a6", "6095abdf45a52836f8ad10a7", "6095abdf45a52836f8ad10a8", "6095abdf45a52836f8ad10a9", "6095abdf45a52836f8ad10aa", "6095abdf45a52836f8ad10ab"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abed45a52836f8ad1518",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Flora & Curl",
            "brand_key": "flora-&-curl",
            "createdAt": "2021-05-07T21:06:53.713Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30420
        },
        "createdAt": "2021-05-07T21:06:53.734Z",
        "updatedAt": "2021-05-07T21:06:53.734Z"
    }, {
        "_id": "6095abed45a52836f8ad151b",
        "products": ["6095abdf45a52836f8ad10ac", "6095abdf45a52836f8ad10ad"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abed45a52836f8ad151a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Frobabies Hair",
            "brand_key": "frobabies-hair",
            "createdAt": "2021-05-07T21:06:53.797Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30421
        },
        "createdAt": "2021-05-07T21:06:53.820Z",
        "updatedAt": "2021-05-07T21:06:53.820Z"
    }, {
        "_id": "6095abed45a52836f8ad151d",
        "products": ["6095abdf45a52836f8ad10b1", "6095abdf45a52836f8ad10b2", "6095abdf45a52836f8ad10b3", "6095abdf45a52836f8ad10b4", "6095abdf45a52836f8ad10b5", "6095abdf45a52836f8ad10b6", "6095abdf45a52836f8ad10b7"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abed45a52836f8ad151c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Fudge",
            "brand_key": "fudge",
            "createdAt": "2021-05-07T21:06:53.903Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30422
        },
        "createdAt": "2021-05-07T21:06:53.925Z",
        "updatedAt": "2021-05-07T21:06:53.925Z"
    }, {
        "_id": "6095abee45a52836f8ad151f",
        "products": ["6095abdf45a52836f8ad10b8", "6095abdf45a52836f8ad10b9", "6095abdf45a52836f8ad10ba", "6095abdf45a52836f8ad10bb"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abed45a52836f8ad151e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Garnier",
            "brand_key": "garnier",
            "createdAt": "2021-05-07T21:06:53.990Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30423
        },
        "createdAt": "2021-05-07T21:06:54.014Z",
        "updatedAt": "2021-05-07T21:06:54.014Z"
    }, {
        "_id": "6095abee45a52836f8ad1521",
        "products": ["6095abdf45a52836f8ad10bc", "6095abdf45a52836f8ad10bd", "6095abdf45a52836f8ad10be", "6095abdf45a52836f8ad10bf"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad1520",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "GhostBond",
            "brand_key": "ghostbond",
            "createdAt": "2021-05-07T21:06:54.074Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30424
        },
        "createdAt": "2021-05-07T21:06:54.097Z",
        "updatedAt": "2021-05-07T21:06:54.097Z"
    }, {
        "_id": "6095abee45a52836f8ad1523",
        "products": ["6095abdf45a52836f8ad10c0"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad1522",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Ginseng Miracle",
            "brand_key": "ginseng-miracle",
            "createdAt": "2021-05-07T21:06:54.164Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30425
        },
        "createdAt": "2021-05-07T21:06:54.186Z",
        "updatedAt": "2021-05-07T21:06:54.186Z"
    }, {
        "_id": "6095abee45a52836f8ad1525",
        "products": ["6095abdf45a52836f8ad10c1", "6095abdf45a52836f8ad10c2", "6095abdf45a52836f8ad10c3", "6095abdf45a52836f8ad10c4", "6095abdf45a52836f8ad10c5", "6095abdf45a52836f8ad10c6", "6095abdf45a52836f8ad10c7", "6095abdf45a52836f8ad10c8", "6095abdf45a52836f8ad10c9"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad1524",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Giovanni",
            "brand_key": "giovanni",
            "createdAt": "2021-05-07T21:06:54.244Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30426
        },
        "createdAt": "2021-05-07T21:06:54.265Z",
        "updatedAt": "2021-05-07T21:06:54.265Z"
    }, {
        "_id": "6095abee45a52836f8ad1527",
        "products": ["6095abdf45a52836f8ad10ca", "6095abdf45a52836f8ad10cb"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad1526",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Goldwell",
            "brand_key": "goldwell",
            "createdAt": "2021-05-07T21:06:54.324Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30427
        },
        "createdAt": "2021-05-07T21:06:54.346Z",
        "updatedAt": "2021-05-07T21:06:54.346Z"
    }, {
        "_id": "6095abee45a52836f8ad1529",
        "products": ["6095abdf45a52836f8ad10cc", "6095abdf45a52836f8ad10cd", "6095abdf45a52836f8ad10ce", "6095abdf45a52836f8ad10cf", "6095abdf45a52836f8ad10d0", "6095abdf45a52836f8ad10d1", "6095abdf45a52836f8ad10d2", "6095abdf45a52836f8ad10d3"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad1528",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Gro Healthy",
            "brand_key": "gro-healthy",
            "createdAt": "2021-05-07T21:06:54.404Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30428
        },
        "createdAt": "2021-05-07T21:06:54.427Z",
        "updatedAt": "2021-05-07T21:06:54.427Z"
    }, {
        "_id": "6095abee45a52836f8ad152b",
        "products": ["6095abdf45a52836f8ad10d4", "6095abf045a52836f8ad154e", "6095abf045a52836f8ad154f", "6095abf745a52836f8ad178b", "6095abf745a52836f8ad178c", "6095abf745a52836f8ad178d", "6095abf745a52836f8ad178e", "6095abf745a52836f8ad178f", "6095abf745a52836f8ad1790", "6095abf745a52836f8ad1791", "6095abf745a52836f8ad1792"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad152a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Parnevu",
            "brand_key": "Parnevu",
            "createdAt": "2021-05-07T21:06:54.485Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30429
        },
        "createdAt": "2021-05-07T21:06:54.507Z",
        "updatedAt": "2021-05-07T21:09:19.033Z"
    }, {
        "_id": "6095abee45a52836f8ad152b",
        "products": ["6095abdf45a52836f8ad10d4", "6095abf045a52836f8ad154e", "6095abf045a52836f8ad154f", "6095abf745a52836f8ad178b", "6095abf745a52836f8ad178c", "6095abf745a52836f8ad178d", "6095abf745a52836f8ad178e", "6095abf745a52836f8ad178f", "6095abf745a52836f8ad1790", "6095abf745a52836f8ad1791", "6095abf745a52836f8ad1792"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad152a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "perma sharp",
            "brand_key": "perma sharp",
            "createdAt": "2021-05-07T21:06:54.485Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30429
        },
        "createdAt": "2021-05-07T21:06:54.507Z",
        "updatedAt": "2021-05-07T21:09:19.033Z"
    }, {
        "_id": "6095abee45a52836f8ad152b",
        "products": ["6095abdf45a52836f8ad10d4", "6095abf045a52836f8ad154e", "6095abf045a52836f8ad154f", "6095abf745a52836f8ad178b", "6095abf745a52836f8ad178c", "6095abf745a52836f8ad178d", "6095abf745a52836f8ad178e", "6095abf745a52836f8ad178f", "6095abf745a52836f8ad1790", "6095abf745a52836f8ad1791", "6095abf745a52836f8ad1792"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad152a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Profectiv",
            "brand_key": "profectiv",
            "createdAt": "2021-05-07T21:06:54.485Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30429
        },
        "createdAt": "2021-05-07T21:06:54.507Z",
        "updatedAt": "2021-05-07T21:09:19.033Z"
    }, {
        "_id": "6095abee45a52836f8ad152d",
        "products": ["6095abdf45a52836f8ad10d5", "6095abdf45a52836f8ad10d6", "6095abdf45a52836f8ad10d7", "6095abdf45a52836f8ad10d8", "6095abdf45a52836f8ad10d9", "6095abdf45a52836f8ad10da", "6095abdf45a52836f8ad10db", "6095abdf45a52836f8ad10dc", "6095abdf45a52836f8ad10dd", "6095abdf45a52836f8ad10de"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad152c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Fonex",
            "brand_key": "fonex",
            "createdAt": "2021-05-07T21:06:54.566Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30430
        },
        "createdAt": "2021-05-07T21:06:54.588Z",
        "updatedAt": "2021-05-07T21:06:54.588Z"
    }, {
        "_id": "6095abee45a52836f8ad152f",
        "products": ["6095abdf45a52836f8ad10df", "6095abf745a52836f8ad1793", "6095abf745a52836f8ad1794", "6095abf745a52836f8ad1795", "6095abf745a52836f8ad1796", "6095abf745a52836f8ad1797", "6095abf745a52836f8ad1798", "6095abf745a52836f8ad1799", "6095abf745a52836f8ad179a", "6095abf745a52836f8ad179b", "6095abf745a52836f8ad179c", "6095abf745a52836f8ad179d", "6095abf745a52836f8ad179e", "6095abf745a52836f8ad179f", "6095abf745a52836f8ad17a0", "6095abf745a52836f8ad17a1", "6095abf745a52836f8ad17a2", "6095abf745a52836f8ad17a3", "6095abf745a52836f8ad17a4", "6095abf745a52836f8ad17a5", "6095abf745a52836f8ad17a6", "6095abf745a52836f8ad17a7", "6095abf745a52836f8ad17a8", "6095abf745a52836f8ad17a9", "6095abf745a52836f8ad17aa", "6095abf745a52836f8ad17ab", "6095abf745a52836f8ad17ac", "6095abf745a52836f8ad17ad", "6095abf745a52836f8ad17ae", "6095abf745a52836f8ad17af", "6095abf745a52836f8ad17b0", "6095abf745a52836f8ad17b1", "6095abf745a52836f8ad17b2", "6095abf745a52836f8ad17b3", "6095abf745a52836f8ad17b4", "6095abf745a52836f8ad17b5", "6095abf745a52836f8ad17b6", "6095abf745a52836f8ad17b7", "6095abf745a52836f8ad17b8", "6095abf745a52836f8ad17b9", "6095abf745a52836f8ad17ba", "6095abf745a52836f8ad17bb", "6095abf745a52836f8ad17bc", "6095abf745a52836f8ad17bd", "6095abf745a52836f8ad17be", "6095abf745a52836f8ad17bf", "6095abf745a52836f8ad17c0", "6095abf745a52836f8ad17c1", "6095abf745a52836f8ad17c2", "6095abf745a52836f8ad17c3", "6095abf745a52836f8ad17c4", "6095abf745a52836f8ad17c5", "6095abf745a52836f8ad17c6", "6095abf745a52836f8ad17c7", "6095abf745a52836f8ad17c8", "6095abf745a52836f8ad17c9", "6095abf745a52836f8ad17ca", "6095abf745a52836f8ad17cb", "6095abf745a52836f8ad17cc", "6095abf745a52836f8ad17cd", "6095abf745a52836f8ad17ce"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad152e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Hairaisers",
            "brand_key": "hairaisers",
            "createdAt": "2021-05-07T21:06:54.647Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30431
        },
        "createdAt": "2021-05-07T21:06:54.669Z",
        "updatedAt": "2021-05-07T21:09:22.468Z"
    }, {
        "_id": "6095abee45a52836f8ad1531",
        "products": ["6095abdf45a52836f8ad10e0", "6095abdf45a52836f8ad10e1"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad1530",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Hairfinity",
            "brand_key": "hairfinity",
            "createdAt": "2021-05-07T21:06:54.727Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30432
        },
        "createdAt": "2021-05-07T21:06:54.748Z",
        "updatedAt": "2021-05-07T21:06:54.748Z"
    }, {
        "_id": "6095abee45a52836f8ad1531",
        "products": ["6095abdf45a52836f8ad10e0", "6095abdf45a52836f8ad10e1"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad1530",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Hairmed",
            "brand_key": "hairmed",
            "createdAt": "2021-05-07T21:06:54.727Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30432
        },
        "createdAt": "2021-05-07T21:06:54.748Z",
        "updatedAt": "2021-05-07T21:06:54.748Z"
    }, {
        "_id": "6095abee45a52836f8ad1533",
        "products": ["6095abdf45a52836f8ad10e2"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad1532",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Happy Hair",
            "brand_key": "happy-hair",
            "createdAt": "2021-05-07T21:06:54.808Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30433
        },
        "createdAt": "2021-05-07T21:06:54.829Z",
        "updatedAt": "2021-05-07T21:06:54.829Z"
    }, {
        "_id": "6095abee45a52836f8ad1535",
        "products": ["6095abdf45a52836f8ad10e3", "6095abdf45a52836f8ad10e4", "6095abdf45a52836f8ad10e5", "6095abdf45a52836f8ad10e6", "6095abdf45a52836f8ad10e7"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad1534",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Hask Placenta",
            "brand_key": "hask-placenta",
            "createdAt": "2021-05-07T21:06:54.887Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30434
        },
        "createdAt": "2021-05-07T21:06:54.910Z",
        "updatedAt": "2021-05-07T21:06:54.910Z"
    }, {
        "_id": "6095abee45a52836f8ad1537",
        "products": ["6095abdf45a52836f8ad10e8", "6095abdf45a52836f8ad10e9", "6095abdf45a52836f8ad10ea", "6095abdf45a52836f8ad10eb", "6095abdf45a52836f8ad10ec", "6095abdf45a52836f8ad10ed", "6095abdf45a52836f8ad10ee", "6095abdf45a52836f8ad10ef", "6095abdf45a52836f8ad10f0", "6095abdf45a52836f8ad10f1", "6095abdf45a52836f8ad10f2", "6095abdf45a52836f8ad10f3", "6095abdf45a52836f8ad10f4", "6095abdf45a52836f8ad10f5", "6095abdf45a52836f8ad10f6", "6095abdf45a52836f8ad10f7", "6095abdf45a52836f8ad10f8"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abee45a52836f8ad1536",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Hawaiian Silky",
            "brand_key": "hawaiian-silky",
            "createdAt": "2021-05-07T21:06:54.970Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30435
        },
        "createdAt": "2021-05-07T21:06:54.991Z",
        "updatedAt": "2021-05-07T21:06:54.991Z"
    }, {
        "_id": "6095abef45a52836f8ad1539",
        "products": ["6095abdf45a52836f8ad10f9", "6095abdf45a52836f8ad10fa", "6095abdf45a52836f8ad10fb"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abef45a52836f8ad1538",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "High Time",
            "brand_key": "high-time",
            "createdAt": "2021-05-07T21:06:55.049Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30436
        },
        "createdAt": "2021-05-07T21:06:55.070Z",
        "updatedAt": "2021-05-07T21:06:55.070Z"
    }, {
        "_id": "6095abef45a52836f8ad153b",
        "products": ["6095abdf45a52836f8ad10fc", "6095abdf45a52836f8ad10fd", "6095abdf45a52836f8ad10fe", "6095abdf45a52836f8ad10ff", "6095abdf45a52836f8ad1100", "6095abdf45a52836f8ad1101"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abef45a52836f8ad153a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Hollywood Beauty",
            "brand_key": "hollywood-beauty",
            "createdAt": "2021-05-07T21:06:55.128Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30437
        },
        "createdAt": "2021-05-07T21:06:55.150Z",
        "updatedAt": "2021-05-07T21:06:55.150Z"
    }, {
        "_id": "6095abef45a52836f8ad153d",
        "products": ["6095abdf45a52836f8ad1102", "6095abdf45a52836f8ad1103", "6095abdf45a52836f8ad1104", "6095abdf45a52836f8ad1105", "6095abdf45a52836f8ad1106", "6095abdf45a52836f8ad1107", "6095abdf45a52836f8ad1108", "6095abdf45a52836f8ad1109", "6095abdf45a52836f8ad110a", "6095abdf45a52836f8ad110b", "6095abdf45a52836f8ad110c", "6095abdf45a52836f8ad110d", "6095abdf45a52836f8ad110e", "6095abdf45a52836f8ad110f", "6095abdf45a52836f8ad1110", "6095abdf45a52836f8ad1111", "6095abdf45a52836f8ad1112", "6095abdf45a52836f8ad1113", "6095abdf45a52836f8ad1114", "6095abdf45a52836f8ad1115", "6095abdf45a52836f8ad1116", "6095abdf45a52836f8ad1117", "6095abdf45a52836f8ad1118", "6095abdf45a52836f8ad1119", "6095abdf45a52836f8ad111a", "6095abdf45a52836f8ad111b", "6095abdf45a52836f8ad111c", "6095abdf45a52836f8ad111d", "6095abdf45a52836f8ad111e", "6095abdf45a52836f8ad111f", "6095abdf45a52836f8ad1120", "6095abdf45a52836f8ad1121", "6095abdf45a52836f8ad1122", "6095abdf45a52836f8ad1123", "6095abdf45a52836f8ad1124", "6095abdf45a52836f8ad1125", "6095abdf45a52836f8ad1126", "6095abdf45a52836f8ad1127", "6095abdf45a52836f8ad1128", "6095abdf45a52836f8ad1129", "6095abdf45a52836f8ad112a", "6095abdf45a52836f8ad112b", "6095abdf45a52836f8ad112c", "6095abdf45a52836f8ad112d", "6095abdf45a52836f8ad112e", "6095abdf45a52836f8ad112f", "6095abdf45a52836f8ad1130", "6095abdf45a52836f8ad1131", "6095abdf45a52836f8ad1132", "6095abdf45a52836f8ad1133", "6095abdf45a52836f8ad1134", "6095abdf45a52836f8ad1135", "6095abdf45a52836f8ad1136", "6095abdf45a52836f8ad1137", "6095abdf45a52836f8ad1138", "6095abdf45a52836f8ad1139", "6095abdf45a52836f8ad113a", "6095abdf45a52836f8ad113b", "6095abdf45a52836f8ad113c", "6095abdf45a52836f8ad113d", "6095abdf45a52836f8ad113e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abef45a52836f8ad153c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "I C",
            "brand_key": "i-c",
            "createdAt": "2021-05-07T21:06:55.208Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30438
        },
        "createdAt": "2021-05-07T21:06:55.231Z",
        "updatedAt": "2021-05-07T21:06:55.231Z"
    }, {
        "_id": "6095abef45a52836f8ad153f",
        "products": ["6095abdf45a52836f8ad113f", "6095abdf45a52836f8ad1140", "6095abdf45a52836f8ad1141"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abef45a52836f8ad153e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "III Sisters Of Nature",
            "brand_key": "iii-sisters-of-nature",
            "createdAt": "2021-05-07T21:06:55.290Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30439
        },
        "createdAt": "2021-05-07T21:06:55.313Z",
        "updatedAt": "2021-05-07T21:06:55.313Z"
    }, {
        "_id": "6095abef45a52836f8ad1541",
        "products": ["6095abdf45a52836f8ad1142", "6095abdf45a52836f8ad1143"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abef45a52836f8ad1540",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Inahsi Naturals",
            "brand_key": "inahsi naturals",
            "createdAt": "2021-05-07T21:06:55.374Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30440
        },
        "createdAt": "2021-05-07T21:06:55.396Z",
        "updatedAt": "2021-05-07T21:06:55.396Z"
    }, {
        "_id": "6095abef45a52836f8ad1541",
        "products": ["6095abdf45a52836f8ad1142", "6095abdf45a52836f8ad1143"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abef45a52836f8ad1540",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "inecto",
            "brand_key": "inecto",
            "createdAt": "2021-05-07T21:06:55.374Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30440
        },
        "createdAt": "2021-05-07T21:06:55.396Z",
        "updatedAt": "2021-05-07T21:06:55.396Z"
    }
             , {
        "_id": "6095abef45a52836f8ad1541",
        "products": ["6095abdf45a52836f8ad1142", "6095abdf45a52836f8ad1143"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abef45a52836f8ad1540",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "IKB",
            "brand_key": "ikb",
            "createdAt": "2021-05-07T21:06:55.374Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30440
        },
        "createdAt": "2021-05-07T21:06:55.396Z",
        "updatedAt": "2021-05-07T21:06:55.396Z"
    }, {
        "_id": "6095abef45a52836f8ad1543",
        "products": ["6095abdf45a52836f8ad1144", "6095abdf45a52836f8ad1145", "6095abdf45a52836f8ad1146", "6095abdf45a52836f8ad1147", "6095abdf45a52836f8ad1148", "6095abdf45a52836f8ad1149", "6095abdf45a52836f8ad114a", "6095abdf45a52836f8ad114b", "6095abdf45a52836f8ad114c", "6095abdf45a52836f8ad114d", "6095abdf45a52836f8ad114e", "6095abdf45a52836f8ad114f", "6095abdf45a52836f8ad1150", "6095abdf45a52836f8ad1151", "6095abdf45a52836f8ad1152", "6095abdf45a52836f8ad1153", "6095abdf45a52836f8ad1154", "6095abdf45a52836f8ad1155", "6095abdf45a52836f8ad1156", "6095ac0145a52836f8ad1a98", "6095ac0145a52836f8ad1a99", "6095ac0145a52836f8ad1a9a", "6095ac0145a52836f8ad1a9b", "6095ac0145a52836f8ad1a9c", "6095ac0145a52836f8ad1a9d", "6095ac0145a52836f8ad1a9e", "6095ac0145a52836f8ad1a9f", "6095ac0145a52836f8ad1aa0", "6095ac0145a52836f8ad1aa1", "6095ac0145a52836f8ad1aa2", "6095ac0145a52836f8ad1aa3", "6095ac0145a52836f8ad1aa4", "6095ac0145a52836f8ad1aa5", "6095ac0145a52836f8ad1aa6", "6095ac0145a52836f8ad1aa7", "6095ac0145a52836f8ad1aa8"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abef45a52836f8ad1542",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Victorus Lashes",
            "brand_key": "victorus-lashes",
            "createdAt": "2021-05-07T21:06:55.456Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30441
        },
        "createdAt": "2021-05-07T21:06:55.478Z",
        "updatedAt": "2021-05-07T21:09:28.583Z"
    }, {
        "_id": "6095abef45a52836f8ad1545",
        "products": ["6095abdf45a52836f8ad1157", "6095abdf45a52836f8ad1158", "6095abdf45a52836f8ad1159", "6095abdf45a52836f8ad115a", "6095abdf45a52836f8ad115b", "6095abdf45a52836f8ad115c", "6095abdf45a52836f8ad115d", "6095abe445a52836f8ad115e", "6095abe445a52836f8ad115f", "6095abe445a52836f8ad1160", "6095abe445a52836f8ad1161", "6095abe445a52836f8ad1162", "6095abe445a52836f8ad1163", "6095abe445a52836f8ad1164", "6095abe445a52836f8ad1165", "6095abe445a52836f8ad1166", "6095abe445a52836f8ad1167", "6095abe445a52836f8ad1168", "6095abe445a52836f8ad1169", "6095abe445a52836f8ad116a", "6095abe445a52836f8ad116b", "6095abe445a52836f8ad116c", "6095abe445a52836f8ad116d", "6095abe445a52836f8ad116e", "6095abe445a52836f8ad116f"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abef45a52836f8ad1544",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "IKOO",
            "brand_key": "IKOO",
            "createdAt": "2021-05-07T21:06:55.535Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30442
        },
        "createdAt": "2021-05-07T21:06:55.557Z",
        "updatedAt": "2021-05-07T21:09:15.389Z"
    }, {
        "_id": "6095abef45a52836f8ad1545",
        "products": ["6095abdf45a52836f8ad1157", "6095abdf45a52836f8ad1158", "6095abdf45a52836f8ad1159", "6095abdf45a52836f8ad115a", "6095abdf45a52836f8ad115b", "6095abdf45a52836f8ad115c", "6095abdf45a52836f8ad115d", "6095abe445a52836f8ad115e", "6095abe445a52836f8ad115f", "6095abe445a52836f8ad1160", "6095abe445a52836f8ad1161", "6095abe445a52836f8ad1162", "6095abe445a52836f8ad1163", "6095abe445a52836f8ad1164", "6095abe445a52836f8ad1165", "6095abe445a52836f8ad1166", "6095abe445a52836f8ad1167", "6095abe445a52836f8ad1168", "6095abe445a52836f8ad1169", "6095abe445a52836f8ad116a", "6095abe445a52836f8ad116b", "6095abe445a52836f8ad116c", "6095abe445a52836f8ad116d", "6095abe445a52836f8ad116e", "6095abe445a52836f8ad116f"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095abef45a52836f8ad1544",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Innersense",
            "brand_key": "innersense",
            "createdAt": "2021-05-07T21:06:55.535Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30442
        },
        "createdAt": "2021-05-07T21:06:55.557Z",
        "updatedAt": "2021-05-07T21:09:15.389Z"
    }, {
        "_id": "6095ac7b45a52836f8ad1e29",
        "products": ["6095abe445a52836f8ad1170", "6095abe445a52836f8ad1171"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7b45a52836f8ad1e28",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Jaguar",
            "brand_key": "jaguar",
            "createdAt": "2021-05-07T21:09:15.470Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30443
        },
        "createdAt": "2021-05-07T21:09:15.496Z",
        "updatedAt": "2021-05-07T21:09:15.496Z"
    }, {
        "_id": "6095ac7b45a52836f8ad1e2b",
        "products": ["6095abe445a52836f8ad1172", "6095abfe45a52836f8ad19b6", "6095abfe45a52836f8ad19b7", "6095abfe45a52836f8ad19b8", "6095abfe45a52836f8ad19b9", "6095abfe45a52836f8ad19ba", "6095abfe45a52836f8ad19bb", "6095abfe45a52836f8ad19bc", "6095abfe45a52836f8ad19bd", "6095abfe45a52836f8ad19be", "6095abfe45a52836f8ad19bf", "6095abfe45a52836f8ad19c0", "6095abfe45a52836f8ad19c1", "6095abfe45a52836f8ad19c2", "6095abfe45a52836f8ad19c3", "6095abfe45a52836f8ad19c4", "6095abfe45a52836f8ad19c5", "6095abfe45a52836f8ad19c6", "6095abfe45a52836f8ad19c7", "6095abfe45a52836f8ad19c8", "6095abfe45a52836f8ad19c9", "6095abfe45a52836f8ad19ca", "6095abfe45a52836f8ad19cb", "6095abfe45a52836f8ad19cc", "6095abfe45a52836f8ad19cd", "6095abfe45a52836f8ad19ce", "6095abfe45a52836f8ad19cf"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7b45a52836f8ad1e2a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Sunny Isle",
            "brand_key": "sunny-isle",
            "createdAt": "2021-05-07T21:09:15.565Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30444
        },
        "createdAt": "2021-05-07T21:09:15.591Z",
        "updatedAt": "2021-05-07T21:09:15.591Z"
    }, {
        "_id": "6095ac7b45a52836f8ad1e2d",
        "products": ["6095abe445a52836f8ad1173", "6095abe445a52836f8ad1174", "6095abe445a52836f8ad1175", "6095abe445a52836f8ad1176", "6095abe445a52836f8ad1177", "6095abe445a52836f8ad1178", "6095abe445a52836f8ad1179", "6095abe445a52836f8ad117a", "6095abe445a52836f8ad117b", "6095abe445a52836f8ad117c", "6095abe445a52836f8ad117d", "6095abe445a52836f8ad117e", "6095abe445a52836f8ad117f", "6095abe445a52836f8ad1180", "6095abe445a52836f8ad1181", "6095abe445a52836f8ad1182", "6095abe445a52836f8ad1183", "6095abe445a52836f8ad1184", "6095abe445a52836f8ad1185", "6095abe445a52836f8ad1186", "6095abe445a52836f8ad1187", "6095abe445a52836f8ad1188", "6095abe445a52836f8ad1189", "6095abe445a52836f8ad118a", "6095abe445a52836f8ad118b", "6095abe445a52836f8ad118c", "6095abe445a52836f8ad118d", "6095abe445a52836f8ad118e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7b45a52836f8ad1e2c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Jamaican Mango & Lime",
            "brand_key": "jamaican-mango-&-lime",
            "createdAt": "2021-05-07T21:09:15.653Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30445
        },
        "createdAt": "2021-05-07T21:09:15.679Z",
        "updatedAt": "2021-05-07T21:09:15.679Z"
    }, {
        "_id": "6095ac7b45a52836f8ad1e2f",
        "products": ["6095abe445a52836f8ad118f", "6095abe445a52836f8ad1190", "6095abe445a52836f8ad1191", "6095abe445a52836f8ad1192", "6095abe445a52836f8ad1193", "6095abe445a52836f8ad1194", "6095abe445a52836f8ad1195", "6095abe445a52836f8ad1196", "6095abe445a52836f8ad1197", "6095abe445a52836f8ad1198", "6095abe445a52836f8ad1199", "6095abe445a52836f8ad119a", "6095abe445a52836f8ad119b", "6095abe445a52836f8ad119c", "6095abe445a52836f8ad119d", "6095abe445a52836f8ad119e", "6095abe445a52836f8ad119f", "6095abe445a52836f8ad11a0", "6095abe445a52836f8ad11a1", "6095abe445a52836f8ad11a2"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7b45a52836f8ad1e2e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Jane Carter",
            "brand_key": "jane-carter",
            "createdAt": "2021-05-07T21:09:15.739Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30446
        },
        "createdAt": "2021-05-07T21:09:15.761Z",
        "updatedAt": "2021-05-07T21:09:15.761Z"
    }, {
        "_id": "6095ac7b45a52836f8ad1e31",
        "products": ["6095abe445a52836f8ad11a3", "6095abe445a52836f8ad11a4", "6095abe445a52836f8ad11a5", "6095abe445a52836f8ad11a6", "6095abe445a52836f8ad11a7", "6095abe445a52836f8ad11a8", "6095abe445a52836f8ad11a9"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7b45a52836f8ad1e30",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Jergens",
            "brand_key": "jergens",
            "createdAt": "2021-05-07T21:09:15.820Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30447
        },
        "createdAt": "2021-05-07T21:09:15.843Z",
        "updatedAt": "2021-05-07T21:09:15.843Z"
    }, {
        "_id": "6095ac7b45a52836f8ad1e33",
        "products": ["6095abe445a52836f8ad11aa", "6095abe445a52836f8ad11ab", "6095abe445a52836f8ad11ac", "6095abe445a52836f8ad11ad", "6095abe445a52836f8ad11ae", "6095abe445a52836f8ad11af", "6095abe445a52836f8ad11b0", "6095abe445a52836f8ad11b1", "6095abe445a52836f8ad11b2", "6095abe445a52836f8ad11b3", "6095abe445a52836f8ad11b4", "6095abe445a52836f8ad11b5", "6095abe445a52836f8ad11b6", "6095abe445a52836f8ad11b7", "6095abe445a52836f8ad11b8", "6095abe445a52836f8ad11b9", "6095abe445a52836f8ad11ba", "6095abe445a52836f8ad11bb", "6095abe445a52836f8ad11bc", "6095abe445a52836f8ad11bd", "6095abe445a52836f8ad11be", "6095abe445a52836f8ad11bf", "6095abe445a52836f8ad11c0", "6095abe445a52836f8ad11c1", "6095abe445a52836f8ad11c2", "6095abe445a52836f8ad11c3", "6095abe445a52836f8ad11c4", "6095abe445a52836f8ad11c5"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7b45a52836f8ad1e32",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Jessicurl",
            "brand_key": "jessicurl",
            "createdAt": "2021-05-07T21:09:15.905Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30448
        },
        "createdAt": "2021-05-07T21:09:15.927Z",
        "updatedAt": "2021-05-07T21:09:15.927Z"
    }, {
        "_id": "6095ac7c45a52836f8ad1e35",
        "products": ["6095abe445a52836f8ad11c6", "6095abe445a52836f8ad11c7", "6095abe445a52836f8ad11c8"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7b45a52836f8ad1e34",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "John Masters Organics",
            "brand_key": "john-masters-organics",
            "createdAt": "2021-05-07T21:09:15.989Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30449
        },
        "createdAt": "2021-05-07T21:09:16.014Z",
        "updatedAt": "2021-05-07T21:09:16.014Z"
    }, {
        "_id": "6095ac7c45a52836f8ad1e37",
        "products": ["6095abe445a52836f8ad11c9", "6095abe445a52836f8ad11ca", "6095abe445a52836f8ad11cb", "6095abe445a52836f8ad11cc", "6095abe445a52836f8ad11cd", "6095abe445a52836f8ad11ce", "6095abe445a52836f8ad11cf", "6095abe445a52836f8ad11d0"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7c45a52836f8ad1e36",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Johnson & Johnson",
            "brand_key": "johnson-&-johnson",
            "createdAt": "2021-05-07T21:09:16.083Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30450
        },
        "createdAt": "2021-05-07T21:09:16.106Z",
        "updatedAt": "2021-05-07T21:09:16.106Z"
    }, {
        "_id": "6095ac7c45a52836f8ad1e39",
        "products": ["6095abe445a52836f8ad11d1", "6095abe445a52836f8ad11d2", "6095abe445a52836f8ad11d3", "6095abe445a52836f8ad11d4", "6095abe445a52836f8ad11d5", "6095abe445a52836f8ad11d6"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7c45a52836f8ad1e38",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Gentletreatment",
            "brand_key": "gentletreatment",
            "createdAt": "2021-05-07T21:09:16.167Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30451
        },
        "createdAt": "2021-05-07T21:09:16.191Z",
        "updatedAt": "2021-05-07T21:09:16.191Z"
    }, {
        "_id": "6095ac7c45a52836f8ad1e3b",
        "products": ["6095abe445a52836f8ad11d7", "6095abe445a52836f8ad11d8", "6095abe445a52836f8ad11d9", "6095abe445a52836f8ad11da", "6095abe445a52836f8ad11db", "6095abe445a52836f8ad11dc", "6095abe445a52836f8ad11dd", "6095abe445a52836f8ad11de", "6095abe445a52836f8ad11df", "6095abe445a52836f8ad11e0", "6095abe445a52836f8ad11e1", "6095abe445a52836f8ad11e2", "6095abe445a52836f8ad11e3", "6095abe445a52836f8ad11e4", "6095abe445a52836f8ad11e5", "6095abe445a52836f8ad11e6", "6095abe445a52836f8ad11e7", "6095abe445a52836f8ad11e8"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7c45a52836f8ad1e3a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Just for Me",
            "brand_key": "just-for-me",
            "createdAt": "2021-05-07T21:09:16.249Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30452
        },
        "createdAt": "2021-05-07T21:09:16.270Z",
        "updatedAt": "2021-05-07T21:09:16.270Z"
    }, {
        "_id": "6095ac7c45a52836f8ad1e3d",
        "products": ["6095abe445a52836f8ad11e9", "6095abe445a52836f8ad11ea", "6095abe445a52836f8ad11eb"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7c45a52836f8ad1e3c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Just For Men",
            "brand_key": "just-for-men",
            "createdAt": "2021-05-07T21:09:16.333Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30453
        },
        "createdAt": "2021-05-07T21:09:16.354Z",
        "updatedAt": "2021-05-07T21:09:16.354Z"
    }, {
        "_id": "6095ac7c45a52836f8ad1e3f",
        "products": ["6095abe445a52836f8ad11ec", "6095abe445a52836f8ad11ed", "6095abe445a52836f8ad11ee", "6095abe445a52836f8ad11ef", "6095abe445a52836f8ad11f0", "6095abe445a52836f8ad11f1", "6095abe445a52836f8ad11f2", "6095abe445a52836f8ad11f3", "6095abe445a52836f8ad11f4", "6095abe445a52836f8ad11f5", "6095abe445a52836f8ad11f6", "6095abe445a52836f8ad11f7", "6095abe445a52836f8ad11f8", "6095abe445a52836f8ad11f9", "6095abe445a52836f8ad11fa", "6095abe445a52836f8ad11fb", "6095abe445a52836f8ad11fc", "6095abe445a52836f8ad11fd", "6095abe445a52836f8ad11fe", "6095abe445a52836f8ad11ff", "6095abe445a52836f8ad1200", "6095abe445a52836f8ad1201", "6095abe445a52836f8ad1202", "6095abe445a52836f8ad1203", "6095abe445a52836f8ad1204", "6095abe445a52836f8ad1205", "6095abe445a52836f8ad1206", "6095abe445a52836f8ad1207", "6095abe445a52836f8ad1208", "6095abe445a52836f8ad1209", "6095abe445a52836f8ad120a", "6095abe445a52836f8ad120b", "6095abe445a52836f8ad120c", "6095abe445a52836f8ad120d", "6095abe445a52836f8ad120e", "6095abe445a52836f8ad120f", "6095abe445a52836f8ad1210", "6095abe445a52836f8ad1211", "6095abe445a52836f8ad1212", "6095abe445a52836f8ad1213", "6095abe445a52836f8ad1214", "6095abe445a52836f8ad1215", "6095abe445a52836f8ad1216", "6095abe445a52836f8ad1217", "6095abe445a52836f8ad1218", "6095abe445a52836f8ad1219", "6095abe445a52836f8ad121a", "6095abe445a52836f8ad121b", "6095abe445a52836f8ad121c", "6095abe445a52836f8ad121d", "6095abe445a52836f8ad121e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7c45a52836f8ad1e3e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "KeraCare",
            "brand_key": "keracare",
            "createdAt": "2021-05-07T21:09:16.412Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30454
        },
        "createdAt": "2021-05-07T21:09:16.434Z",
        "updatedAt": "2021-05-07T21:09:16.434Z"
    }, {
        "_id": "6095ac7c45a52836f8ad1e41",
        "products": ["6095abe445a52836f8ad121f", "6095abe445a52836f8ad1220", "6095abe445a52836f8ad1221", "6095abe445a52836f8ad1222", "6095abe445a52836f8ad1223", "6095abe445a52836f8ad1224", "6095abe445a52836f8ad1225", "6095abe445a52836f8ad1226", "6095abe445a52836f8ad1227", "6095abe445a52836f8ad1228"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7c45a52836f8ad1e40",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Kids Organics",
            "brand_key": "kids-organics",
            "createdAt": "2021-05-07T21:09:16.492Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30455
        },
        "createdAt": "2021-05-07T21:09:16.513Z",
        "updatedAt": "2021-05-07T21:09:16.513Z"
    }, {
        "_id": "6095ac7c45a52836f8ad1e43",
        "products": ["6095abe445a52836f8ad122a", "6095abe445a52836f8ad122b", "6095abe445a52836f8ad122c", "6095abe445a52836f8ad122d", "6095abe445a52836f8ad122e", "6095abe445a52836f8ad122f", "6095abe445a52836f8ad1230", "6095abe445a52836f8ad1231", "6095abe445a52836f8ad1232", "6095abe445a52836f8ad1233"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7c45a52836f8ad1e42",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Kinky Curly",
            "brand_key": "kinky-curly",
            "createdAt": "2021-05-07T21:09:16.631Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30456
        },
        "createdAt": "2021-05-07T21:09:16.654Z",
        "updatedAt": "2021-05-07T21:09:16.654Z"
    }, {
        "_id": "6095ac7c45a52836f8ad1e45",
        "products": ["6095abe445a52836f8ad1234", "6095abe445a52836f8ad1235", "6095abe445a52836f8ad1236", "6095abe445a52836f8ad1237", "6095abe445a52836f8ad1238", "6095abe445a52836f8ad1239", "6095abe445a52836f8ad123a", "6095abe445a52836f8ad123b", "6095abe445a52836f8ad123c"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7c45a52836f8ad1e44",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Kiss",
            "brand_key": "kiss",
            "createdAt": "2021-05-07T21:09:16.711Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30457
        },
        "createdAt": "2021-05-07T21:09:16.733Z",
        "updatedAt": "2021-05-07T21:09:16.733Z"
    }, {
        "_id": "6095ac7c45a52836f8ad1e47",
        "products": ["6095abe445a52836f8ad123d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7c45a52836f8ad1e46",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "KTC",
            "brand_key": "ktc",
            "createdAt": "2021-05-07T21:09:16.790Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30458
        },
        "createdAt": "2021-05-07T21:09:16.811Z",
        "updatedAt": "2021-05-07T21:09:16.811Z"
    }, {
        "_id": "6095ac7c45a52836f8ad1e47",
        "products": ["6095abe445a52836f8ad123d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7c45a52836f8ad1e46",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Kuknus Collection",
            "brand_key": "Kuknus Collection",
            "createdAt": "2021-05-07T21:09:16.790Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30458
        },
        "createdAt": "2021-05-07T21:09:16.811Z",
        "updatedAt": "2021-05-07T21:09:16.811Z"
    }, {
        "_id": "6095ac7c45a52836f8ad1e49",
        "products": ["6095abe445a52836f8ad1246", "6095abe445a52836f8ad1247", "6095abe445a52836f8ad1248", "6095abe445a52836f8ad1249", "6095abe445a52836f8ad124a"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7c45a52836f8ad1e48",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "L&K",
            "brand_key": "l&k",
            "createdAt": "2021-05-07T21:09:16.923Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30459
        },
        "createdAt": "2021-05-07T21:09:16.946Z",
        "updatedAt": "2021-05-07T21:09:16.946Z"
    }, {
        "_id": "6095ac7d45a52836f8ad1e4b",
        "products": ["6095abe445a52836f8ad124b", "6095abe445a52836f8ad124c", "6095abe445a52836f8ad124d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7d45a52836f8ad1e4a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "L'ACTION",
            "brand_key": "l'action",
            "createdAt": "2021-05-07T21:09:17.009Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30460
        },
        "createdAt": "2021-05-07T21:09:17.030Z",
        "updatedAt": "2021-05-07T21:09:17.030Z"
    }, {
        "_id": "6095ac7d45a52836f8ad1e4b",
        "products": ["6095abe445a52836f8ad124b", "6095abe445a52836f8ad124c", "6095abe445a52836f8ad124d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7d45a52836f8ad1e4a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "L'Oréal Professionnel",
            "brand_key": "L'Oréal Professionnel",
            "createdAt": "2021-05-07T21:09:17.009Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30460
        },
        "createdAt": "2021-05-07T21:09:17.030Z",
        "updatedAt": "2021-05-07T21:09:17.030Z"
    },{
        "_id": "6095ac7d45a52836f8ad1e4d",
        "products": ["6095abe445a52836f8ad124e", "6095abe445a52836f8ad124f", "6095abe445a52836f8ad1250", "6095abe445a52836f8ad1251", "6095abe445a52836f8ad1252", "6095abe445a52836f8ad1253", "6095abe445a52836f8ad1254", "6095abe445a52836f8ad1255", "6095abe445a52836f8ad1256", "6095abe445a52836f8ad1257", "6095abe845a52836f8ad12b4", "6095abe845a52836f8ad12b5", "6095abe845a52836f8ad12b6", "6095abe845a52836f8ad12b7", "6095abe845a52836f8ad12b8", "6095abe845a52836f8ad12b9", "6095abe845a52836f8ad12ba", "6095abe845a52836f8ad12bb", "6095abe845a52836f8ad12bc", "6095abe845a52836f8ad12bd", "6095abe845a52836f8ad12be", "6095abe845a52836f8ad12bf", "6095abe845a52836f8ad12c0", "6095abe845a52836f8ad12c1", "6095abe845a52836f8ad12c2", "6095abe845a52836f8ad12c3", "6095abe845a52836f8ad12c4", "6095abe845a52836f8ad12c5", "6095abe845a52836f8ad12c6", "6095abe845a52836f8ad12c7", "6095abe845a52836f8ad12c8", "6095abe845a52836f8ad12c9", "6095abe845a52836f8ad12ca", "6095abe845a52836f8ad12cb", "6095abe845a52836f8ad12cc", "6095abe845a52836f8ad12cd", "6095abe845a52836f8ad12ce", "6095abe845a52836f8ad12cf", "6095abe845a52836f8ad12d0", "6095abe845a52836f8ad12d1", "6095abe845a52836f8ad12d2", "6095abe845a52836f8ad12d3", "6095abe845a52836f8ad12d4", "6095abe845a52836f8ad12d5", "6095abe845a52836f8ad12d6", "6095abe845a52836f8ad12d7", "6095abe845a52836f8ad12d8", "6095abe845a52836f8ad12d9", "6095abe845a52836f8ad12da", "6095abe845a52836f8ad12db", "6095abe845a52836f8ad12dc", "6095abe845a52836f8ad12dd", "6095abe845a52836f8ad12de", "6095abe845a52836f8ad12df", "6095abe845a52836f8ad12e0", "6095abe845a52836f8ad12e1", "6095abe845a52836f8ad12e2", "6095abe845a52836f8ad12e3", "6095abe845a52836f8ad12e4", "6095abe845a52836f8ad12e5", "6095abe845a52836f8ad12e6", "6095abe845a52836f8ad12e7", "6095abe845a52836f8ad12e8", "6095abe845a52836f8ad12e9", "6095abe845a52836f8ad12ea", "6095abe845a52836f8ad12eb", "6095abe845a52836f8ad12ec", "6095abe845a52836f8ad12ed", "6095abe845a52836f8ad12ee", "6095abe845a52836f8ad12ef", "6095abe845a52836f8ad12f0", "6095abe845a52836f8ad12f1", "6095abe845a52836f8ad12f2", "6095abe845a52836f8ad12f3", "6095abe845a52836f8ad12f4", "6095abe845a52836f8ad12f5", "6095abe845a52836f8ad12f6", "6095abe845a52836f8ad12f7", "6095abe845a52836f8ad12f8", "6095abe845a52836f8ad12f9", "6095abe845a52836f8ad12fa", "6095abe845a52836f8ad12fb", "6095abe845a52836f8ad12fc", "6095abe845a52836f8ad12fd", "6095abe845a52836f8ad12fe", "6095abe845a52836f8ad12ff", "6095abe845a52836f8ad1300", "6095abe845a52836f8ad1301", "6095abe845a52836f8ad1302", "6095abe845a52836f8ad1303", "6095abe845a52836f8ad1304", "6095abe845a52836f8ad1305", "6095abe845a52836f8ad1306", "6095abe845a52836f8ad1307", "6095abe845a52836f8ad1308", "6095abe845a52836f8ad1309", "6095abe845a52836f8ad130a", "6095abe845a52836f8ad130b", "6095abe845a52836f8ad130c", "6095abe845a52836f8ad130d", "6095abe845a52836f8ad130e", "6095abe845a52836f8ad130f", "6095abe845a52836f8ad1310", "6095abe845a52836f8ad1311", "6095abe845a52836f8ad1312", "6095abe845a52836f8ad1313", "6095abe845a52836f8ad1314", "6095abe845a52836f8ad1315", "6095abe845a52836f8ad1316", "6095abe845a52836f8ad1317", "6095abe845a52836f8ad1318", "6095abe845a52836f8ad1319", "6095abe845a52836f8ad131a", "6095abe845a52836f8ad131b", "6095abe845a52836f8ad131c", "6095abe845a52836f8ad131d", "6095abe845a52836f8ad131e", "6095abe845a52836f8ad131f", "6095abe845a52836f8ad1320", "6095abe845a52836f8ad1321", "6095abe845a52836f8ad1322", "6095abe845a52836f8ad1323", "6095abe845a52836f8ad1324", "6095abe845a52836f8ad1325", "6095abe845a52836f8ad1326", "6095abe845a52836f8ad1327", "6095abe845a52836f8ad1328", "6095abe845a52836f8ad1329", "6095abe845a52836f8ad132a", "6095abe845a52836f8ad132b", "6095abe845a52836f8ad132c", "6095abe845a52836f8ad132d", "6095abe845a52836f8ad132e", "6095abe845a52836f8ad132f", "6095abe845a52836f8ad1330", "6095abe845a52836f8ad1331", "6095abe845a52836f8ad1332", "6095abe845a52836f8ad1333", "6095abe845a52836f8ad1334", "6095abe845a52836f8ad1335", "6095abe845a52836f8ad1336", "6095abe845a52836f8ad1337", "6095abe845a52836f8ad1338", "6095abe845a52836f8ad1339", "6095abe845a52836f8ad133a", "6095abe845a52836f8ad133b", "6095abe845a52836f8ad133c", "6095abe845a52836f8ad133d", "6095abe845a52836f8ad133e", "6095abe845a52836f8ad133f", "6095abe845a52836f8ad1340", "6095abe845a52836f8ad1341", "6095abe845a52836f8ad1342", "6095abe845a52836f8ad1343", "6095abe845a52836f8ad1344", "6095abe845a52836f8ad1345", "6095abe845a52836f8ad1346", "6095abe845a52836f8ad1347", "6095abe845a52836f8ad1348", "6095abe845a52836f8ad1349", "6095abe845a52836f8ad134a", "6095abe845a52836f8ad134b", "6095abe845a52836f8ad134c", "6095abe845a52836f8ad134d", "6095abe845a52836f8ad134e", "6095abe845a52836f8ad134f", "6095abe845a52836f8ad1350", "6095abe845a52836f8ad1351", "6095abe845a52836f8ad1352", "6095abe845a52836f8ad1353", "6095abe845a52836f8ad1354", "6095abe845a52836f8ad1355", "6095abe845a52836f8ad1356", "6095abe845a52836f8ad1357", "6095abe845a52836f8ad1358", "6095abe845a52836f8ad1359", "6095abe845a52836f8ad135a", "6095abe845a52836f8ad135b", "6095abe845a52836f8ad135c", "6095abe845a52836f8ad135d", "6095abe845a52836f8ad135e", "6095abe845a52836f8ad135f", "6095abe845a52836f8ad1360", "6095abe845a52836f8ad1361", "6095abe845a52836f8ad1362", "6095abe845a52836f8ad1363", "6095abe845a52836f8ad1364", "6095abe845a52836f8ad1365", "6095abe845a52836f8ad1366", "6095abe845a52836f8ad1367", "6095abe845a52836f8ad1368", "6095abe845a52836f8ad1369", "6095abe845a52836f8ad136a", "6095abe845a52836f8ad136b", "6095abe845a52836f8ad136c", "6095abe845a52836f8ad136d", "6095abe845a52836f8ad136e", "6095abe845a52836f8ad136f", "6095abe845a52836f8ad1370", "6095abe845a52836f8ad1371", "6095abe845a52836f8ad1372", "6095abe845a52836f8ad1373", "6095abe845a52836f8ad1374", "6095abe845a52836f8ad1375", "6095abe845a52836f8ad1376", "6095abe845a52836f8ad1377", "6095abe845a52836f8ad1378", "6095abe845a52836f8ad1379", "6095abe845a52836f8ad137a", "6095abe845a52836f8ad137b", "6095abe845a52836f8ad137c", "6095abe845a52836f8ad137d", "6095abe845a52836f8ad137e", "6095abe845a52836f8ad137f", "6095abe845a52836f8ad1380", "6095abe845a52836f8ad1381", "6095abe845a52836f8ad1382", "6095abe845a52836f8ad1383", "6095abe845a52836f8ad1384", "6095abe845a52836f8ad1385", "6095abe845a52836f8ad1386", "6095abe845a52836f8ad1387", "6095abe845a52836f8ad1388", "6095abe845a52836f8ad1389", "6095abe845a52836f8ad138a", "6095abe845a52836f8ad138b", "6095abe845a52836f8ad138c", "6095abe845a52836f8ad138d", "6095abe845a52836f8ad138e", "6095abe845a52836f8ad138f", "6095abe845a52836f8ad1390", "6095abe845a52836f8ad1391", "6095abe845a52836f8ad1392", "6095abe845a52836f8ad1393", "6095abe845a52836f8ad1394", "6095abe845a52836f8ad1395", "6095abe845a52836f8ad1396", "6095abe845a52836f8ad1397", "6095abe845a52836f8ad1398", "6095abe845a52836f8ad1399", "6095abe845a52836f8ad139a", "6095abe845a52836f8ad139b", "6095abe845a52836f8ad139c", "6095abe845a52836f8ad139d", "6095abe845a52836f8ad139e", "6095abe845a52836f8ad139f", "6095abe845a52836f8ad13a0", "6095abe845a52836f8ad13a1", "6095abe845a52836f8ad13a2", "6095abe845a52836f8ad13a3", "6095abe845a52836f8ad13a4", "6095abe845a52836f8ad13a5", "6095abe845a52836f8ad13a6", "6095abe845a52836f8ad13a7", "6095abe845a52836f8ad13a8", "6095abe845a52836f8ad13a9", "6095abe845a52836f8ad13aa", "6095abe845a52836f8ad13ab", "6095abe845a52836f8ad13ac", "6095abe845a52836f8ad13ad", "6095abec45a52836f8ad1400", "6095abec45a52836f8ad1401", "6095abec45a52836f8ad1402", "6095abec45a52836f8ad1403", "6095abec45a52836f8ad1404", "6095abec45a52836f8ad1405", "6095abec45a52836f8ad1406", "6095abec45a52836f8ad1407", "6095abec45a52836f8ad1408", "6095abec45a52836f8ad1409", "6095abec45a52836f8ad140a", "6095abec45a52836f8ad140b", "6095abec45a52836f8ad140c", "6095abec45a52836f8ad140d", "6095abec45a52836f8ad140e", "6095abec45a52836f8ad140f", "6095abec45a52836f8ad1410", "6095abec45a52836f8ad1411", "6095abec45a52836f8ad1412", "6095abec45a52836f8ad1413", "6095abec45a52836f8ad1414", "6095abec45a52836f8ad1415", "6095abec45a52836f8ad1416", "6095abec45a52836f8ad1417", "6095abec45a52836f8ad1418", "6095abec45a52836f8ad1419", "6095abec45a52836f8ad141a", "6095abec45a52836f8ad141b", "6095abec45a52836f8ad141c", "6095abec45a52836f8ad141d", "6095abec45a52836f8ad141e", "6095abec45a52836f8ad141f", "6095abec45a52836f8ad1420", "6095abec45a52836f8ad1421", "6095abec45a52836f8ad1422", "6095abec45a52836f8ad1423", "6095abec45a52836f8ad1424", "6095abec45a52836f8ad1425", "6095abec45a52836f8ad1426", "6095abec45a52836f8ad1427", "6095abec45a52836f8ad1428", "6095abec45a52836f8ad1429", "6095abec45a52836f8ad142a", "6095abec45a52836f8ad142b", "6095abec45a52836f8ad142c", "6095abec45a52836f8ad142d", "6095abec45a52836f8ad142e", "6095abec45a52836f8ad142f", "6095abec45a52836f8ad1430", "6095abec45a52836f8ad1431", "6095abec45a52836f8ad1432", "6095abec45a52836f8ad1433", "6095abec45a52836f8ad1434", "6095abec45a52836f8ad1435", "6095abec45a52836f8ad1436", "6095abec45a52836f8ad1437", "6095abec45a52836f8ad1438", "6095abec45a52836f8ad1439", "6095abec45a52836f8ad143a", "6095abec45a52836f8ad143b", "6095abec45a52836f8ad143c", "6095abec45a52836f8ad143d", "6095abec45a52836f8ad143e", "6095abec45a52836f8ad143f", "6095abec45a52836f8ad1440", "6095abec45a52836f8ad1441", "6095abec45a52836f8ad1442", "6095abec45a52836f8ad1443", "6095abec45a52836f8ad1444", "6095abec45a52836f8ad1445", "6095abec45a52836f8ad1446", "6095abec45a52836f8ad1447", "6095abec45a52836f8ad1448", "6095abec45a52836f8ad1449", "6095abec45a52836f8ad144a", "6095abec45a52836f8ad144b", "6095abec45a52836f8ad144c", "6095abec45a52836f8ad144d", "6095abec45a52836f8ad144e", "6095abec45a52836f8ad144f", "6095abec45a52836f8ad1450", "6095abec45a52836f8ad1451", "6095abec45a52836f8ad1452", "6095abec45a52836f8ad1453", "6095abec45a52836f8ad1454", "6095abec45a52836f8ad1455"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7d45a52836f8ad1e4c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "LA Girl MakeUp",
            "brand_key": "la-girl-makeup",
            "createdAt": "2021-05-07T21:09:17.089Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30461
        },
        "createdAt": "2021-05-07T21:09:17.123Z",
        "updatedAt": "2021-05-07T21:09:17.123Z"
    }, {
        "_id": "6095ac7d45a52836f8ad1e4f",
        "products": ["6095abec45a52836f8ad1456", "6095abec45a52836f8ad1457", "6095abec45a52836f8ad1458", "6095abec45a52836f8ad1459", "6095abec45a52836f8ad145a", "6095abec45a52836f8ad145b", "6095abec45a52836f8ad145c", "6095abec45a52836f8ad145d", "6095abec45a52836f8ad145e", "6095abec45a52836f8ad145f", "6095abec45a52836f8ad1460", "6095abec45a52836f8ad1461", "6095abec45a52836f8ad1462", "6095abec45a52836f8ad1463", "6095abec45a52836f8ad1464", "6095abec45a52836f8ad1465", "6095abec45a52836f8ad1466", "6095abec45a52836f8ad1467", "6095abec45a52836f8ad1468", "6095abec45a52836f8ad1469", "6095abec45a52836f8ad146a", "6095abec45a52836f8ad146b", "6095abec45a52836f8ad146c", "6095abec45a52836f8ad146d", "6095abec45a52836f8ad146e", "6095abec45a52836f8ad146f", "6095abec45a52836f8ad1470", "6095abec45a52836f8ad1471", "6095abec45a52836f8ad1472", "6095abec45a52836f8ad1473", "6095abec45a52836f8ad1474", "6095abec45a52836f8ad1475", "6095abec45a52836f8ad1476", "6095abec45a52836f8ad1477"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7d45a52836f8ad1e4e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "La Riche Directions",
            "brand_key": "la-riche-directions",
            "createdAt": "2021-05-07T21:09:17.194Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30462
        },
        "createdAt": "2021-05-07T21:09:17.216Z",
        "updatedAt": "2021-05-07T21:09:17.216Z"
    }, {
        "_id": "6095ac7d45a52836f8ad1e51",
        "products": ["6095abec45a52836f8ad1478", "6095abec45a52836f8ad1479", "6095abec45a52836f8ad147a", "6095abec45a52836f8ad147b", "6095abec45a52836f8ad147c", "6095abec45a52836f8ad147d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7d45a52836f8ad1e50",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Lala's",
            "brand_key": "lala's",
            "createdAt": "2021-05-07T21:09:17.285Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30463
        },
        "createdAt": "2021-05-07T21:09:17.309Z",
        "updatedAt": "2021-05-07T21:09:17.309Z"
    }, {
        "_id": "6095ac7d45a52836f8ad1e53",
        "products": ["6095abec45a52836f8ad147f", "6095abec45a52836f8ad1480", "6095abec45a52836f8ad1481", "6095abec45a52836f8ad1482", "6095abec45a52836f8ad1483"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7d45a52836f8ad1e52",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Lets Dread",
            "brand_key": "lets-dread",
            "createdAt": "2021-05-07T21:09:17.431Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30464
        },
        "createdAt": "2021-05-07T21:09:17.453Z",
        "updatedAt": "2021-05-07T21:09:17.453Z"
    }, {
        "_id": "6095ac7d45a52836f8ad1e55",
        "products": ["6095abec45a52836f8ad1484", "6095abec45a52836f8ad1485", "6095abec45a52836f8ad1486", "6095abec45a52836f8ad1487"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7d45a52836f8ad1e54",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Lets Jam",
            "brand_key": "lets-jam",
            "createdAt": "2021-05-07T21:09:17.517Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30465
        },
        "createdAt": "2021-05-07T21:09:17.541Z",
        "updatedAt": "2021-05-07T21:09:17.541Z"
    }, {
        "_id": "6095ac7d45a52836f8ad1e57",
        "products": ["6095abec45a52836f8ad1488"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7d45a52836f8ad1e56",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Limacol",
            "brand_key": "limacol",
            "createdAt": "2021-05-07T21:09:17.609Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30466
        },
        "createdAt": "2021-05-07T21:09:17.636Z",
        "updatedAt": "2021-05-07T21:09:17.636Z"
    }, {
        "_id": "6095ac7d45a52836f8ad1e59",
        "products": ["6095abec45a52836f8ad1489"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7d45a52836f8ad1e58",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Model Model",
            "brand_key": "model-model",
            "createdAt": "2021-05-07T21:09:17.698Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30467
        },
        "createdAt": "2021-05-07T21:09:17.719Z",
        "updatedAt": "2021-05-07T21:09:17.719Z"
    }, {
        "_id": "6095ac7d45a52836f8ad1e5b",
        "products": ["6095abec45a52836f8ad148a", "6095abec45a52836f8ad148b", "6095abec45a52836f8ad148c", "6095abec45a52836f8ad148d", "6095abec45a52836f8ad148e", "6095abec45a52836f8ad148f", "6095abec45a52836f8ad1490", "6095abec45a52836f8ad1491", "6095abec45a52836f8ad1492", "6095abec45a52836f8ad1493", "6095abec45a52836f8ad1494", "6095abec45a52836f8ad1495", "6095abec45a52836f8ad1496", "6095abec45a52836f8ad1497", "6095abec45a52836f8ad1498", "6095abec45a52836f8ad1499", "6095abec45a52836f8ad149a"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7d45a52836f8ad1e5a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Lotta Body",
            "brand_key": "lotta-body",
            "createdAt": "2021-05-07T21:09:17.779Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30468
        },
        "createdAt": "2021-05-07T21:09:17.805Z",
        "updatedAt": "2021-05-07T21:09:17.805Z"
    }, {
        "_id": "6095ac7d45a52836f8ad1e5d",
        "products": ["6095abec45a52836f8ad149b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7d45a52836f8ad1e5c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Lyran",
            "brand_key": "lyran",
            "createdAt": "2021-05-07T21:09:17.863Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30469
        },
        "createdAt": "2021-05-07T21:09:17.885Z",
        "updatedAt": "2021-05-07T21:09:17.885Z"
    }, {
        "_id": "6095ac7d45a52836f8ad1e5f",
        "products": ["6095abec45a52836f8ad149c", "6095abec45a52836f8ad149d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7d45a52836f8ad1e5e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "M.G.C.",
            "brand_key": "m.g.c.",
            "createdAt": "2021-05-07T21:09:17.955Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30470
        },
        "createdAt": "2021-05-07T21:09:17.980Z",
        "updatedAt": "2021-05-07T21:09:17.980Z"
    }, {
        "_id": "6095ac7e45a52836f8ad1e61",
        "products": ["6095abec45a52836f8ad149e", "6095abec45a52836f8ad149f", "6095abec45a52836f8ad14a0", "6095abec45a52836f8ad14a1", "6095abec45a52836f8ad14a2", "6095abec45a52836f8ad14a3", "6095abec45a52836f8ad14a4", "6095abec45a52836f8ad14a5", "6095abec45a52836f8ad14a6", "6095abec45a52836f8ad14a7"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7e45a52836f8ad1e60",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "MaBrowns",
            "brand_key": "MaBrowns",
            "createdAt": "2021-05-07T21:09:18.043Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30471
        },
        "createdAt": "2021-05-07T21:09:18.066Z",
        "updatedAt": "2021-05-07T21:09:18.066Z"
    }, {
        "_id": "6095ac7e45a52836f8ad1e61",
        "products": ["6095abec45a52836f8ad149e", "6095abec45a52836f8ad149f", "6095abec45a52836f8ad14a0", "6095abec45a52836f8ad14a1", "6095abec45a52836f8ad14a2", "6095abec45a52836f8ad14a3", "6095abec45a52836f8ad14a4", "6095abec45a52836f8ad14a5", "6095abec45a52836f8ad14a6", "6095abec45a52836f8ad14a7"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7e45a52836f8ad1e60",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Macadamia",
            "brand_key": "macadamia",
            "createdAt": "2021-05-07T21:09:18.043Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30471
        },
        "createdAt": "2021-05-07T21:09:18.066Z",
        "updatedAt": "2021-05-07T21:09:18.066Z"
    }, {
        "_id": "6095ac7e45a52836f8ad1e63",
        "products": ["6095abec45a52836f8ad14a8", "6095abec45a52836f8ad14a9", "6095abec45a52836f8ad14aa", "6095abec45a52836f8ad14ab", "6095abec45a52836f8ad14ac", "6095abec45a52836f8ad14ad", "6095abec45a52836f8ad14b3"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7e45a52836f8ad1e62",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Magic",
            "brand_key": "magic",
            "createdAt": "2021-05-07T21:09:18.132Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30472
        },
        "createdAt": "2021-05-07T21:09:18.155Z",
        "updatedAt": "2021-05-07T21:09:18.155Z"
    }, {
        "_id": "6095ac7e45a52836f8ad1e65",
        "products": ["6095abec45a52836f8ad14ae", "6095abec45a52836f8ad14af", "6095abec45a52836f8ad14b0", "6095abec45a52836f8ad14b1", "6095abec45a52836f8ad14b2"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7e45a52836f8ad1e64",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Magic Collection",
            "brand_key": "magic-collection",
            "createdAt": "2021-05-07T21:09:18.220Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30473
        },
        "createdAt": "2021-05-07T21:09:18.245Z",
        "updatedAt": "2021-05-07T21:09:18.245Z"
    }, {
        "_id": "6095ac7e45a52836f8ad1e67",
        "products": ["6095abec45a52836f8ad14b4", "6095abec45a52836f8ad14b5", "6095abec45a52836f8ad14b6"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7e45a52836f8ad1e66",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Magno",
            "brand_key": "magno",
            "createdAt": "2021-05-07T21:09:18.307Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30474
        },
        "createdAt": "2021-05-07T21:09:18.331Z",
        "updatedAt": "2021-05-07T21:09:18.331Z"
    }, {
        "_id": "6095ac7e45a52836f8ad1e69",
        "products": ["6095abec45a52836f8ad14b7", "6095abec45a52836f8ad14b8", "6095abec45a52836f8ad14b9", "6095abec45a52836f8ad14ba", "6095abec45a52836f8ad14bb", "6095abec45a52836f8ad14bc", "6095abec45a52836f8ad14bd", "6095abec45a52836f8ad14be", "6095abec45a52836f8ad14bf", "6095abec45a52836f8ad14c0", "6095abec45a52836f8ad14c1", "6095abec45a52836f8ad14c2", "6095abec45a52836f8ad14c3", "6095abec45a52836f8ad14c4", "6095abec45a52836f8ad14c5"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7e45a52836f8ad1e68",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Makari",
            "brand_key": "makari",
            "createdAt": "2021-05-07T21:09:18.396Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30475
        },
        "createdAt": "2021-05-07T21:09:18.428Z",
        "updatedAt": "2021-05-07T21:09:18.428Z"
    }, {
        "_id": "6095ac7e45a52836f8ad1e6b",
        "products": ["6095abec45a52836f8ad14c6", "6095abec45a52836f8ad14c7", "6095abec45a52836f8ad14c8", "6095abec45a52836f8ad14c9", "6095abec45a52836f8ad14ca", "6095abec45a52836f8ad14cb", "6095abec45a52836f8ad14cc", "6095abec45a52836f8ad14cd", "6095abec45a52836f8ad14ce", "6095abec45a52836f8ad14cf", "6095abec45a52836f8ad14d0", "6095abec45a52836f8ad14d1", "6095abec45a52836f8ad14d2", "6095abec45a52836f8ad14d3", "6095abec45a52836f8ad14d4", "6095abec45a52836f8ad14d5", "6095abec45a52836f8ad14d6", "6095abec45a52836f8ad14d7", "6095abec45a52836f8ad14d8", "6095abec45a52836f8ad14d9", "6095abec45a52836f8ad14da", "6095abec45a52836f8ad14db", "6095abec45a52836f8ad14dc", "6095abec45a52836f8ad14dd", "6095abec45a52836f8ad14de", "6095abec45a52836f8ad14df"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7e45a52836f8ad1e6a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Make-up Studio",
            "brand_key": "make-up-studio",
            "createdAt": "2021-05-07T21:09:18.490Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30476
        },
        "createdAt": "2021-05-07T21:09:18.514Z",
        "updatedAt": "2021-05-07T21:09:18.514Z"
    }, {
        "_id": "6095ac7e45a52836f8ad1e6d",
        "products": ["6095abec45a52836f8ad14e0", "6095abec45a52836f8ad14e1", "6095abec45a52836f8ad14e2", "6095abec45a52836f8ad14e3", "6095abec45a52836f8ad14e4", "6095abec45a52836f8ad14e5", "6095abec45a52836f8ad14e6", "6095abec45a52836f8ad14e7", "6095abec45a52836f8ad14e8", "6095abec45a52836f8ad14e9", "6095abec45a52836f8ad14ea", "6095abec45a52836f8ad14eb"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7e45a52836f8ad1e6c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Mane 'n Tail",
            "brand_key": "mane-'n-tail",
            "createdAt": "2021-05-07T21:09:18.587Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30477
        },
        "createdAt": "2021-05-07T21:09:18.613Z",
        "updatedAt": "2021-05-07T21:09:18.613Z"
    }, {
        "_id": "6095ac7e45a52836f8ad1e6f",
        "products": ["6095abec45a52836f8ad14ed", "6095abec45a52836f8ad14ee", "6095abec45a52836f8ad14ef", "6095abec45a52836f8ad14f0", "6095abec45a52836f8ad14f1", "6095abec45a52836f8ad14f2", "6095abec45a52836f8ad14f3", "6095abec45a52836f8ad14f4", "6095abec45a52836f8ad14f5", "6095abec45a52836f8ad14f6", "6095abec45a52836f8ad14f7", "6095abec45a52836f8ad14f8", "6095abec45a52836f8ad14f9"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7e45a52836f8ad1e6e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Manic Panic",
            "brand_key": "manic-panic",
            "createdAt": "2021-05-07T21:09:18.757Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30478
        },
        "createdAt": "2021-05-07T21:09:18.791Z",
        "updatedAt": "2021-05-07T21:09:18.791Z"
    },
             {
        "_id": "6095ac7e45a52836f8ad1e6f",
        "products": ["6095abec45a52836f8ad14ed", "6095abec45a52836f8ad14ee", "6095abec45a52836f8ad14ef", "6095abec45a52836f8ad14f0", "6095abec45a52836f8ad14f1", "6095abec45a52836f8ad14f2", "6095abec45a52836f8ad14f3", "6095abec45a52836f8ad14f4", "6095abec45a52836f8ad14f5", "6095abec45a52836f8ad14f6", "6095abec45a52836f8ad14f7", "6095abec45a52836f8ad14f8", "6095abec45a52836f8ad14f9"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7e45a52836f8ad1e6e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Maui",
            "brand_key": "maui",
            "createdAt": "2021-05-07T21:09:18.757Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30478
        },
        "createdAt": "2021-05-07T21:09:18.791Z",
        "updatedAt": "2021-05-07T21:09:18.791Z"
    }, {
        "_id": "6095ac7e45a52836f8ad1e71",
        "products": ["6095abf045a52836f8ad1546", "6095abf045a52836f8ad1547", "6095abf045a52836f8ad1548", "6095abf045a52836f8ad1549", "6095abf045a52836f8ad154a"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7e45a52836f8ad1e70",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Mazuri Organics",
            "brand_key": "mazuri-organics",
            "createdAt": "2021-05-07T21:09:18.851Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30479
        },
        "createdAt": "2021-05-07T21:09:18.876Z",
        "updatedAt": "2021-05-07T21:09:18.876Z"
    }, {
        "_id": "6095ac7e45a52836f8ad1e73",
        "products": ["6095abf045a52836f8ad154b", "6095abf045a52836f8ad154c", "6095abf045a52836f8ad154d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7e45a52836f8ad1e72",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Mazuri Shea Butter Naturals",
            "brand_key": "mazuri-shea-butter-naturals",
            "createdAt": "2021-05-07T21:09:18.940Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30480
        },
        "createdAt": "2021-05-07T21:09:18.960Z",
        "updatedAt": "2021-05-07T21:09:18.960Z"
    }, {
        "_id": "6095ac7f45a52836f8ad1d75",
        "products": ["6095abf045a52836f8ad1551", "6095abf045a52836f8ad1552", "6095abf045a52836f8ad1553", "6095abf045a52836f8ad1554", "6095abf045a52836f8ad1555", "6095abf045a52836f8ad1556", "6095abf045a52836f8ad1557", "6095abf045a52836f8ad1558", "6095abf045a52836f8ad1559", "6095abf045a52836f8ad155a", "6095abf045a52836f8ad155b", "6095abf045a52836f8ad155c", "6095abf045a52836f8ad155d", "6095abf045a52836f8ad155e", "6095abf045a52836f8ad155f", "6095abf045a52836f8ad1560", "6095abf045a52836f8ad1561", "6095abf045a52836f8ad1562", "6095abf045a52836f8ad1563", "6095abf045a52836f8ad1564", "6095abf045a52836f8ad1565", "6095abf045a52836f8ad1566", "6095abf045a52836f8ad1567", "6095abf045a52836f8ad1568", "6095abf045a52836f8ad1569", "6095abf045a52836f8ad156a", "6095abf045a52836f8ad156b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7f45a52836f8ad1e74",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Miche Beauty",
            "brand_key": "Miche-Beauty",
            "createdAt": "2021-05-07T21:09:19.101Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30481
        },
        "createdAt": "2021-05-07T21:09:19.127Z",
        "updatedAt": "2021-05-07T21:09:19.127Z"
    },{
        "_id": "6095ac7f45a52836f8ad1e75",
        "products": ["6095abf045a52836f8ad1551", "6095abf045a52836f8ad1552", "6095abf045a52836f8ad1553", "6095abf045a52836f8ad1554", "6095abf045a52836f8ad1555", "6095abf045a52836f8ad1556", "6095abf045a52836f8ad1557", "6095abf045a52836f8ad1558", "6095abf045a52836f8ad1559", "6095abf045a52836f8ad155a", "6095abf045a52836f8ad155b", "6095abf045a52836f8ad155c", "6095abf045a52836f8ad155d", "6095abf045a52836f8ad155e", "6095abf045a52836f8ad155f", "6095abf045a52836f8ad1560", "6095abf045a52836f8ad1561", "6095abf045a52836f8ad1562", "6095abf045a52836f8ad1563", "6095abf045a52836f8ad1564", "6095abf045a52836f8ad1565", "6095abf045a52836f8ad1566", "6095abf045a52836f8ad1567", "6095abf045a52836f8ad1568", "6095abf045a52836f8ad1569", "6095abf045a52836f8ad156a", "6095abf045a52836f8ad156b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7f45a52836f8ad1e74",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Mielle Organics",
            "brand_key": "mielle-organics",
            "createdAt": "2021-05-07T21:09:19.101Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30481
        },
        "createdAt": "2021-05-07T21:09:19.127Z",
        "updatedAt": "2021-05-07T21:09:19.127Z"
    }, {
        "_id": "6095ac7f45a52836f8ad1e77",
        "products": ["6095abf045a52836f8ad156c", "6095abf045a52836f8ad156d", "6095abf045a52836f8ad156e", "6095abf045a52836f8ad156f", "6095abf045a52836f8ad1570", "6095abf045a52836f8ad1571", "6095abf045a52836f8ad1572", "6095abf045a52836f8ad1573", "6095abf045a52836f8ad1574"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7f45a52836f8ad1e76",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Miracle 9",
            "brand_key": "Miracle 9",
            "createdAt": "2021-05-07T21:09:19.187Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30482
        },
        "createdAt": "2021-05-07T21:09:19.210Z",
        "updatedAt": "2021-05-07T21:09:19.210Z"
    }, {
        "_id": "6095ac7f45a52836f8ad1e77",
        "products": ["6095abf045a52836f8ad156c", "6095abf045a52836f8ad156d", "6095abf045a52836f8ad156e", "6095abf045a52836f8ad156f", "6095abf045a52836f8ad1570", "6095abf045a52836f8ad1571", "6095abf045a52836f8ad1572", "6095abf045a52836f8ad1573", "6095abf045a52836f8ad1574"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7f45a52836f8ad1e76",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Mimax Make Up",
            "brand_key": "mimax-make-up",
            "createdAt": "2021-05-07T21:09:19.187Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30482
        },
        "createdAt": "2021-05-07T21:09:19.210Z",
        "updatedAt": "2021-05-07T21:09:19.210Z"
    }, {
        "_id": "6095ac7f45a52836f8ad1e79",
        "products": ["6095abf045a52836f8ad1576", "6095abf045a52836f8ad1577", "6095abf045a52836f8ad1578", "6095abf045a52836f8ad1579", "6095abf045a52836f8ad157a", "6095abf045a52836f8ad157b", "6095abf045a52836f8ad157c", "6095abf045a52836f8ad157d", "6095abf045a52836f8ad157e", "6095abf045a52836f8ad157f", "6095abf045a52836f8ad1580", "6095abf045a52836f8ad1581"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7f45a52836f8ad1e78",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Miss Jessie's",
            "brand_key": "miss-jessie's",
            "createdAt": "2021-05-07T21:09:19.273Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30483
        },
        "createdAt": "2021-05-07T21:09:19.297Z",
        "updatedAt": "2021-05-07T21:09:19.297Z"
    }, {
        "_id": "6095ac7f45a52836f8ad1e7b",
        "products": ["6095abf045a52836f8ad1582", "6095abf045a52836f8ad1583", "6095abf045a52836f8ad1584", "6095abf045a52836f8ad1585", "6095abf045a52836f8ad1586", "6095abf045a52836f8ad1587", "6095abf045a52836f8ad1588", "6095abf045a52836f8ad1589", "6095abf045a52836f8ad158a", "6095abf045a52836f8ad158b", "6095abf045a52836f8ad158c", "6095abf045a52836f8ad158d", "6095abf045a52836f8ad158e", "6095abf045a52836f8ad158f", "6095abf045a52836f8ad1590", "6095abf045a52836f8ad1591", "6095abf045a52836f8ad1592", "6095abf045a52836f8ad1593", "6095abf045a52836f8ad1594", "6095abf045a52836f8ad1595"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7f45a52836f8ad1e7a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Mixed Chicks",
            "brand_key": "mixed-chicks",
            "createdAt": "2021-05-07T21:09:19.356Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30484
        },
        "createdAt": "2021-05-07T21:09:19.378Z",
        "updatedAt": "2021-05-07T21:09:19.378Z"
    }, {
        "_id": "6095ac7f45a52836f8ad1e7d",
        "products": ["6095abf045a52836f8ad1596"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7f45a52836f8ad1e7c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Mixed Roots",
            "brand_key": "mixed-roots",
            "createdAt": "2021-05-07T21:09:19.447Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30485
        },
        "createdAt": "2021-05-07T21:09:19.470Z",
        "updatedAt": "2021-05-07T21:09:19.470Z"
    }, {
        "_id": "6095ac7f45a52836f8ad1e7f",
        "products": ["6095abf045a52836f8ad1597", "6095abf045a52836f8ad1598", "6095abf045a52836f8ad1599", "6095abf045a52836f8ad159a", "6095abf045a52836f8ad159b", "6095abf045a52836f8ad159c", "6095abf045a52836f8ad159d", "6095abf045a52836f8ad159e", "6095abf045a52836f8ad159f", "6095abf045a52836f8ad15a0", "6095abf045a52836f8ad15a1", "6095abf045a52836f8ad15a2", "6095abf045a52836f8ad15a3", "6095abf045a52836f8ad15a4", "6095abf045a52836f8ad15a5", "6095abf045a52836f8ad15a6", "6095abf045a52836f8ad15a7", "6095abf045a52836f8ad15a8", "6095abf045a52836f8ad15a9", "6095abf045a52836f8ad15aa", "6095abf045a52836f8ad15ab", "6095abf045a52836f8ad15ac", "6095abf045a52836f8ad15ad", "6095abf045a52836f8ad15ae", "6095abf045a52836f8ad15af", "6095abf045a52836f8ad15b0", "6095abf045a52836f8ad15b1", "6095abf045a52836f8ad15b2", "6095abf045a52836f8ad15b3", "6095abf045a52836f8ad15b4", "6095abf045a52836f8ad15b5", "6095abf045a52836f8ad15b6", "6095abf045a52836f8ad15b7", "6095abf045a52836f8ad15b8", "6095abf045a52836f8ad15b9", "6095abf045a52836f8ad15ba", "6095abf045a52836f8ad15bb", "6095abf045a52836f8ad15bc", "6095abf045a52836f8ad15bd"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7f45a52836f8ad1e7e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Mizani",
            "brand_key": "mizani",
            "createdAt": "2021-05-07T21:09:19.534Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30486
        },
        "createdAt": "2021-05-07T21:09:19.559Z",
        "updatedAt": "2021-05-07T21:09:19.559Z"
    }, {
        "_id": "6095ac7f45a52836f8ad1e81",
        "products": ["6095abf045a52836f8ad15be", "6095abf045a52836f8ad15bf", "6095abf045a52836f8ad15c0", "6095abf045a52836f8ad15c1"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7f45a52836f8ad1e80",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Moco De Gorila",
            "brand_key": "moco-de-gorila",
            "createdAt": "2021-05-07T21:09:19.627Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30487
        },
        "createdAt": "2021-05-07T21:09:19.648Z",
        "updatedAt": "2021-05-07T21:09:19.648Z"
    }, {
        "_id": "6095ac7f45a52836f8ad1e83",
        "products": ["6095abf045a52836f8ad15c2", "6095abf045a52836f8ad15c3"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7f45a52836f8ad1e82",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Moroccanoil",
            "brand_key": "moroccanoil",
            "createdAt": "2021-05-07T21:09:19.709Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30488
        },
        "createdAt": "2021-05-07T21:09:19.734Z",
        "updatedAt": "2021-05-07T21:09:19.734Z"
    }, {
        "_id": "6095ac7f45a52836f8ad1e85",
        "products": ["6095abf045a52836f8ad15c4", "6095abf045a52836f8ad15c5", "6095abf045a52836f8ad15c6", "6095abf045a52836f8ad15c7", "6095abf045a52836f8ad15c8", "6095abf045a52836f8ad15c9", "6095abf045a52836f8ad15ca", "6095abf045a52836f8ad15cb", "6095abf045a52836f8ad15cc", "6095abf045a52836f8ad15cd", "6095abf045a52836f8ad15ce", "6095abf045a52836f8ad15cf", "6095abf045a52836f8ad15d0", "6095abf045a52836f8ad15d1", "6095abf045a52836f8ad15d2"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7f45a52836f8ad1e84",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Motions",
            "brand_key": "motions",
            "createdAt": "2021-05-07T21:09:19.800Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30489
        },
        "createdAt": "2021-05-07T21:09:19.824Z",
        "updatedAt": "2021-05-07T21:09:19.824Z"
    }, {
        "_id": "6095ac7f45a52836f8ad1e87",
        "products": ["6095abf045a52836f8ad15d3", "6095abf045a52836f8ad15d4", "6095abf045a52836f8ad15d5", "6095abf045a52836f8ad15d6"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7f45a52836f8ad1e86",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Murray & Lanman",
            "brand_key": "murray-&-lanman",
            "createdAt": "2021-05-07T21:09:19.890Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30490
        },
        "createdAt": "2021-05-07T21:09:19.913Z",
        "updatedAt": "2021-05-07T21:09:19.913Z"
    }, {
        "_id": "6095ac7f45a52836f8ad1e89",
        "products": ["6095abf045a52836f8ad15d7", "6095abf045a52836f8ad15d8", "6095abf045a52836f8ad15d9", "6095abf045a52836f8ad15da", "6095abf045a52836f8ad15db"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac7f45a52836f8ad1e88",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Murray's",
            "brand_key": "murray's",
            "createdAt": "2021-05-07T21:09:19.973Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30491
        },
        "createdAt": "2021-05-07T21:09:19.998Z",
        "updatedAt": "2021-05-07T21:09:19.998Z"
    }, {
        "_id": "6095ac8045a52836f8ad1e8b",
        "products": ["6095abf045a52836f8ad15de"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e8a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Natural Hair Concept",
            "brand_key": "natural-hair-concept",
            "createdAt": "2021-05-07T21:09:20.060Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30492
        },
        "createdAt": "2021-05-07T21:09:20.082Z",
        "updatedAt": "2021-05-07T21:09:20.082Z"
    },
             {
        "_id": "6095ac8045a52836f8ad1e8b",
        "products": ["6095abf045a52836f8ad15de"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e8a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Neoprosone",
            "brand_key": "neoprosone",
            "createdAt": "2021-05-07T21:09:20.060Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30492
        },
        "createdAt": "2021-05-07T21:09:20.082Z",
        "updatedAt": "2021-05-07T21:09:20.082Z"
    },{
        "_id": "6095ac8045a52836f8ad1e8b",
        "products": ["6095abf045a52836f8ad15de"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e8a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Natucor",
            "brand_key": "natucor",
            "createdAt": "2021-05-07T21:09:20.060Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30492
        },
        "createdAt": "2021-05-07T21:09:20.082Z",
        "updatedAt": "2021-05-07T21:09:20.082Z"
    }, {
        "_id": "6095ac8045a52836f8ad1e8b",
        "products": ["6095abf045a52836f8ad15de"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e8a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Nicka K",
            "brand_key": "nicka-k",
            "createdAt": "2021-05-07T21:09:20.060Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30492
        },
        "createdAt": "2021-05-07T21:09:20.082Z",
        "updatedAt": "2021-05-07T21:09:20.082Z"
    }, {
        "_id": "6095ac8045a52836f8ad1e8d",
        "products": ["6095abf045a52836f8ad15e0", "6095abf045a52836f8ad15e1", "6095abf045a52836f8ad15e2", "6095abf045a52836f8ad15e3", "6095abf045a52836f8ad15e4", "6095abf045a52836f8ad15e5", "6095abf045a52836f8ad15e6", "6095abf045a52836f8ad15e7", "6095abf045a52836f8ad15e8", "6095abf045a52836f8ad15e9", "6095abf045a52836f8ad15ea", "6095abf045a52836f8ad15eb", "6095abf045a52836f8ad15ec", "6095abf045a52836f8ad15ed", "6095abf045a52836f8ad15ee", "6095abf045a52836f8ad15ef", "6095abf045a52836f8ad15f0", "6095abf045a52836f8ad15f1", "6095abf045a52836f8ad15f2", "6095abf045a52836f8ad15f3", "6095abf045a52836f8ad15f4", "6095abf045a52836f8ad15f5", "6095abf045a52836f8ad15f6", "6095abf045a52836f8ad15f7", "6095abf045a52836f8ad15f8", "6095abf045a52836f8ad15f9", "6095abf045a52836f8ad15fa", "6095abf045a52836f8ad15fb", "6095abf045a52836f8ad15fc", "6095abf045a52836f8ad15fd", "6095abf045a52836f8ad15fe", "6095abf045a52836f8ad15ff", "6095abf045a52836f8ad1600", "6095abf045a52836f8ad1601", "6095abf045a52836f8ad1602", "6095abf045a52836f8ad1603", "6095abf045a52836f8ad1604", "6095abf045a52836f8ad1605", "6095abf045a52836f8ad1606", "6095abf045a52836f8ad1607", "6095abf045a52836f8ad1608", "6095abf045a52836f8ad1609", "6095abf045a52836f8ad160a", "6095abf045a52836f8ad160b", "6095abf045a52836f8ad160c", "6095abf045a52836f8ad160d", "6095abf045a52836f8ad160e", "6095abf045a52836f8ad160f"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e8c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Not Your Mother's",
            "brand_key": "not-your-mother's",
            "createdAt": "2021-05-07T21:09:20.140Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30493
        },
        "createdAt": "2021-05-07T21:09:20.162Z",
        "updatedAt": "2021-05-07T21:09:20.162Z"
    }, {
        "_id": "6095ac8045a52836f8ad1e8f",
        "products": ["6095abf045a52836f8ad1610", "6095abf045a52836f8ad1611", "6095abf045a52836f8ad1612", "6095abf045a52836f8ad1613", "6095abf045a52836f8ad1614", "6095abf045a52836f8ad1615", "6095abf045a52836f8ad1616"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e8e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Noughty",
            "brand_key": "noughty",
            "createdAt": "2021-05-07T21:09:20.221Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30494
        },
        "createdAt": "2021-05-07T21:09:20.242Z",
        "updatedAt": "2021-05-07T21:09:20.242Z"
    }, {
        "_id": "6095ac8045a52836f8ad1e91",
        "products": ["6095abf045a52836f8ad1617", "6095abf045a52836f8ad1618", "6095abf045a52836f8ad1619", "6095abf045a52836f8ad161a", "6095abf045a52836f8ad161b", "6095abf045a52836f8ad161c", "6095abf045a52836f8ad161d", "6095abf045a52836f8ad161e", "6095abf045a52836f8ad161f", "6095abf045a52836f8ad1620", "6095abf045a52836f8ad1621", "6095abf045a52836f8ad1622", "6095abf045a52836f8ad1623", "6095abf045a52836f8ad1624", "6095abf045a52836f8ad1625", "6095abf045a52836f8ad1626", "6095abf045a52836f8ad1627", "6095abf045a52836f8ad1628", "6095abf045a52836f8ad1629", "6095abf045a52836f8ad162a", "6095abf045a52836f8ad162b", "6095abf045a52836f8ad162c", "6095abf045a52836f8ad162d", "6095abf045a52836f8ad162e", "6095abf045a52836f8ad162f", "6095abf045a52836f8ad1630", "6095abf045a52836f8ad1631", "6095abf045a52836f8ad1632", "6095abf045a52836f8ad1633", "6095abf045a52836f8ad1634", "6095abf045a52836f8ad1635", "6095abf045a52836f8ad1636", "6095abf045a52836f8ad1637", "6095abf045a52836f8ad1638", "6095abf045a52836f8ad1639", "6095abf045a52836f8ad163a", "6095abf045a52836f8ad163b", "6095abf045a52836f8ad163c", "6095abf045a52836f8ad163d", "6095abf045a52836f8ad163e", "6095abf045a52836f8ad163f", "6095abf445a52836f8ad1640", "6095abf445a52836f8ad1641", "6095abf445a52836f8ad1642", "6095abf445a52836f8ad1643", "6095abf445a52836f8ad1644", "6095abf445a52836f8ad1645", "6095abf445a52836f8ad1646", "6095abf445a52836f8ad1647", "6095abf445a52836f8ad1648", "6095abf445a52836f8ad1649", "6095abf445a52836f8ad164a", "6095abf445a52836f8ad164b", "6095abf445a52836f8ad164c", "6095abf445a52836f8ad164d", "6095abf445a52836f8ad164e", "6095abf445a52836f8ad164f", "6095abf445a52836f8ad1650", "6095abf445a52836f8ad1651", "6095abf445a52836f8ad1652", "6095abf445a52836f8ad1653", "6095abf445a52836f8ad1654", "6095abf445a52836f8ad1655", "6095abf445a52836f8ad1656", "6095abf445a52836f8ad1657", "6095abf445a52836f8ad1658", "6095abf445a52836f8ad1659", "6095abf445a52836f8ad165a", "6095abf445a52836f8ad165b", "6095abf445a52836f8ad165c", "6095abf445a52836f8ad165d", "6095abf445a52836f8ad165e", "6095abf445a52836f8ad165f", "6095abf445a52836f8ad1660", "6095abf445a52836f8ad1661", "6095abf445a52836f8ad1662", "6095abf445a52836f8ad1663", "6095abf445a52836f8ad1664", "6095abf445a52836f8ad1665", "6095abf445a52836f8ad1666", "6095abf445a52836f8ad1667", "6095abf445a52836f8ad1668", "6095abf445a52836f8ad1669", "6095abf445a52836f8ad166a", "6095abf445a52836f8ad166b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e90",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Novex",
            "brand_key": "novex",
            "createdAt": "2021-05-07T21:09:20.303Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30495
        },
        "createdAt": "2021-05-07T21:09:20.327Z",
        "updatedAt": "2021-05-07T21:09:20.327Z"
    }, {
        "_id": "6095ac8045a52836f8ad1e93",
        "products": ["6095abf445a52836f8ad166c"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e92",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Noxzema",
            "brand_key": "noxzema",
            "createdAt": "2021-05-07T21:09:20.387Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30496
        },
        "createdAt": "2021-05-07T21:09:20.417Z",
        "updatedAt": "2021-05-07T21:09:20.417Z"
    }, {
        "_id": "6095ac8045a52836f8ad1e95",
        "products": ["6095abf445a52836f8ad166d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e94",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Nu Nile",
            "brand_key": "nu-nile",
            "createdAt": "2021-05-07T21:09:20.476Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30497
        },
        "createdAt": "2021-05-07T21:09:20.496Z",
        "updatedAt": "2021-05-07T21:09:20.496Z"
    }, {
        "_id": "6095ac8045a52836f8ad1e97",
        "products": ["6095abf445a52836f8ad166e", "6095abf445a52836f8ad166f", "6095abf445a52836f8ad1670", "6095abf445a52836f8ad1671", "6095abf445a52836f8ad1672"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e96",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Nutriclair",
            "brand_key": "nutriclair",
            "createdAt": "2021-05-07T21:09:20.553Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30498
        },
        "createdAt": "2021-05-07T21:09:20.578Z",
        "updatedAt": "2021-05-07T21:09:20.578Z"
    }, {
        "_id": "6095ac8045a52836f8ad1e99",
        "products": ["6095abf445a52836f8ad1673"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e98",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "NYC Curls",
            "brand_key": "nyc-curls",
            "createdAt": "2021-05-07T21:09:20.638Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30499
        },
        "createdAt": "2021-05-07T21:09:20.660Z",
        "updatedAt": "2021-05-07T21:09:20.660Z"
    }, {
        "_id": "6095ac8045a52836f8ad1e9b",
        "products": ["6095abf445a52836f8ad1674", "6095abf445a52836f8ad1675", "6095abf445a52836f8ad1676"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e9a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Nyxon",
            "brand_key": "nyxon",
            "createdAt": "2021-05-07T21:09:20.724Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30500
        },
        "createdAt": "2021-05-07T21:09:20.746Z",
        "updatedAt": "2021-05-07T21:09:20.746Z"
    }, {
        "_id": "6095ac8045a52836f8ad1e9d",
        "products": ["6095abf445a52836f8ad1677", "6095abf445a52836f8ad1678", "6095abf445a52836f8ad1679", "6095abf445a52836f8ad167a", "6095abf445a52836f8ad167b", "6095abf445a52836f8ad167c", "6095abf445a52836f8ad167d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e9c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Obia Naturals",
            "brand_key": "obia-naturals",
            "createdAt": "2021-05-07T21:09:20.814Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30501
        },
        "createdAt": "2021-05-07T21:09:20.840Z",
        "updatedAt": "2021-05-07T21:09:20.840Z"
    },{
        "_id": "6095ac8045a52836f8ad1e9d",
        "products": ["6095abf445a52836f8ad1677", "6095abf445a52836f8ad1678", "6095abf445a52836f8ad1679", "6095abf445a52836f8ad167a", "6095abf445a52836f8ad167b", "6095abf445a52836f8ad167c", "6095abf445a52836f8ad167d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e9c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Ogoyi Cosmetics",
            "brand_key": "ogoyi-cosmetics",
            "createdAt": "2021-05-07T21:09:20.814Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30501
        },
        "createdAt": "2021-05-07T21:09:20.840Z",
        "updatedAt": "2021-05-07T21:09:20.840Z"
    }, {
        "_id": "6095ac8045a52836f8ad1e9f",
        "products": ["6095abf445a52836f8ad167e", "6095abf445a52836f8ad167f", "6095abf445a52836f8ad1680", "6095abf445a52836f8ad1681", "6095abf445a52836f8ad1682", "6095abf445a52836f8ad1683", "6095abf445a52836f8ad1684", "6095abf445a52836f8ad1685", "6095abf445a52836f8ad1686", "6095abf445a52836f8ad1687"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1e9e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Olaplex",
            "brand_key": "olaplex",
            "createdAt": "2021-05-07T21:09:20.901Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30502
        },
        "createdAt": "2021-05-07T21:09:20.927Z",
        "updatedAt": "2021-05-07T21:09:20.927Z"
    }, {
        "_id": "6095ac8145a52836f8ad1ea1",
        "products": ["6095abf445a52836f8ad1688"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1ea0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "okay",
            "brand_key": "okay",
            "createdAt": "2021-05-07T21:09:20.990Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30503
        },
        "createdAt": "2021-05-07T21:09:21.018Z",
        "updatedAt": "2021-05-07T21:09:21.018Z"
    }, {
        "_id": "6095ac8145a52836f8ad1ea1",
        "products": ["6095abf445a52836f8ad1688"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8045a52836f8ad1ea0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Optimum",
            "brand_key": "optimum",
            "createdAt": "2021-05-07T21:09:20.990Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30503
        },
        "createdAt": "2021-05-07T21:09:21.018Z",
        "updatedAt": "2021-05-07T21:09:21.018Z"
    }, {
        "_id": "6095ac8145a52836f8ad1ea3",
        "products": ["6095abf445a52836f8ad1689", "6095abf445a52836f8ad168a", "6095abf445a52836f8ad168b", "6095abf445a52836f8ad168c", "6095abf445a52836f8ad168d", "6095abf445a52836f8ad168e", "6095abf445a52836f8ad168f", "6095abf445a52836f8ad1690", "6095abf445a52836f8ad1693", "6095abf445a52836f8ad1694", "6095abf445a52836f8ad1695", "6095abf445a52836f8ad1696", "6095abf445a52836f8ad1697", "6095abf445a52836f8ad1698", "6095abf445a52836f8ad1699", "6095abf445a52836f8ad169a", "6095abf445a52836f8ad169b", "6095abf445a52836f8ad169c", "6095abf445a52836f8ad169d", "6095abf445a52836f8ad169e", "6095abf445a52836f8ad169f", "6095abf445a52836f8ad16a0", "6095abf445a52836f8ad16a1", "6095abf445a52836f8ad16a2", "6095abf445a52836f8ad16a3", "6095abf445a52836f8ad16a4", "6095abf445a52836f8ad16a5", "6095abf445a52836f8ad16a6", "6095abf445a52836f8ad16a7", "6095abf445a52836f8ad16a8", "6095abf445a52836f8ad16a9", "6095abf445a52836f8ad16aa", "6095abf445a52836f8ad16ab", "6095abf445a52836f8ad16ac", "6095abf445a52836f8ad16ad", "6095abf445a52836f8ad16ae", "6095abf445a52836f8ad16af", "6095abf445a52836f8ad16b0", "6095abf445a52836f8ad16b1", "6095abf445a52836f8ad16b2", "6095abf445a52836f8ad16b3", "6095abf445a52836f8ad16b4", "6095abf445a52836f8ad16b5", "6095abf445a52836f8ad16b6", "6095abf445a52836f8ad16b7", "6095abf445a52836f8ad16b8", "6095abf445a52836f8ad16b9", "6095abf445a52836f8ad16ba", "6095abf445a52836f8ad16bb", "6095abf445a52836f8ad16bc", "6095abf445a52836f8ad16bd", "6095abf445a52836f8ad16be", "6095abf445a52836f8ad16bf", "6095abf445a52836f8ad16c0", "6095abf445a52836f8ad16c1", "6095abf445a52836f8ad16c2", "6095abf445a52836f8ad16c3", "6095abf445a52836f8ad16c4", "6095abf445a52836f8ad16c5", "6095abf445a52836f8ad16c6", "6095abf445a52836f8ad16c7"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8145a52836f8ad1ea2",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Organic (Ors)",
            "brand_key": "organic-(ors)",
            "createdAt": "2021-05-07T21:09:21.087Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30504
        },
        "createdAt": "2021-05-07T21:09:21.120Z",
        "updatedAt": "2021-05-07T21:09:21.120Z"
    }, {
        "_id": "6095ac8145a52836f8ad1ea5",
        "products": ["6095abf445a52836f8ad1691", "6095abf445a52836f8ad1692"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8145a52836f8ad1ea4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Organic Hair Energizer",
            "brand_key": "organic-hair-energizer",
            "createdAt": "2021-05-07T21:09:21.187Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30505
        },
        "createdAt": "2021-05-07T21:09:21.208Z",
        "updatedAt": "2021-05-07T21:09:21.208Z"
    }, {
        "_id": "6095ac8145a52836f8ad1ea7",
        "products": ["6095abf445a52836f8ad16c8", "6095abf445a52836f8ad16c9", "6095abf445a52836f8ad16ca"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8145a52836f8ad1ea6",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Organix",
            "brand_key": "organix",
            "createdAt": "2021-05-07T21:09:21.271Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30506
        },
        "createdAt": "2021-05-07T21:09:21.294Z",
        "updatedAt": "2021-05-07T21:09:21.294Z"
    }, {
        "_id": "6095ac8145a52836f8ad1ea9",
        "products": ["6095abf445a52836f8ad16cb", "6095abf445a52836f8ad16cc", "6095abf445a52836f8ad16cd", "6095abf445a52836f8ad16ce", "6095abf445a52836f8ad16cf", "6095abf445a52836f8ad16d0", "6095abf445a52836f8ad16d1", "6095abf445a52836f8ad16d2"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8145a52836f8ad1ea8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Orofluido",
            "brand_key": "orofluido",
            "createdAt": "2021-05-07T21:09:21.364Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30507
        },
        "createdAt": "2021-05-07T21:09:21.392Z",
        "updatedAt": "2021-05-07T21:09:21.392Z"
    }, {
        "_id": "6095ac8145a52836f8ad1eab",
        "products": ["6095abf445a52836f8ad16d3", "6095abf445a52836f8ad16d4", "6095abf445a52836f8ad16d5", "6095abf445a52836f8ad16d6", "6095abf445a52836f8ad16d7", "6095abf445a52836f8ad16d8", "6095abf445a52836f8ad16d9", "6095abf445a52836f8ad16da"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8145a52836f8ad1eaa",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Ouidad",
            "brand_key": "ouidad",
            "createdAt": "2021-05-07T21:09:21.458Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30508
        },
        "createdAt": "2021-05-07T21:09:21.480Z",
        "updatedAt": "2021-05-07T21:09:21.480Z"
    },
    {
        "_id": "6095ac8145a52836f8ad1eab",
        "products": ["6095abf445a52836f8ad16d3", "6095abf445a52836f8ad16d4", "6095abf445a52836f8ad16d5", "6095abf445a52836f8ad16d6", "6095abf445a52836f8ad16d7", "6095abf445a52836f8ad16d8", "6095abf445a52836f8ad16d9", "6095abf445a52836f8ad16da"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8145a52836f8ad1eaa",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Oyin Handmade",
            "brand_key": "oyin-handmade",
            "createdAt": "2021-05-07T21:09:21.458Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30508
        },
        "createdAt": "2021-05-07T21:09:21.480Z",
        "updatedAt": "2021-05-07T21:09:21.480Z"
    }, {
        "_id": "6095ac8145a52836f8ad1ead",
        "products": ["6095abf445a52836f8ad16db", "6095abf445a52836f8ad16dc", "6095abf445a52836f8ad16dd", "6095abf445a52836f8ad16de", "6095abf445a52836f8ad16df", "6095abf445a52836f8ad16e0", "6095abf445a52836f8ad16e1", "6095abf445a52836f8ad16e2", "6095abf445a52836f8ad16e3", "6095abf445a52836f8ad16e4", "6095abf445a52836f8ad16e5", "6095abf445a52836f8ad16e6", "6095abf445a52836f8ad16e7", "6095abf445a52836f8ad16e8", "6095abf445a52836f8ad16e9", "6095abf445a52836f8ad16ea", "6095abf445a52836f8ad16eb", "6095abf445a52836f8ad16ec", "6095abf445a52836f8ad16ed", "6095abf445a52836f8ad16ee", "6095abf445a52836f8ad16ef", "6095abf445a52836f8ad16f0", "6095abf445a52836f8ad16f1", "6095abf445a52836f8ad16f2", "6095abf445a52836f8ad16f3", "6095abf445a52836f8ad16f4", "6095abf445a52836f8ad16f5", "6095abf445a52836f8ad16f6", "6095abf445a52836f8ad16f7", "6095abf445a52836f8ad16f8", "6095abf445a52836f8ad16f9", "6095abf445a52836f8ad16fa", "6095abf445a52836f8ad16fb", "6095abf445a52836f8ad16fc", "6095abf445a52836f8ad16fd", "6095abf445a52836f8ad16fe", "6095abf445a52836f8ad16ff", "6095abf445a52836f8ad1700", "6095abf445a52836f8ad1701", "6095abf445a52836f8ad1702", "6095abf445a52836f8ad1703", "6095abf445a52836f8ad1704", "6095abf445a52836f8ad1705", "6095abf445a52836f8ad1706", "6095abf445a52836f8ad1707", "6095abf445a52836f8ad1708", "6095abf445a52836f8ad1709", "6095abf445a52836f8ad170a", "6095abf445a52836f8ad170b", "6095abf445a52836f8ad170c"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8145a52836f8ad1eac",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Palmers",
            "brand_key": "palmers",
            "createdAt": "2021-05-07T21:09:21.542Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30509
        },
        "createdAt": "2021-05-07T21:09:21.572Z",
        "updatedAt": "2021-05-07T21:09:21.572Z"
    }, {
        "_id": "6095ac8145a52836f8ad1eaf",
        "products": ["6095abf445a52836f8ad170d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8145a52836f8ad1eae",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Paltas",
            "brand_key": "paltas",
            "createdAt": "2021-05-07T21:09:21.637Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30510
        },
        "createdAt": "2021-05-07T21:09:21.659Z",
        "updatedAt": "2021-05-07T21:09:21.659Z"
    }, {
        "_id": "6095ac8145a52836f8ad1eb1",
        "products": ["6095abf445a52836f8ad170e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8145a52836f8ad1eb0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "PCJ",
            "brand_key": "pcj",
            "createdAt": "2021-05-07T21:09:21.736Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30511
        },
        "createdAt": "2021-05-07T21:09:21.757Z",
        "updatedAt": "2021-05-07T21:09:21.757Z"
    }, {
        "_id": "6095ac8145a52836f8ad1eb3",
        "products": ["6095abf445a52836f8ad1710", "6095abf445a52836f8ad1711", "6095abf445a52836f8ad1712", "6095abf445a52836f8ad1713", "6095abf445a52836f8ad1714", "6095abf445a52836f8ad1715", "6095abf445a52836f8ad1716", "6095abf445a52836f8ad1717", "6095abf445a52836f8ad1718", "6095abf445a52836f8ad1719", "6095abf445a52836f8ad171a", "6095abf445a52836f8ad171b", "6095abf445a52836f8ad171c", "6095abf445a52836f8ad171d", "6095abf445a52836f8ad171e", "6095abf445a52836f8ad171f", "6095abf445a52836f8ad1720", "6095abf445a52836f8ad1721", "6095abf445a52836f8ad1722", "6095abf445a52836f8ad1723", "6095abf445a52836f8ad1724", "6095abf445a52836f8ad1725", "6095abf445a52836f8ad1726", "6095abf445a52836f8ad1727", "6095abf445a52836f8ad1728", "6095abf445a52836f8ad1729", "6095abf445a52836f8ad172a", "6095abf445a52836f8ad172b", "6095abf445a52836f8ad172c", "6095abf445a52836f8ad172d", "6095abf445a52836f8ad172e", "6095abf445a52836f8ad172f", "6095abf445a52836f8ad1730", "6095abf445a52836f8ad1731", "6095abf445a52836f8ad1732", "6095abf445a52836f8ad1733", "6095abf445a52836f8ad1734", "6095abf445a52836f8ad1735", "6095abf445a52836f8ad1736"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8145a52836f8ad1eb2",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Pink",
            "brand_key": "pink",
            "createdAt": "2021-05-07T21:09:21.817Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30512
        },
        "createdAt": "2021-05-07T21:09:21.839Z",
        "updatedAt": "2021-05-07T21:09:21.839Z"
    }, {
        "_id": "6095ac8145a52836f8ad1eb5",
        "products": ["6095abf445a52836f8ad1738", "6095abf745a52836f8ad1766", "6095abf745a52836f8ad1767", "6095abf745a52836f8ad1768", "6095abf745a52836f8ad1769", "6095abf745a52836f8ad176a", "6095abf745a52836f8ad176b", "6095abf745a52836f8ad176c", "6095abf745a52836f8ad176d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8145a52836f8ad1eb4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Proline",
            "brand_key": "proline",
            "createdAt": "2021-05-07T21:09:21.910Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30513
        },
        "createdAt": "2021-05-07T21:09:21.934Z",
        "updatedAt": "2021-05-07T21:09:21.934Z"
    }, {
        "_id": "6095ac8245a52836f8ad1eb7",
        "products": ["6095abf745a52836f8ad173a", "6095abf745a52836f8ad173b", "6095abf745a52836f8ad173c", "6095abf745a52836f8ad173d", "6095abf745a52836f8ad173e", "6095abf745a52836f8ad173f", "6095abf745a52836f8ad1740", "6095abf745a52836f8ad1741", "6095abf745a52836f8ad1742", "6095abf745a52836f8ad1743", "6095abf745a52836f8ad1744", "6095abf745a52836f8ad1745", "6095abf745a52836f8ad1746", "6095abf745a52836f8ad1747", "6095abf745a52836f8ad1748", "6095abf745a52836f8ad1749", "6095abf745a52836f8ad174a", "6095abf745a52836f8ad174b", "6095abf745a52836f8ad174c", "6095abf745a52836f8ad174d", "6095abf745a52836f8ad174e", "6095abf745a52836f8ad174f", "6095abf745a52836f8ad1750", "6095abf745a52836f8ad1751", "6095abf745a52836f8ad1752", "6095abf745a52836f8ad1753", "6095abf745a52836f8ad1754", "6095abf745a52836f8ad1755", "6095abf745a52836f8ad1756", "6095abf745a52836f8ad1757"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8145a52836f8ad1eb6",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Pr. Francoise Bedon",
            "brand_key": "pr.-francoise-bedon",
            "createdAt": "2021-05-07T21:09:21.998Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30514
        },
        "createdAt": "2021-05-07T21:09:22.034Z",
        "updatedAt": "2021-05-07T21:09:22.034Z"
    }, {
        "_id": "6095ac8245a52836f8ad1eb9",
        "products": ["6095abf745a52836f8ad1758", "6095abf745a52836f8ad1759", "6095abf745a52836f8ad175a", "6095abf745a52836f8ad175b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8245a52836f8ad1eb8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Premium Hair",
            "brand_key": "premium-hair",
            "createdAt": "2021-05-07T21:09:22.099Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30515
        },
        "createdAt": "2021-05-07T21:09:22.121Z",
        "updatedAt": "2021-05-07T21:09:22.121Z"
    }, {
        "_id": "6095ac8245a52836f8ad1ebb",
        "products": ["6095abf745a52836f8ad175c"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8245a52836f8ad1eba",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Prestige",
            "brand_key": "prestige",
            "createdAt": "2021-05-07T21:09:22.180Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30516
        },
        "createdAt": "2021-05-07T21:09:22.203Z",
        "updatedAt": "2021-05-07T21:09:22.203Z"
    }, {
        "_id": "6095ac8245a52836f8ad1ebd",
        "products": ["6095abf745a52836f8ad175d", "6095abf745a52836f8ad175e", "6095abf745a52836f8ad175f", "6095abf745a52836f8ad1760", "6095abf745a52836f8ad1761", "6095abf745a52836f8ad1762", "6095abf745a52836f8ad1763", "6095abf745a52836f8ad1764", "6095abf745a52836f8ad1765"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8245a52836f8ad1ebc",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Pretty Curly Girl",
            "brand_key": "pretty-curly-girl",
            "createdAt": "2021-05-07T21:09:22.275Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30517
        },
        "createdAt": "2021-05-07T21:09:22.302Z",
        "updatedAt": "2021-05-07T21:09:22.302Z"
    }, {
        "_id": "6095ac8245a52836f8ad1ebf",
        "products": ["6095abf745a52836f8ad176e", "6095abf745a52836f8ad176f", "6095abf745a52836f8ad1770", "6095abf745a52836f8ad1771", "6095abf745a52836f8ad1772", "6095abf745a52836f8ad1773", "6095abf745a52836f8ad1774", "6095abf745a52836f8ad1775", "6095abf745a52836f8ad1776", "6095abf745a52836f8ad1777", "6095abf745a52836f8ad1778", "6095abf745a52836f8ad1779", "6095abf745a52836f8ad177a", "6095abf745a52836f8ad177b", "6095abf745a52836f8ad177c", "6095abf745a52836f8ad177d", "6095abf745a52836f8ad177e", "6095abf745a52836f8ad177f", "6095abf745a52836f8ad1780", "6095abf745a52836f8ad1781", "6095abf745a52836f8ad1782", "6095abf745a52836f8ad1783", "6095abf745a52836f8ad1784", "6095abf745a52836f8ad1785", "6095abf745a52836f8ad1786", "6095abf745a52836f8ad1787", "6095abf745a52836f8ad1788", "6095abf745a52836f8ad1789", "6095abf745a52836f8ad178a"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8245a52836f8ad1ebe",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Probel",
            "brand_key": "probel",
            "createdAt": "2021-05-07T21:09:22.361Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30518
        },
        "createdAt": "2021-05-07T21:09:22.384Z",
        "updatedAt": "2021-05-07T21:09:22.384Z"
    }, {
        "_id": "6095ac8245a52836f8ad1ec1",
        "products": ["6095abf745a52836f8ad17cf", "6095abf745a52836f8ad17d0", "6095abf745a52836f8ad17d1", "6095abf745a52836f8ad17d2", "6095abf745a52836f8ad17d3", "6095abf745a52836f8ad17d4", "6095abf745a52836f8ad17d5", "6095abf745a52836f8ad17d6", "6095abf745a52836f8ad17d7", "6095abf745a52836f8ad17d8"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8245a52836f8ad1ec0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Qei Plus Paris",
            "brand_key": "qei-plus-paris",
            "createdAt": "2021-05-07T21:09:22.538Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30519
        },
        "createdAt": "2021-05-07T21:09:22.561Z",
        "updatedAt": "2021-05-07T21:09:22.561Z"
    }, {
        "_id": "6095ac8245a52836f8ad1ec3",
        "products": ["6095abf745a52836f8ad17d9", "6095abf745a52836f8ad17da"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8245a52836f8ad1ec2",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Queen Elizabeth",
            "brand_key": "queen-elizabeth",
            "createdAt": "2021-05-07T21:09:22.630Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30520
        },
        "createdAt": "2021-05-07T21:09:22.653Z",
        "updatedAt": "2021-05-07T21:09:22.653Z"
    }, {
        "_id": "6095ac8245a52836f8ad1ec5",
        "products": ["6095abf745a52836f8ad17db", "6095abf745a52836f8ad17dc", "6095abf745a52836f8ad17dd", "6095abf745a52836f8ad17de", "6095abf745a52836f8ad17df", "6095abf745a52836f8ad17e0", "6095abf745a52836f8ad17e1", "6095abf745a52836f8ad17e2", "6095abf745a52836f8ad17e3", "6095abf745a52836f8ad17e4", "6095abf745a52836f8ad17e5", "6095abf745a52836f8ad17e6", "6095abf745a52836f8ad17e7"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8245a52836f8ad1ec4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Queen Helene",
            "brand_key": "queen-helene",
            "createdAt": "2021-05-07T21:09:22.715Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30521
        },
        "createdAt": "2021-05-07T21:09:22.737Z",
        "updatedAt": "2021-05-07T21:09:22.737Z"
    }, {
        "_id": "6095ac8245a52836f8ad1ec7",
        "products": ["6095abf745a52836f8ad17e8"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8245a52836f8ad1ec6",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Rapid Clair",
            "brand_key": "rapid-clair",
            "createdAt": "2021-05-07T21:09:22.796Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30522
        },
        "createdAt": "2021-05-07T21:09:22.817Z",
        "updatedAt": "2021-05-07T21:09:22.817Z"
    }, {
        "_id": "6095ac8245a52836f8ad1ec9",
        "products": ["6095abf745a52836f8ad17e9"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8245a52836f8ad1ec8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Razac",
            "brand_key": "razac",
            "createdAt": "2021-05-07T21:09:22.876Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30523
        },
        "createdAt": "2021-05-07T21:09:22.897Z",
        "updatedAt": "2021-05-07T21:09:22.897Z"
    }, {
        "_id": "6095ac8245a52836f8ad1ecb",
        "products": ["6095abf745a52836f8ad17ea", "6095abf745a52836f8ad17eb", "6095abf745a52836f8ad17ec", "6095abf745a52836f8ad17ed", "6095abf745a52836f8ad17ee"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8245a52836f8ad1eca",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Real Techniques",
            "brand_key": "real-techniques",
            "createdAt": "2021-05-07T21:09:22.960Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30524
        },
        "createdAt": "2021-05-07T21:09:22.982Z",
        "updatedAt": "2021-05-07T21:09:22.982Z"
    }, {
        "_id": "6095ac8345a52836f8ad1ecd",
        "products": ["6095abf745a52836f8ad17ef"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8345a52836f8ad1ecc",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Red Fox",
            "brand_key": "red-fox",
            "createdAt": "2021-05-07T21:09:23.041Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30525
        },
        "createdAt": "2021-05-07T21:09:23.065Z",
        "updatedAt": "2021-05-07T21:09:23.065Z"
    }, {
        "_id": "6095ac8345a52836f8ad1ecf",
        "products": ["6095abf745a52836f8ad17f0", "6095abf745a52836f8ad17f1", "6095abf745a52836f8ad17f2", "6095abf745a52836f8ad17f3", "6095abf745a52836f8ad17f4", "6095abf745a52836f8ad17f5", "6095abf745a52836f8ad17f6", "6095abf745a52836f8ad17f7", "6095abf745a52836f8ad17f8", "6095abf745a52836f8ad17f9", "6095abf745a52836f8ad17fa", "6095abf745a52836f8ad17fb", "6095abf745a52836f8ad17fc", "6095abf745a52836f8ad17fd", "6095abf745a52836f8ad17fe", "6095abf745a52836f8ad17ff", "6095abf745a52836f8ad1800", "6095abf745a52836f8ad1801", "6095abf745a52836f8ad1802", "6095abf745a52836f8ad1803", "6095abf745a52836f8ad1804"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8345a52836f8ad1ece",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "RedOne",
            "brand_key": "redone",
            "createdAt": "2021-05-07T21:09:23.124Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30526
        },
        "createdAt": "2021-05-07T21:09:23.145Z",
        "updatedAt": "2021-05-07T21:09:23.145Z"
    }, {
        "_id": "6095ac8345a52836f8ad1ecf",
        "products": ["6095abf745a52836f8ad17f0", "6095abf745a52836f8ad17f1", "6095abf745a52836f8ad17f2", "6095abf745a52836f8ad17f3", "6095abf745a52836f8ad17f4", "6095abf745a52836f8ad17f5", "6095abf745a52836f8ad17f6", "6095abf745a52836f8ad17f7", "6095abf745a52836f8ad17f8", "6095abf745a52836f8ad17f9", "6095abf745a52836f8ad17fa", "6095abf745a52836f8ad17fb", "6095abf745a52836f8ad17fc", "6095abf745a52836f8ad17fd", "6095abf745a52836f8ad17fe", "6095abf745a52836f8ad17ff", "6095abf745a52836f8ad1800", "6095abf745a52836f8ad1801", "6095abf745a52836f8ad1802", "6095abf745a52836f8ad1803", "6095abf745a52836f8ad1804"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8345a52836f8ad1ece",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Redken",
            "brand_key": "redken",
            "createdAt": "2021-05-07T21:09:23.124Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30526
        },
        "createdAt": "2021-05-07T21:09:23.145Z",
        "updatedAt": "2021-05-07T21:09:23.145Z"
    }, {
        "_id": "6095ac8345a52836f8ad1ed1",
        "products": ["6095abf745a52836f8ad1805", "6095abf745a52836f8ad1806", "6095abf745a52836f8ad1807", "6095abf745a52836f8ad1808"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8345a52836f8ad1ed0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Refectocil",
            "brand_key": "refectocil",
            "createdAt": "2021-05-07T21:09:23.206Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30527
        },
        "createdAt": "2021-05-07T21:09:23.227Z",
        "updatedAt": "2021-05-07T21:09:23.227Z"
    }, {
        "_id": "6095ac8345a52836f8ad1ed3",
        "products": ["6095abf745a52836f8ad180b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8345a52836f8ad1ed2",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Renurients",
            "brand_key": "renurients",
            "createdAt": "2021-05-07T21:09:23.374Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30528
        },
        "createdAt": "2021-05-07T21:09:23.395Z",
        "updatedAt": "2021-05-07T21:09:23.395Z"
    }, {
        "_id": "6095ac8345a52836f8ad1ed5",
        "products": ["6095abf745a52836f8ad180c"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8345a52836f8ad1ed4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Reve d'Or",
            "brand_key": "reve-d'or",
            "createdAt": "2021-05-07T21:09:23.456Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30529
        },
        "createdAt": "2021-05-07T21:09:23.487Z",
        "updatedAt": "2021-05-07T21:09:23.487Z"
    }, {
        "_id": "6095ac8345a52836f8ad1ed7",
        "products": ["6095abf745a52836f8ad180d", "6095abf745a52836f8ad180e", "6095abf745a52836f8ad180f", "6095abf745a52836f8ad1810", "6095abf745a52836f8ad1812", "6095abf745a52836f8ad1813", "6095abf745a52836f8ad1814", "6095abf745a52836f8ad1815"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8345a52836f8ad1ed6",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Revlon",
            "brand_key": "revlon",
            "createdAt": "2021-05-07T21:09:23.548Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30530
        },
        "createdAt": "2021-05-07T21:09:23.575Z",
        "updatedAt": "2021-05-07T21:09:23.575Z"
    }, {
        "_id": "6095ac8345a52836f8ad1ed9",
        "products": ["6095abf745a52836f8ad1811"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8345a52836f8ad1ed8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Revlon Realistic",
            "brand_key": "revlon-realistic",
            "createdAt": "2021-05-07T21:09:23.634Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30531
        },
        "createdAt": "2021-05-07T21:09:23.664Z",
        "updatedAt": "2021-05-07T21:09:23.664Z"
    }, {
        "_id": "6095ac8345a52836f8ad1edb",
        "products": ["6095abf745a52836f8ad1816", "6095abf745a52836f8ad1817"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8345a52836f8ad1eda",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Righteous Roots",
            "brand_key": "righteous-roots",
            "createdAt": "2021-05-07T21:09:23.726Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30532
        },
        "createdAt": "2021-05-07T21:09:23.751Z",
        "updatedAt": "2021-05-07T21:09:23.751Z"
    }, {
        "_id": "6095ac8345a52836f8ad1edd",
        "products": ["6095abf745a52836f8ad1818"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8345a52836f8ad1edc",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Rinju",
            "brand_key": "rinju",
            "createdAt": "2021-05-07T21:09:23.813Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30533
        },
        "createdAt": "2021-05-07T21:09:23.835Z",
        "updatedAt": "2021-05-07T21:09:23.835Z"
    }, {
        "_id": "6095ac8345a52836f8ad1edf",
        "products": ["6095abf745a52836f8ad1819", "6095abf745a52836f8ad181a", "6095abf745a52836f8ad181b", "6095abf745a52836f8ad181c", "6095abf745a52836f8ad181d", "6095abf745a52836f8ad181e", "6095abf745a52836f8ad181f"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8345a52836f8ad1ede",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Rizos Curls",
            "brand_key": "rizos-curls",
            "createdAt": "2021-05-07T21:09:23.901Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30534
        },
        "createdAt": "2021-05-07T21:09:23.925Z",
        "updatedAt": "2021-05-07T21:09:23.925Z"
    }, {
        "_id": "6095ac8445a52836f8ad1ee1",
        "products": ["6095abf745a52836f8ad1821"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8445a52836f8ad1ee0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Rubee",
            "brand_key": "rubee",
            "createdAt": "2021-05-07T21:09:24.001Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30535
        },
        "createdAt": "2021-05-07T21:09:24.028Z",
        "updatedAt": "2021-05-07T21:09:24.028Z"
    }, {
        "_id": "6095ac8445a52836f8ad1ee3",
        "products": ["6095abf745a52836f8ad1822", "6095abf745a52836f8ad1823", "6095abf745a52836f8ad1824", "6095abf745a52836f8ad1825", "6095abf745a52836f8ad1826", "6095abf745a52836f8ad1827", "6095abf745a52836f8ad1828", "6095abf745a52836f8ad1829", "6095abf745a52836f8ad182a", "6095abf745a52836f8ad182b", "6095abf745a52836f8ad182c", "6095abf745a52836f8ad182d", "6095abf745a52836f8ad182e", "6095abf745a52836f8ad182f", "6095abf745a52836f8ad1830", "6095abf745a52836f8ad1831"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8445a52836f8ad1ee2",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Salon Line",
            "brand_key": "salon-line",
            "createdAt": "2021-05-07T21:09:24.094Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30536
        },
        "createdAt": "2021-05-07T21:09:24.122Z",
        "updatedAt": "2021-05-07T21:09:24.122Z"
    }, {
        "_id": "6095ac8445a52836f8ad1ee5",
        "products": ["6095abf745a52836f8ad1832", "6095abf745a52836f8ad1833", "6095abfa45a52836f8ad1834", "6095abfa45a52836f8ad1835", "6095abfa45a52836f8ad1836"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8445a52836f8ad1ee4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Salon Pro",
            "brand_key": "salon-pro",
            "createdAt": "2021-05-07T21:09:24.202Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30537
        },
        "createdAt": "2021-05-07T21:09:24.227Z",
        "updatedAt": "2021-05-07T21:09:24.227Z"
    }, {
        "_id": "6095ac8445a52836f8ad1ee9",
        "products": ["6095abfa45a52836f8ad1839", "6095abfa45a52836f8ad183a", "6095abfa45a52836f8ad183b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8445a52836f8ad1ee8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Got2b",
            "brand_key": "got2b",
            "createdAt": "2021-05-07T21:09:24.395Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30539
        },
        "createdAt": "2021-05-07T21:09:24.421Z",
        "updatedAt": "2021-05-07T21:09:24.421Z"
    }, {
        "_id": "6095ac8445a52836f8ad1eeb",
        "products": ["6095abfa45a52836f8ad1854", "6095abfa45a52836f8ad1855", "6095abfa45a52836f8ad1856", "6095abfa45a52836f8ad1857", "6095abfa45a52836f8ad1858", "6095abfa45a52836f8ad1859", "6095abfa45a52836f8ad185a", "6095abfa45a52836f8ad185b", "6095abfa45a52836f8ad185c", "6095abfa45a52836f8ad185d", "6095abfa45a52836f8ad185e", "6095abfa45a52836f8ad185f", "6095abfa45a52836f8ad1860", "6095abfa45a52836f8ad1861", "6095abfa45a52836f8ad1862", "6095abfa45a52836f8ad1863", "6095abfa45a52836f8ad1864", "6095abfa45a52836f8ad1865", "6095abfa45a52836f8ad1866", "6095abfa45a52836f8ad1867", "6095abfa45a52836f8ad1868"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8445a52836f8ad1eea",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Scurl",
            "brand_key": "scurl",
            "createdAt": "2021-05-07T21:09:24.511Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30540
        },
        "createdAt": "2021-05-07T21:09:24.544Z",
        "updatedAt": "2021-05-07T21:09:24.544Z"
    }, {
        "_id": "6095ac8445a52836f8ad1eed",
        "products": ["6095abfa45a52836f8ad1869", "6095abfa45a52836f8ad186a", "6095abfa45a52836f8ad186b", "6095abfa45a52836f8ad186c", "6095abfa45a52836f8ad186d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8445a52836f8ad1eec",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Secret D Afrique",
            "brand_key": "secret-d-afrique",
            "createdAt": "2021-05-07T21:09:24.639Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30541
        },
        "createdAt": "2021-05-07T21:09:24.666Z",
        "updatedAt": "2021-05-07T21:09:24.666Z"
    }, {
        "_id": "6095ac8445a52836f8ad1eef",
        "products": ["6095abfa45a52836f8ad186e", "6095abfa45a52836f8ad186f", "6095abfa45a52836f8ad1870", "6095abfa45a52836f8ad1871", "6095abfa45a52836f8ad1872"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8445a52836f8ad1eee",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Seda",
            "brand_key": "seda",
            "createdAt": "2021-05-07T21:09:24.779Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30542
        },
        "createdAt": "2021-05-07T21:09:24.801Z",
        "updatedAt": "2021-05-07T21:09:24.801Z"
    }, {
        "_id": "6095ac8445a52836f8ad1ef1",
        "products": ["6095abfa45a52836f8ad1884", "6095abfa45a52836f8ad1885", "6095abfa45a52836f8ad1886", "6095abfa45a52836f8ad1887", "6095abfa45a52836f8ad1888", "6095abfa45a52836f8ad1889", "6095abfa45a52836f8ad188a", "6095abfa45a52836f8ad188b", "6095abfa45a52836f8ad188c", "6095abfa45a52836f8ad188d", "6095abfa45a52836f8ad188e", "6095abfa45a52836f8ad188f", "6095abfa45a52836f8ad1890", "6095abfa45a52836f8ad1891", "6095abfa45a52836f8ad1892", "6095abfa45a52836f8ad1893", "6095abfa45a52836f8ad1894", "6095abfa45a52836f8ad1895", "6095abfa45a52836f8ad1896", "6095abfa45a52836f8ad1897", "6095abfa45a52836f8ad1898", "6095abfa45a52836f8ad1899", "6095abfa45a52836f8ad189a", "6095abfa45a52836f8ad189b", "6095abfa45a52836f8ad189c", "6095abfa45a52836f8ad189d", "6095abfa45a52836f8ad189e", "6095abfa45a52836f8ad189f", "6095abfa45a52836f8ad18a0", "6095abfa45a52836f8ad18a1", "6095abfa45a52836f8ad18a2", "6095abfa45a52836f8ad18a3", "6095abfa45a52836f8ad18a4", "6095abfa45a52836f8ad18a5", "6095abfa45a52836f8ad18a6", "6095abfa45a52836f8ad18a7", "6095abfa45a52836f8ad18a8", "6095abfa45a52836f8ad18a9", "6095abfa45a52836f8ad18aa", "6095abfa45a52836f8ad18ab", "6095abfa45a52836f8ad18ac", "6095abfa45a52836f8ad18ad", "6095abfa45a52836f8ad18ae", "6095abfa45a52836f8ad18af", "6095abfa45a52836f8ad18b0", "6095abfa45a52836f8ad18b1", "6095abfa45a52836f8ad18b2", "6095abfa45a52836f8ad18b3", "6095abfa45a52836f8ad18b4", "6095abfa45a52836f8ad18b5", "6095abfa45a52836f8ad18b6", "6095abfa45a52836f8ad18b7", "6095abfa45a52836f8ad18b8", "6095abfa45a52836f8ad18b9", "6095abfa45a52836f8ad18ba", "6095abfa45a52836f8ad18bb", "6095abfa45a52836f8ad18bc", "6095abfa45a52836f8ad18bd", "6095abfa45a52836f8ad18be", "6095abfa45a52836f8ad18bf", "6095abfa45a52836f8ad18c0", "6095abfa45a52836f8ad18c1", "6095abfa45a52836f8ad18c2", "6095abfa45a52836f8ad18c3", "6095abfa45a52836f8ad18c4", "6095abfa45a52836f8ad18c5", "6095abfa45a52836f8ad18c6", "6095abfa45a52836f8ad18c7", "6095abfa45a52836f8ad18c8", "6095abfa45a52836f8ad18c9", "6095abfa45a52836f8ad18ca", "6095abfa45a52836f8ad18cb", "6095abfa45a52836f8ad18cc", "6095abfa45a52836f8ad18cd", "6095abfa45a52836f8ad18ce", "6095abfa45a52836f8ad18cf", "6095abfa45a52836f8ad18d0", "6095abfa45a52836f8ad18d1", "6095abfa45a52836f8ad18d2", "6095abfa45a52836f8ad18d3", "6095abfa45a52836f8ad18d4", "6095abfa45a52836f8ad18d5", "6095abfa45a52836f8ad18d6", "6095abfa45a52836f8ad18d7", "6095abfa45a52836f8ad18d8", "6095abfa45a52836f8ad18d9", "6095abfa45a52836f8ad18da", "6095abfa45a52836f8ad18db", "6095abfa45a52836f8ad18dc", "6095abfa45a52836f8ad18dd", "6095abfa45a52836f8ad18de", "6095abfa45a52836f8ad18df", "6095abfa45a52836f8ad18e0", "6095abfa45a52836f8ad18e1", "6095abfa45a52836f8ad18e2", "6095abfa45a52836f8ad18e3", "6095abfa45a52836f8ad18e4", "6095abfa45a52836f8ad18e5", "6095abfa45a52836f8ad18e6", "6095abfa45a52836f8ad18e7", "6095abfa45a52836f8ad18e8", "6095abfa45a52836f8ad18e9", "6095abfa45a52836f8ad18ea", "6095abfa45a52836f8ad18eb", "6095abfa45a52836f8ad18ec", "6095abfa45a52836f8ad18ed", "6095abfa45a52836f8ad18ee"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8445a52836f8ad1ef0",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Shea Moisture",
            "brand_key": "shea-moisture",
            "createdAt": "2021-05-07T21:09:24.873Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30543
        },
        "createdAt": "2021-05-07T21:09:24.900Z",
        "updatedAt": "2021-05-07T21:09:24.900Z"
    }, {
        "_id": "6095ac8545a52836f8ad1ef3",
        "products": ["6095abfa45a52836f8ad18ef", "6095abfa45a52836f8ad18f0", "6095abfa45a52836f8ad18f1", "6095abfa45a52836f8ad18f2"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8445a52836f8ad1ef2",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Show Time",
            "brand_key": "show-time",
            "createdAt": "2021-05-07T21:09:24.980Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30544
        },
        "createdAt": "2021-05-07T21:09:25.022Z",
        "updatedAt": "2021-05-07T21:09:25.022Z"
    }, {
        "_id": "6095ac8545a52836f8ad1ef5",
        "products": ["6095abfa45a52836f8ad18f3", "6095abfa45a52836f8ad18f4", "6095abfa45a52836f8ad18f5", "6095abfa45a52836f8ad18f6", "6095abfa45a52836f8ad18f7", "6095abfa45a52836f8ad18f8", "6095abfa45a52836f8ad18f9", "6095abfa45a52836f8ad18fa", "6095abfa45a52836f8ad18fb", "6095abfa45a52836f8ad18fc", "6095abfa45a52836f8ad18fd", "6095abfa45a52836f8ad18fe", "6095abfa45a52836f8ad18ff", "6095abfa45a52836f8ad1900", "6095abfa45a52836f8ad1901", "6095abfa45a52836f8ad1902", "6095abfa45a52836f8ad1903", "6095abfa45a52836f8ad1904", "6095abfa45a52836f8ad1905", "6095abfa45a52836f8ad1906", "6095abfa45a52836f8ad1907", "6095abfa45a52836f8ad1908", "6095abfa45a52836f8ad1909", "6095abfa45a52836f8ad190a", "6095abfa45a52836f8ad190b", "6095abfa45a52836f8ad190c", "6095abfa45a52836f8ad190d", "6095abfa45a52836f8ad190e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8545a52836f8ad1ef4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Silicon Mix",
            "brand_key": "silicon-mix",
            "createdAt": "2021-05-07T21:09:25.092Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30545
        },
        "createdAt": "2021-05-07T21:09:25.119Z",
        "updatedAt": "2021-05-07T21:09:25.119Z"
    }, {
        "_id": "6095ac8545a52836f8ad1ef5",
        "products": ["6095abfa45a52836f8ad18f3", "6095abfa45a52836f8ad18f4", "6095abfa45a52836f8ad18f5", "6095abfa45a52836f8ad18f6", "6095abfa45a52836f8ad18f7", "6095abfa45a52836f8ad18f8", "6095abfa45a52836f8ad18f9", "6095abfa45a52836f8ad18fa", "6095abfa45a52836f8ad18fb", "6095abfa45a52836f8ad18fc", "6095abfa45a52836f8ad18fd", "6095abfa45a52836f8ad18fe", "6095abfa45a52836f8ad18ff", "6095abfa45a52836f8ad1900", "6095abfa45a52836f8ad1901", "6095abfa45a52836f8ad1902", "6095abfa45a52836f8ad1903", "6095abfa45a52836f8ad1904", "6095abfa45a52836f8ad1905", "6095abfa45a52836f8ad1906", "6095abfa45a52836f8ad1907", "6095abfa45a52836f8ad1908", "6095abfa45a52836f8ad1909", "6095abfa45a52836f8ad190a", "6095abfa45a52836f8ad190b", "6095abfa45a52836f8ad190c", "6095abfa45a52836f8ad190d", "6095abfa45a52836f8ad190e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8545a52836f8ad1ef4",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Skala",
            "brand_key": "skala",
            "createdAt": "2021-05-07T21:09:25.092Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30545
        },
        "createdAt": "2021-05-07T21:09:25.119Z",
        "updatedAt": "2021-05-07T21:09:25.119Z"
    },
             {
        "_id": "6095ac8545a52836f8ad1ef7",
        "products": ["6095abfe45a52836f8ad1978", "6095abfe45a52836f8ad1979", "6095abfe45a52836f8ad197a", "6095abfe45a52836f8ad197b", "6095abfe45a52836f8ad197c", "6095abfe45a52836f8ad197d", "6095abfe45a52836f8ad197e", "6095abfe45a52836f8ad197f", "6095abfe45a52836f8ad1980", "6095abfe45a52836f8ad1981", "6095abfe45a52836f8ad1982", "6095abfe45a52836f8ad1983", "6095abfe45a52836f8ad1984", "6095abfe45a52836f8ad1985", "6095abfe45a52836f8ad1986", "6095abfe45a52836f8ad199b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8545a52836f8ad1ef6",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Sofn' Free",
            "brand_key": "sofn'-free",
            "createdAt": "2021-05-07T21:09:25.187Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30546
        },
        "createdAt": "2021-05-07T21:09:25.217Z",
        "updatedAt": "2021-05-07T21:09:25.217Z"
    }, {
        "_id": "6095ac8545a52836f8ad1ef9",
        "products": ["6095abfe45a52836f8ad1987", "6095abfe45a52836f8ad1988"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8545a52836f8ad1ef8",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Sofnfree N Pretty",
            "brand_key": "sofnfree-n-pretty",
            "createdAt": "2021-05-07T21:09:25.287Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30547
        },
        "createdAt": "2021-05-07T21:09:25.310Z",
        "updatedAt": "2021-05-07T21:09:25.310Z"
    }, {
        "_id": "6095ac8545a52836f8ad1efb",
        "products": ["6095abfe45a52836f8ad1989", "6095abfe45a52836f8ad198a", "6095abfe45a52836f8ad198b", "6095abfe45a52836f8ad198c"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8545a52836f8ad1efa",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Soft & Beautiful",
            "brand_key": "soft-&-beautiful",
            "createdAt": "2021-05-07T21:09:25.374Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30548
        },
        "createdAt": "2021-05-07T21:09:25.412Z",
        "updatedAt": "2021-05-07T21:09:25.412Z"
    }, {
        "_id": "6095ac8545a52836f8ad1eff",
        "products": ["6095abfe45a52836f8ad199c"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8545a52836f8ad1efe",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Softsheen Carson",
            "brand_key": "softsheen-carson",
            "createdAt": "2021-05-07T21:09:25.715Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30550
        },
        "createdAt": "2021-05-07T21:09:25.750Z",
        "updatedAt": "2021-05-07T21:09:25.750Z"
    }, {
        "_id": "6095ac8545a52836f8ad1f01",
        "products": ["6095abfe45a52836f8ad199d", "6095abfe45a52836f8ad199e", "6095abfe45a52836f8ad199f", "6095abfe45a52836f8ad19a0", "6095abfe45a52836f8ad19a1", "6095abfe45a52836f8ad19a2", "6095abfe45a52836f8ad19a3", "6095abfe45a52836f8ad19a4"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8545a52836f8ad1f00",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Soultanicals",
            "brand_key": "soultanicals",
            "createdAt": "2021-05-07T21:09:25.836Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30551
        },
        "createdAt": "2021-05-07T21:09:25.867Z",
        "updatedAt": "2021-05-07T21:09:25.867Z"
    }, {
        "_id": "6095ac8545a52836f8ad1f03",
        "products": ["6095abfe45a52836f8ad19a5", "6095abfe45a52836f8ad19a6"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8545a52836f8ad1f02",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Sportin Waves",
            "brand_key": "sportin-waves",
            "createdAt": "2021-05-07T21:09:25.933Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30552
        },
        "createdAt": "2021-05-07T21:09:25.960Z",
        "updatedAt": "2021-05-07T21:09:25.960Z"
    }, {
        "_id": "6095ac8645a52836f8ad1f05",
        "products": ["6095abfe45a52836f8ad19a7", "6095abfe45a52836f8ad19a8", "6095abfe45a52836f8ad19a9", "6095abfe45a52836f8ad19aa"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8645a52836f8ad1f04",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Spunge",
            "brand_key": "Spunge",
            "createdAt": "2021-05-07T21:09:26.027Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30553
        },
        "createdAt": "2021-05-07T21:09:26.050Z",
        "updatedAt": "2021-05-07T21:09:26.050Z"
    }, {
        "_id": "6095ac8645a52836f8ad1f05",
        "products": ["6095abfe45a52836f8ad19a7", "6095abfe45a52836f8ad19a8", "6095abfe45a52836f8ad19a9", "6095abfe45a52836f8ad19aa"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8645a52836f8ad1f04",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "St.Ives",
            "brand_key": "St.Ives",
            "createdAt": "2021-05-07T21:09:26.027Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30553
        },
        "createdAt": "2021-05-07T21:09:26.050Z",
        "updatedAt": "2021-05-07T21:09:26.050Z"
    }, {
        "_id": "6095ac8645a52836f8ad1f05",
        "products": ["6095abfe45a52836f8ad19a7", "6095abfe45a52836f8ad19a8", "6095abfe45a52836f8ad19a9", "6095abfe45a52836f8ad19aa"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8645a52836f8ad1f04",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Sta Sof Fro",
            "brand_key": "sta-sof-fro",
            "createdAt": "2021-05-07T21:09:26.027Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30553
        },
        "createdAt": "2021-05-07T21:09:26.050Z",
        "updatedAt": "2021-05-07T21:09:26.050Z"
    }, {
        "_id": "6095ac8645a52836f8ad1f07",
        "products": ["6095abfe45a52836f8ad19ab", "6095abfe45a52836f8ad19ac", "6095ac0145a52836f8ad1abd", "6095ac0145a52836f8ad1abe", "6095ac0145a52836f8ad1abf", "6095ac0145a52836f8ad1ac0", "6095ac0145a52836f8ad1ac1"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8645a52836f8ad1f06",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Style Factor",
            "brand_key": "style-factor",
            "createdAt": "2021-05-07T21:09:26.124Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30554
        },
        "createdAt": "2021-05-07T21:09:26.162Z",
        "updatedAt": "2021-05-07T21:09:26.162Z"
    },{
        "_id": "6095ac8645a52836f8ad1f07",
        "products": ["6095abfe45a52836f8ad19ab", "6095abfe45a52836f8ad19ac", "6095ac0145a52836f8ad1abd", "6095ac0145a52836f8ad1abe", "6095ac0145a52836f8ad1abf", "6095ac0145a52836f8ad1ac0", "6095ac0145a52836f8ad1ac1"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8645a52836f8ad1f06",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Style Icon",
            "brand_key": "style-icon",
            "createdAt": "2021-05-07T21:09:26.124Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30554
        },
        "createdAt": "2021-05-07T21:09:26.162Z",
        "updatedAt": "2021-05-07T21:09:26.162Z"
    },
             {
        "_id": "6095ac8645a52836f8ad1f07",
        "products": ["6095abfe45a52836f8ad19ab", "6095abfe45a52836f8ad19ac", "6095ac0145a52836f8ad1abd", "6095ac0145a52836f8ad1abe", "6095ac0145a52836f8ad1abf", "6095ac0145a52836f8ad1ac0", "6095ac0145a52836f8ad1ac1"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8645a52836f8ad1f06",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Style On",
            "brand_key": "style-on",
            "createdAt": "2021-05-07T21:09:26.124Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30554
        },
        "createdAt": "2021-05-07T21:09:26.162Z",
        "updatedAt": "2021-05-07T21:09:26.162Z"
    }, {
        "_id": "6095ac8645a52836f8ad1f09",
        "products": ["6095abfe45a52836f8ad19ae", "6095abfe45a52836f8ad19af", "6095abfe45a52836f8ad19b0", "6095abfe45a52836f8ad19b1", "6095abfe45a52836f8ad19b2"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8645a52836f8ad1f08",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Styling Dredz",
            "brand_key": "styling-dredz",
            "createdAt": "2021-05-07T21:09:26.338Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30555
        },
        "createdAt": "2021-05-07T21:09:26.374Z",
        "updatedAt": "2021-05-07T21:09:26.374Z"
    }, {
        "_id": "6095ac8645a52836f8ad1f0d",
        "products": ["6095abfe45a52836f8ad19b4", "6095abfe45a52836f8ad19b5"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8645a52836f8ad1f0c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Sulfur 8",
            "brand_key": "sulfur-8",
            "createdAt": "2021-05-07T21:09:26.559Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30557
        },
        "createdAt": "2021-05-07T21:09:26.594Z",
        "updatedAt": "2021-05-07T21:09:26.594Z"
    }, {
        "_id": "6095ac8645a52836f8ad1f11",
        "products": ["6095abfe45a52836f8ad19db", "6095abfe45a52836f8ad19dc", "6095abfe45a52836f8ad19dd", "6095abfe45a52836f8ad19de", "6095abfe45a52836f8ad19df", "6095abfe45a52836f8ad19e0", "6095abfe45a52836f8ad19e1", "6095abfe45a52836f8ad19e2", "6095abfe45a52836f8ad19e3", "6095abfe45a52836f8ad19e4", "6095abfe45a52836f8ad19e5", "6095abfe45a52836f8ad19e6", "6095abfe45a52836f8ad19e7", "6095abfe45a52836f8ad19e8", "6095abfe45a52836f8ad19e9", "6095abfe45a52836f8ad19ea", "6095abfe45a52836f8ad19eb", "6095abfe45a52836f8ad19ec", "6095abfe45a52836f8ad19ed", "6095abfe45a52836f8ad19ee", "6095abfe45a52836f8ad19ef", "6095abfe45a52836f8ad19f0", "6095abfe45a52836f8ad19f1", "6095abfe45a52836f8ad19f2", "6095abfe45a52836f8ad19f3", "6095abfe45a52836f8ad19f4", "6095abfe45a52836f8ad19f5", "6095abfe45a52836f8ad19f6", "6095abfe45a52836f8ad19f7", "6095abfe45a52836f8ad19f8", "6095abfe45a52836f8ad19f9", "6095abfe45a52836f8ad19fa", "6095abfe45a52836f8ad19fb", "6095abfe45a52836f8ad19fc", "6095abfe45a52836f8ad19fd", "6095abfe45a52836f8ad19fe", "6095abfe45a52836f8ad19ff", "6095abfe45a52836f8ad1a00", "6095abfe45a52836f8ad1a01", "6095abfe45a52836f8ad1a02", "6095abfe45a52836f8ad1a03", "6095abfe45a52836f8ad1a04", "6095abfe45a52836f8ad1a05", "6095abfe45a52836f8ad1a06", "6095abfe45a52836f8ad1a07", "6095abfe45a52836f8ad1a08", "6095abfe45a52836f8ad1a09", "6095abfe45a52836f8ad1a0a", "6095abfe45a52836f8ad1a0b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8645a52836f8ad1f10",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Taliah Waajid",
            "brand_key": "taliah-waajid",
            "createdAt": "2021-05-07T21:09:26.795Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30559
        },
        "createdAt": "2021-05-07T21:09:26.829Z",
        "updatedAt": "2021-05-07T21:09:26.829Z"
    }, {
        "_id": "6095ac8645a52836f8ad1f13",
        "products": ["6095abfe45a52836f8ad1a0c", "6095abfe45a52836f8ad1a0d", "6095abfe45a52836f8ad1a0e", "6095abfe45a52836f8ad1a0f", "6095abfe45a52836f8ad1a10", "6095abfe45a52836f8ad1a11", "6095abfe45a52836f8ad1a12", "6095abfe45a52836f8ad1a13"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8645a52836f8ad1f12",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "TCB",
            "brand_key": "tcb",
            "createdAt": "2021-05-07T21:09:26.891Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30560
        },
        "createdAt": "2021-05-07T21:09:26.913Z",
        "updatedAt": "2021-05-07T21:09:26.913Z"
    }, {
        "_id": "6095ac8645a52836f8ad1f15",
        "products": ["6095abfe45a52836f8ad1a14", "6095abfe45a52836f8ad1a15", "6095abfe45a52836f8ad1a16", "6095abfe45a52836f8ad1a17", "6095abfe45a52836f8ad1a18", "6095abfe45a52836f8ad1a19", "6095abfe45a52836f8ad1a1a", "6095abfe45a52836f8ad1a1b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8645a52836f8ad1f14",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Texture my way",
            "brand_key": "texture-my-way",
            "createdAt": "2021-05-07T21:09:26.978Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30561
        },
        "createdAt": "2021-05-07T21:09:26.999Z",
        "updatedAt": "2021-05-07T21:09:26.999Z"
    }, {
        "_id": "6095ac8745a52836f8ad1f17",
        "products": ["6095abfe45a52836f8ad1a1c", "6095abfe45a52836f8ad1a1d", "6095abfe45a52836f8ad1a1e", "6095abfe45a52836f8ad1a1f", "6095abfe45a52836f8ad1a20", "6095abfe45a52836f8ad1a21", "6095abfe45a52836f8ad1a22", "6095abfe45a52836f8ad1a23"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8745a52836f8ad1f16",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "TGIN",
            "brand_key": "tgin",
            "createdAt": "2021-05-07T21:09:27.062Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30562
        },
        "createdAt": "2021-05-07T21:09:27.089Z",
        "updatedAt": "2021-05-07T21:09:27.089Z"
    }, {
        "_id": "6095ac8745a52836f8ad1f19",
        "products": ["6095abfe45a52836f8ad1a25", "6095abfe45a52836f8ad1a26", "6095abfe45a52836f8ad1a27", "6095ac0145a52836f8ad1a28", "6095ac0145a52836f8ad1a29", "6095ac0145a52836f8ad1a2a", "6095ac0145a52836f8ad1a2b", "6095ac0145a52836f8ad1a2c", "6095ac0145a52836f8ad1a2d", "6095ac0145a52836f8ad1a2e", "6095ac0145a52836f8ad1a2f", "6095ac0145a52836f8ad1a30", "6095ac0145a52836f8ad1a31", "6095ac0145a52836f8ad1a32", "6095ac0145a52836f8ad1a33", "6095ac0145a52836f8ad1a34", "6095ac0145a52836f8ad1a35", "6095ac0145a52836f8ad1a36", "6095ac0145a52836f8ad1a37", "6095ac0145a52836f8ad1a38", "6095ac0145a52836f8ad1a39", "6095ac0145a52836f8ad1a3a", "6095ac0145a52836f8ad1a3b", "6095ac0145a52836f8ad1a3c", "6095ac0145a52836f8ad1a3d", "6095ac0145a52836f8ad1a3e", "6095ac0145a52836f8ad1a3f", "6095ac0145a52836f8ad1a40", "6095ac0145a52836f8ad1a41", "6095ac0145a52836f8ad1a42", "6095ac0145a52836f8ad1a43", "6095ac0145a52836f8ad1a44", "6095ac0145a52836f8ad1a45", "6095ac0145a52836f8ad1a46", "6095ac0145a52836f8ad1a47", "6095ac0145a52836f8ad1a48", "6095ac0145a52836f8ad1a49", "6095ac0145a52836f8ad1a4a", "6095ac0145a52836f8ad1a4b", "6095ac0145a52836f8ad1a4c", "6095ac0145a52836f8ad1a4d", "6095ac0145a52836f8ad1a4e", "6095ac0145a52836f8ad1a4f", "6095ac0145a52836f8ad1a50", "6095ac0145a52836f8ad1a51", "6095ac0145a52836f8ad1a52", "6095ac0145a52836f8ad1a53", "6095ac0145a52836f8ad1a54", "6095ac0145a52836f8ad1a55", "6095ac0145a52836f8ad1a56", "6095ac0145a52836f8ad1a57", "6095ac0145a52836f8ad1a58", "6095ac0145a52836f8ad1a59"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8745a52836f8ad1f18",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "The Mane Choice",
            "brand_key": "the-mane-choice",
            "createdAt": "2021-05-07T21:09:27.178Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30563
        },
        "createdAt": "2021-05-07T21:09:27.203Z",
        "updatedAt": "2021-05-07T21:09:27.203Z"
    }, {
        "_id": "6095ac8745a52836f8ad1f1b",
        "products": ["6095ac0145a52836f8ad1a5a", "6095ac0145a52836f8ad1a5b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8745a52836f8ad1f1a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "The Doux",
            "brand_key": "the-doux",
            "createdAt": "2021-05-07T21:09:27.282Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30564
        },
        "createdAt": "2021-05-07T21:09:27.310Z",
        "updatedAt": "2021-05-07T21:09:27.310Z"
    }, {
        "_id": "6095ac8745a52836f8ad1f1b",
        "products": ["6095ac0145a52836f8ad1a5a", "6095ac0145a52836f8ad1a5b"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8745a52836f8ad1f1a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "TiGi",
            "brand_key": "tigi",
            "createdAt": "2021-05-07T21:09:27.282Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30564
        },
        "createdAt": "2021-05-07T21:09:27.310Z",
        "updatedAt": "2021-05-07T21:09:27.310Z"
    }, {
        "_id": "6095ac8745a52836f8ad1f1d",
        "products": ["6095ac0145a52836f8ad1a5c"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8745a52836f8ad1f1c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Tinkle",
            "brand_key": "tinkle",
            "createdAt": "2021-05-07T21:09:27.375Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30565
        },
        "createdAt": "2021-05-07T21:09:27.399Z",
        "updatedAt": "2021-05-07T21:09:27.399Z"
    }, {
        "_id": "6095ac8745a52836f8ad1f1f",
        "products": ["6095ac0145a52836f8ad1a5d"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8745a52836f8ad1f1e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Treet",
            "brand_key": "treet",
            "createdAt": "2021-05-07T21:09:27.461Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30566
        },
        "createdAt": "2021-05-07T21:09:27.483Z",
        "updatedAt": "2021-05-07T21:09:27.483Z"
    }, {
        "_id": "6095ac8745a52836f8ad1f21",
        "products": ["6095ac0145a52836f8ad1a5f", "6095ac0145a52836f8ad1a60"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8745a52836f8ad1f20",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Tresemme",
            "brand_key": "Tresemme",
            "createdAt": "2021-05-07T21:09:27.646Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30567
        },
        "createdAt": "2021-05-07T21:09:27.677Z",
        "updatedAt": "2021-05-07T21:09:27.677Z"
    },{
        "_id": "6095ac8745a52836f8ad1f21",
        "products": ["6095ac0145a52836f8ad1a5f", "6095ac0145a52836f8ad1a60"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8745a52836f8ad1f20",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Tura",
            "brand_key": "tura",
            "createdAt": "2021-05-07T21:09:27.646Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30567
        },
        "createdAt": "2021-05-07T21:09:27.677Z",
        "updatedAt": "2021-05-07T21:09:27.677Z"
    }, {
        "_id": "6095ac8745a52836f8ad1f23",
        "products": ["6095ac0145a52836f8ad1a61"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8745a52836f8ad1f22",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Tweexy",
            "brand_key": "tweexy",
            "createdAt": "2021-05-07T21:09:27.750Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30568
        },
        "createdAt": "2021-05-07T21:09:27.787Z",
        "updatedAt": "2021-05-07T21:09:27.787Z"
    }, {
        "_id": "6095ac8745a52836f8ad1f23",
        "products": ["6095ac0145a52836f8ad1a61"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8745a52836f8ad1f22",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Twist",
            "brand_key": "twist",
            "createdAt": "2021-05-07T21:09:27.750Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30568
        },
        "createdAt": "2021-05-07T21:09:27.787Z",
        "updatedAt": "2021-05-07T21:09:27.787Z"
    }, {
        "_id": "6095ac8745a52836f8ad1f25",
        "products": ["6095ac0145a52836f8ad1a62", "6095ac0145a52836f8ad1a63", "6095ac0145a52836f8ad1a64", "6095ac0145a52836f8ad1a65", "6095ac0145a52836f8ad1a66", "6095ac0145a52836f8ad1a67", "6095ac0145a52836f8ad1a68", "6095ac0145a52836f8ad1a69", "6095ac0145a52836f8ad1a6a", "6095ac0145a52836f8ad1a6b", "6095ac0145a52836f8ad1a6c", "6095ac0145a52836f8ad1a6d", "6095ac0145a52836f8ad1a6e", "6095ac0145a52836f8ad1a6f", "6095ac0145a52836f8ad1a70"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8745a52836f8ad1f24",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Umberto Giannini",
            "brand_key": "umberto-giannini",
            "createdAt": "2021-05-07T21:09:27.856Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30569
        },
        "createdAt": "2021-05-07T21:09:27.889Z",
        "updatedAt": "2021-05-07T21:09:27.889Z"
    }, {
        "_id": "6095ac8745a52836f8ad1f27",
        "products": ["6095ac0145a52836f8ad1a71", "6095ac0145a52836f8ad1a72", "6095ac0145a52836f8ad1a73", "6095ac0145a52836f8ad1a74", "6095ac0145a52836f8ad1a75", "6095ac0145a52836f8ad1a76", "6095ac0145a52836f8ad1a77", "6095ac0145a52836f8ad1a78", "6095ac0145a52836f8ad1a79", "6095ac0145a52836f8ad1a7a"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8745a52836f8ad1f26",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Uncle Funky's Daughter",
            "brand_key": "uncle-funky's-daughter",
            "createdAt": "2021-05-07T21:09:27.960Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30570
        },
        "createdAt": "2021-05-07T21:09:27.991Z",
        "updatedAt": "2021-05-07T21:09:27.991Z"
    }, {
        "_id": "6095ac8845a52836f8ad1f29",
        "products": ["6095ac0145a52836f8ad1a7b", "6095ac0145a52836f8ad1a7c", "6095ac0145a52836f8ad1a7d", "6095ac0145a52836f8ad1a7e"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8845a52836f8ad1f28",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Uncle Jimmy",
            "brand_key": "uncle-jimmy",
            "createdAt": "2021-05-07T21:09:28.062Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30571
        },
        "createdAt": "2021-05-07T21:09:28.084Z",
        "updatedAt": "2021-05-07T21:09:28.084Z"
    }, {
        "_id": "6095ac8845a52836f8ad1f2b",
        "products": ["6095ac0145a52836f8ad1a7f", "6095ac0145a52836f8ad1a80", "6095ac0145a52836f8ad1a81", "6095ac0145a52836f8ad1a82", "6095ac0145a52836f8ad1a83", "6095ac0145a52836f8ad1a84"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8845a52836f8ad1f2a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Uniq One",
            "brand_key": "uniq-one",
            "createdAt": "2021-05-07T21:09:28.151Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30572
        },
        "createdAt": "2021-05-07T21:09:28.178Z",
        "updatedAt": "2021-05-07T21:09:28.178Z"
    }, {
        "_id": "6095ac8845a52836f8ad1f2d",
        "products": ["6095ac0145a52836f8ad1a85", "6095ac0145a52836f8ad1a85"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8845a52836f8ad1f2c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Valera",
            "brand_key": "valera",
            "createdAt": "2021-05-07T21:09:28.241Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30573
        },
        "createdAt": "2021-05-07T21:09:28.263Z",
        "updatedAt": "2021-05-07T21:09:28.422Z"
    }, {
        "_id": "6095ac8845a52836f8ad1f2f",
        "products": ["6095ac0145a52836f8ad1a86", "6095ac0145a52836f8ad1a87", "6095ac0145a52836f8ad1a88", "6095ac0145a52836f8ad1a89", "6095ac0145a52836f8ad1a8a", "6095ac0145a52836f8ad1a86", "6095ac0145a52836f8ad1a87", "6095ac0145a52836f8ad1a88", "6095ac0145a52836f8ad1a89", "6095ac0145a52836f8ad1a8a"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8845a52836f8ad1f2e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Vaseline",
            "brand_key": "vaseline",
            "createdAt": "2021-05-07T21:09:28.373Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30574
        },
        "createdAt": "2021-05-07T21:09:28.399Z",
        "updatedAt": "2021-05-07T21:09:28.485Z"
    }, {
        "_id": "6095ac8845a52836f8ad1f31",
        "products": ["6095ac0145a52836f8ad1a8b", "6095ac0145a52836f8ad1a8c", "6095ac0145a52836f8ad1a8d", "6095ac0145a52836f8ad1a8e", "6095ac0145a52836f8ad1a8f", "6095ac0145a52836f8ad1a90", "6095ac0145a52836f8ad1a91", "6095ac0145a52836f8ad1a92", "6095ac0145a52836f8ad1a93", "6095ac0145a52836f8ad1a94", "6095ac0145a52836f8ad1a95", "6095ac0145a52836f8ad1a96", "6095ac0145a52836f8ad1a97", "6095ac0145a52836f8ad1a8b", "6095ac0145a52836f8ad1a8c", "6095ac0145a52836f8ad1a8d", "6095ac0145a52836f8ad1a8e", "6095ac0145a52836f8ad1a8f", "6095ac0145a52836f8ad1a90", "6095ac0145a52836f8ad1a91", "6095ac0145a52836f8ad1a92", "6095ac0145a52836f8ad1a93", "6095ac0145a52836f8ad1a94", "6095ac0145a52836f8ad1a95", "6095ac0145a52836f8ad1a96", "6095ac0145a52836f8ad1a97"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8845a52836f8ad1f30",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Vatika",
            "brand_key": "vatika",
            "createdAt": "2021-05-07T21:09:28.483Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30575
        },
        "createdAt": "2021-05-07T21:09:28.506Z",
        "updatedAt": "2021-05-07T21:09:28.543Z"
    }, {
        "_id": "6095ac8845a52836f8ad1f33",
        "products": ["6095ac0145a52836f8ad1aac", "6095ac0145a52836f8ad1aad", "6095ac0145a52836f8ad1aae", "6095ac0145a52836f8ad1aaf", "6095ac0145a52836f8ad1ab0", "6095ac0145a52836f8ad1ab1", "6095ac0145a52836f8ad1ab2", "6095ac0145a52836f8ad1ab3", "6095ac0145a52836f8ad1ab4"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8845a52836f8ad1f32",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Veinira",
            "brand_key": "Veinira",
            "createdAt": "2021-05-07T21:09:28.656Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30576
        },
        "createdAt": "2021-05-07T21:09:28.678Z",
        "updatedAt": "2021-05-07T21:09:28.678Z"
    },  {
        "_id": "6095ac8845a52836f8ad1f33",
        "products": ["6095ac0145a52836f8ad1aac", "6095ac0145a52836f8ad1aad", "6095ac0145a52836f8ad1aae", "6095ac0145a52836f8ad1aaf", "6095ac0145a52836f8ad1ab0", "6095ac0145a52836f8ad1ab1", "6095ac0145a52836f8ad1ab2", "6095ac0145a52836f8ad1ab3", "6095ac0145a52836f8ad1ab4"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8845a52836f8ad1f32",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Vitale",
            "brand_key": "vitale",
            "createdAt": "2021-05-07T21:09:28.656Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30576
        },
        "createdAt": "2021-05-07T21:09:28.678Z",
        "updatedAt": "2021-05-07T21:09:28.678Z"
    }, {
        "_id": "6095ac8845a52836f8ad1f35",
        "products": ["6095ac0145a52836f8ad1aac", "6095ac0145a52836f8ad1aad", "6095ac0145a52836f8ad1aae", "6095ac0145a52836f8ad1aaf", "6095ac0145a52836f8ad1ab0", "6095ac0145a52836f8ad1ab1", "6095ac0145a52836f8ad1ab2", "6095ac0145a52836f8ad1ab3", "6095ac0145a52836f8ad1ab4"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8845a52836f8ad1f34",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Vitale",
            "brand_key": "vitale-1",
            "createdAt": "2021-05-07T21:09:28.684Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30577
        },
        "createdAt": "2021-05-07T21:09:28.706Z",
        "updatedAt": "2021-05-07T21:09:28.706Z"
    }, {
        "_id": "6095ac8845a52836f8ad1f39",
        "products": ["6095ac0145a52836f8ad1ab5", "6095ac0145a52836f8ad1ab6", "6095ac0145a52836f8ad1ab7", "6095ac0145a52836f8ad1ab8", "6095ac0145a52836f8ad1ab9", "6095ac0145a52836f8ad1aba", "6095ac0145a52836f8ad1abb"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8845a52836f8ad1f38",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Wahl",
            "brand_key": "wahl-1",
            "createdAt": "2021-05-07T21:09:28.772Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30579
        },
        "createdAt": "2021-05-07T21:09:28.804Z",
        "updatedAt": "2021-05-07T21:09:28.804Z"
    },  {
        "_id": "6095ac8845a52836f8ad1f3d",
        "products": ["6095ac0145a52836f8ad1abc"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8845a52836f8ad1f3c",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Walker Tape",
            "brand_key": "walker-tape-1",
            "createdAt": "2021-05-07T21:09:28.864Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30581
        },
        "createdAt": "2021-05-07T21:09:28.886Z",
        "updatedAt": "2021-05-07T21:09:28.886Z"
    }, {
        "_id": "6095ac8845a52836f8ad1f3f",
        "products": ["6095ac0145a52836f8ad1ac2", "6095ac0145a52836f8ad1ac3", "6095ac0145a52836f8ad1ac4", "6095ac0145a52836f8ad1ac5", "6095ac0145a52836f8ad1ac6", "6095ac0145a52836f8ad1ac7", "6095ac0145a52836f8ad1ac8", "6095ac0145a52836f8ad1ac9", "6095ac0145a52836f8ad1aca", "6095ac0145a52836f8ad1acb", "6095ac0145a52836f8ad1acc", "6095ac0145a52836f8ad1acd", "6095ac0145a52836f8ad1ace"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8845a52836f8ad1f3e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Wave Nouveau",
            "brand_key": "wave-nouveau",
            "createdAt": "2021-05-07T21:09:28.917Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30582
        },
        "createdAt": "2021-05-07T21:09:28.939Z",
        "updatedAt": "2021-05-07T21:09:28.939Z"
    }, {
        "_id": "6095ac8945a52836f8ad1f43",
        "products": ["6095ac0145a52836f8ad1acf", "6095ac0145a52836f8ad1ad0", "6095ac0145a52836f8ad1ad1", "6095ac0145a52836f8ad1ad2", "6095ac0145a52836f8ad1ad3", "6095ac0145a52836f8ad1ad4", "6095ac0145a52836f8ad1ad5", "6095ac0145a52836f8ad1ad6", "6095ac0145a52836f8ad1ad7", "6095ac0145a52836f8ad1ad8", "6095ac0145a52836f8ad1ad9", "6095ac0145a52836f8ad1ada", "6095ac0145a52836f8ad1adb", "6095ac0145a52836f8ad1adc", "6095ac0145a52836f8ad1add", "6095ac0145a52836f8ad1ade", "6095ac0145a52836f8ad1adf", "6095ac0145a52836f8ad1ae0", "6095ac0145a52836f8ad1ae1", "6095ac0145a52836f8ad1ae2", "6095ac0145a52836f8ad1ae3", "6095ac0145a52836f8ad1ae4", "6095ac0145a52836f8ad1ae5", "6095ac0145a52836f8ad1ae6", "6095ac0145a52836f8ad1ae7", "6095ac0145a52836f8ad1ae8", "6095ac0145a52836f8ad1ae9", "6095ac0145a52836f8ad1aea", "6095ac0145a52836f8ad1aeb", "6095ac0145a52836f8ad1aec", "6095ac0145a52836f8ad1aed", "6095ac0145a52836f8ad1aee", "6095ac0145a52836f8ad1aef", "6095ac0145a52836f8ad1af0", "6095ac0145a52836f8ad1af1", "6095ac0145a52836f8ad1af2", "6095ac0145a52836f8ad1af3", "6095ac0145a52836f8ad1af4", "6095ac0145a52836f8ad1af5", "6095ac0145a52836f8ad1af6", "6095ac0145a52836f8ad1af7", "6095ac0145a52836f8ad1acf", "6095ac0145a52836f8ad1ad0", "6095ac0145a52836f8ad1ad1", "6095ac0145a52836f8ad1ad2", "6095ac0145a52836f8ad1ad3", "6095ac0145a52836f8ad1ad4", "6095ac0145a52836f8ad1ad5", "6095ac0145a52836f8ad1ad6", "6095ac0145a52836f8ad1ad7", "6095ac0145a52836f8ad1ad8", "6095ac0145a52836f8ad1ad9", "6095ac0145a52836f8ad1ada", "6095ac0145a52836f8ad1adb", "6095ac0145a52836f8ad1adc", "6095ac0145a52836f8ad1add", "6095ac0145a52836f8ad1ade", "6095ac0145a52836f8ad1adf", "6095ac0145a52836f8ad1ae0", "6095ac0145a52836f8ad1ae1", "6095ac0145a52836f8ad1ae2", "6095ac0145a52836f8ad1ae3", "6095ac0145a52836f8ad1ae4", "6095ac0145a52836f8ad1ae5", "6095ac0145a52836f8ad1ae6", "6095ac0145a52836f8ad1ae7", "6095ac0145a52836f8ad1ae8", "6095ac0145a52836f8ad1ae9", "6095ac0145a52836f8ad1aea", "6095ac0145a52836f8ad1aeb", "6095ac0145a52836f8ad1aec", "6095ac0145a52836f8ad1aed", "6095ac0145a52836f8ad1aee", "6095ac0145a52836f8ad1aef", "6095ac0145a52836f8ad1af0", "6095ac0145a52836f8ad1af1", "6095ac0145a52836f8ad1af2", "6095ac0145a52836f8ad1af3", "6095ac0145a52836f8ad1af4", "6095ac0145a52836f8ad1af5", "6095ac0145a52836f8ad1af6", "6095ac0145a52836f8ad1af7"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8945a52836f8ad1f42",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Wella",
            "brand_key": "wella",
            "createdAt": "2021-05-07T21:09:29.000Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30584
        },
        "createdAt": "2021-05-07T21:09:29.025Z",
        "updatedAt": "2021-05-07T21:09:29.063Z"
    },  {
        "_id": "6095ac8945a52836f8ad1f47",
        "products": ["6095ac0145a52836f8ad1af8", "6095ac0145a52836f8ad1af9", "6095ac0145a52836f8ad1afa", "6095ac0145a52836f8ad1afb", "6095ac0145a52836f8ad1afc", "6095ac0145a52836f8ad1afd", "6095ac0145a52836f8ad1afe", "6095ac0145a52836f8ad1aff"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8945a52836f8ad1f46",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Wet Line Xtreme",
            "brand_key": "wet-line-xtreme-1",
            "createdAt": "2021-05-07T21:09:29.134Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30586
        },
        "createdAt": "2021-05-07T21:09:29.154Z",
        "updatedAt": "2021-05-07T21:09:29.154Z"
    }, {
        "_id": "6095ac8945a52836f8ad1f49",
        "products": ["6095ac0145a52836f8ad1b00", "6095ac0145a52836f8ad1b01"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8945a52836f8ad1f48",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "White Express",
            "brand_key": "white-express",
            "createdAt": "2021-05-07T21:09:29.190Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30587
        },
        "createdAt": "2021-05-07T21:09:29.213Z",
        "updatedAt": "2021-05-07T21:09:29.213Z"
    }, {
        "_id": "6095ac8945a52836f8ad1f4f",
        "products": ["6095ac0145a52836f8ad1b02", "6095ac0145a52836f8ad1b03"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8945a52836f8ad1f4e",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Wild Growth Oil",
            "brand_key": "wild-growth-oil-1",
            "createdAt": "2021-05-07T21:09:29.319Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30590
        },
        "createdAt": "2021-05-07T21:09:29.342Z",
        "updatedAt": "2021-05-07T21:09:29.342Z"
    },  {
        "_id": "6095ac8945a52836f8ad1f53",
        "products": ["6095ac0145a52836f8ad1b04", "6095ac0145a52836f8ad1b05", "6095ac0145a52836f8ad1b06"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8945a52836f8ad1f52",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "World of Curls",
            "brand_key": "world-of-curls-1",
            "createdAt": "2021-05-07T21:09:29.427Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30592
        },
        "createdAt": "2021-05-07T21:09:29.453Z",
        "updatedAt": "2021-05-07T21:09:29.453Z"
    },  {
        "_id": "6095ac8945a52836f8ad1f57",
        "products": ["6095ac0145a52836f8ad1b10", "6095ac0145a52836f8ad1b11", "6095ac0145a52836f8ad1b12"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8945a52836f8ad1f56",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Xtrase",
            "brand_key": "xtrase-1",
            "createdAt": "2021-05-07T21:09:29.584Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30594
        },
        "createdAt": "2021-05-07T21:09:29.612Z",
        "updatedAt": "2021-05-07T21:09:29.612Z"
    },{
        "_id": "6095ac8945a52836f8ad1f5b",
        "products": ["6095ac0145a52836f8ad1b13", "6095ac0145a52836f8ad1b14", "6095ac0145a52836f8ad1b15", "6095ac0145a52836f8ad1b16", "6095ac0145a52836f8ad1b17", "6095ac0145a52836f8ad1b18", "6095ac0145a52836f8ad1b19", "6095ac0145a52836f8ad1b1a", "6095ac0145a52836f8ad1b1b", "6095ac0145a52836f8ad1b1c", "6095ac0145a52836f8ad1b1d", "6095ac0145a52836f8ad1b1e", "6095ac0145a52836f8ad1b1f", "6095ac0145a52836f8ad1b20", "6095ac0145a52836f8ad1b21", "6095ac0245a52836f8ad1b22", "6095ac0245a52836f8ad1b23", "6095ac0245a52836f8ad1b24", "6095ac0245a52836f8ad1b25", "6095ac0245a52836f8ad1b26", "6095ac0245a52836f8ad1b27", "6095ac0245a52836f8ad1b28", "6095ac0245a52836f8ad1b29", "6095ac0245a52836f8ad1b2a", "6095ac0245a52836f8ad1b2b", "6095ac0245a52836f8ad1b2c", "6095ac0245a52836f8ad1b2d", "6095ac0245a52836f8ad1b2e", "6095ac0245a52836f8ad1b2f", "6095ac0245a52836f8ad1b30", "6095ac0245a52836f8ad1b31", "6095ac0245a52836f8ad1b32", "6095ac0245a52836f8ad1b33", "6095ac0245a52836f8ad1b34", "6095ac0245a52836f8ad1b35", "6095ac0245a52836f8ad1b3d", "6095ac0245a52836f8ad1b3e", "6095ac0245a52836f8ad1b3f", "6095ac0245a52836f8ad1b40", "6095ac0245a52836f8ad1b41", "6095ac0245a52836f8ad1b42", "6095ac0245a52836f8ad1b43", "6095ac0245a52836f8ad1b44", "6095ac0245a52836f8ad1b45", "6095ac0245a52836f8ad1b46"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8945a52836f8ad1f5a",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Yari",
            "brand_key": "yari",
            "createdAt": "2021-05-07T21:09:29.689Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30596
        },
        "createdAt": "2021-05-07T21:09:29.712Z",
        "updatedAt": "2021-05-07T21:09:29.712Z"
    },  {
        "_id": "6095ac8945a52836f8ad1f5f",
        "products": ["6095ac0245a52836f8ad1b36", "6095ac0245a52836f8ad1b37", "6095ac0245a52836f8ad1b38", "6095ac0245a52836f8ad1b39", "6095ac0245a52836f8ad1b3a", "6095ac0245a52836f8ad1b3b", "6095ac0245a52836f8ad1b3c"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8945a52836f8ad1f5d",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Yari Fruity Curls",
            "brand_key": "yari-fruity-curls",
            "createdAt": "2021-05-07T21:09:29.775Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30598
        },
        "createdAt": "2021-05-07T21:09:29.801Z",
        "updatedAt": "2021-05-07T21:09:29.801Z"
    },  {
        "_id": "6095ac8945a52836f8ad1f5f",
        "products": ["6095ac0245a52836f8ad1b36", "6095ac0245a52836f8ad1b37", "6095ac0245a52836f8ad1b38", "6095ac0245a52836f8ad1b39", "6095ac0245a52836f8ad1b3a", "6095ac0245a52836f8ad1b3b", "6095ac0245a52836f8ad1b3c"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8945a52836f8ad1f5d",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Yari Green",
            "brand_key": "yari-green",
            "createdAt": "2021-05-07T21:09:29.775Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30598
        },
        "createdAt": "2021-05-07T21:09:29.801Z",
        "updatedAt": "2021-05-07T21:09:29.801Z"
    },  {
        "_id": "6095ac8945a52836f8ad1f63",
        "products": ["6095ac0245a52836f8ad1b47"],
        "shop_id": "6095abc845a52836f8ad0b54",
        "brand_id": {
            "_id": "6095ac8945a52836f8ad1f61",
            "is_feature": false,
            "is_disabled": false,
            "isDelete": false,
            "shop_id": "6095abc845a52836f8ad0b54",
            "brand_name": "Yes To Carrots",
            "brand_key": "yes-to-carrots",
            "createdAt": "2021-05-07T21:09:29.869Z",
            "updatedAt": "2021-05-11T11:39:26.810Z",
            "position": 30600
        },
        "createdAt": "2021-05-07T21:09:29.894Z",
        "updatedAt": "2021-05-07T21:09:29.894Z"
    }]
};

function get_position(inp, pos) {

    switch (pos) {
        case 1:
            // center
            inp.classList.add("aht-center");

            break;
        case 2:
            // right
            inp.classList.add("aht-right");

            break;
        case 3:
            // left
            inp.classList.add("aht-left");

            break;
        case '1':
            // center
            inp.classList.add("aht-center");

            break;
        case '2':
            // right
            inp.classList.add("aht-right");

            break;
        case '3':
            // left
            inp.classList.add("aht-left");

            break;
        default:
            inp.classList.add("aht-left");
    }
}

var brands_new = brands.data.filter(function(brand) {
    if (!brand.brand_id) {
        return false; // skip
    }
    return true;
})

var main_title = document.createTextNode(page_title.data.page_title_setting.label);
if (document.getElementById("aht-page-title")) {
    document.getElementById("aht-page-title").appendChild(main_title);
}

var sb_title = document.createTextNode(setting.data.search_box_setting.title_setting.label);
if (document.getElementById("search-box-title")) {
    document.getElementById("search-box-title").appendChild(sb_title);
    if (setting.data.search_box_setting.title_setting.font_bold) {
        document.getElementById("search-box-title").classList.add("aht-bold");
    }
    get_position(document.getElementById("search-box-title"), setting.data.search_box_setting.title_setting.align);
}

var fb_title = document.createTextNode(setting.data.featured_brand_setting.title_setting.label);

var bl_title = document.createTextNode(setting.data.brand_list_setting.title_setting.label);
if (document.getElementById("brand-list-title") != null) {
    document.getElementById("brand-list-title").appendChild(bl_title);
    if (setting.data.brand_list_setting.title_setting.font_bold) {
        document.getElementById("brand-list-title").classList.add("aht-bold");
    }
    get_position(document.getElementById("brand-list-title"), setting.data.brand_list_setting.title_setting.align);
}

var al_title = document.createTextNode(setting.data.alphabet_list_setting.title_setting.label);
if (document.getElementById("alphabet-list-title") != null) {
    document.getElementById("alphabet-list-title").appendChild(al_title);
    if (setting.data.alphabet_list_setting.title_setting.font_bold) {
        document.getElementById("alphabet-list-title").classList.add("aht-bold");
    }
    get_position(document.getElementById("alphabet-list-title"), setting.data.alphabet_list_setting.title_setting.align);
}

// Alphabet section
var alphabet = setting.data.alphabet_list_setting.general_setting.alphabet.toUpperCase().split(',');
alphabet = Array.from(new Set(alphabet));


var alphabet_list = [];
alphabet.map((value, index) => {
    if (value != '') {
        const check_exist = brands_new
            .filter(brand => {

                return brand.brand_id.brand_name.charAt(0).toLowerCase().indexOf(value.toLowerCase()) >= 0;

            })

        if (check_exist.length > 0) {
            alphabet_list.push({
                'character': value,
                'brand': check_exist
            });
        };
    }
})


function render_alphabet_list() {
    var root = document.getElementById('aht-alphabet-list');
    const div_root = document.createElement("div");
    div_root.setAttribute("class", "aht-row-wrapper aht-row-mobile-1");
    if (parseInt(setting.data.alphabet_list_setting.general_setting.character_per_row) > 3) {
        div_root.classList.add("aht-row-tablet-3");
        div_root.classList.add("aht-row-" + setting.data.alphabet_list_setting.general_setting.character_per_row);
    } else {
        div_root.classList.add("aht-row-tablet-" + setting.data.alphabet_list_setting.general_setting.character_per_row);
        div_root.classList.add("aht-row-" + setting.data.alphabet_list_setting.general_setting.character_per_row);
    }
    root.appendChild(div_root);
    alphabet_list.map((value, index) => {
        const div_brand = document.createElement("div");
        div_brand.setAttribute("class", "aht-row-wrapper aht-row-mobile-" + setting.data.alphabet_list_setting.general_setting.brand_per_row_mobile + " aht-row-tablet-" + setting.data.alphabet_list_setting.general_setting.brand_per_row_tablet + " aht-row-" + setting.data.alphabet_list_setting.general_setting.brand_per_row);
        var div_row = document.createElement('div');
        div_row.setAttribute('class', 'aht-grid');

        var div_info = document.createElement('div');
        div_info.setAttribute('class', 'aht-alphabet-list-content');

        var div_letter = document.createElement('div');
        div_letter.setAttribute('class', 'aht-alphabet-letter');
        div_letter.setAttribute('id', 'Character' + value.character);

        var div_name = document.createElement('div');
        div_name.setAttribute('class', 'aht-brand-name aht-center');

        var character = document.createTextNode(value.character);
        div_letter.appendChild(character);
        if (value.brand.length <= setting.data.alphabet_list_setting.general_setting.brand_per_character) {
            var handle = '';
            div_letter.setAttribute('data-current-brand', value.brand.length);
            value.brand.map((brands, index) => {
                if ("" != "") {
                   // handle = "" + brands.brand_id.brand_key;
                  handle = '/collections/vendors?q=' + encodeURI(brands.brand_id.brand_name);
                    handle = handle.replace('&', '%26');
                } else {
                    //var str = brand.brand_id.brand_key;
                    // handle = '/pages/'+ page_title.data.url_key+'/'+str;

                    //Original
                    //handle = '/pages/'+ page_title.data.url_key+'/'+ brands.brand_id.brand_key;
                    //handle = handle.replace('&', '%26');
                    //handle = handle.replace('\'', '%27');

                    handle = '/collections/vendors?q=' + encodeURI(brands.brand_id.brand_name);
                    handle = handle.replace('&', '%26');

                }
                var li_item = document.createElement('div');
                li_item.setAttribute('class', 'aht-alphabet-brand');
                var a_logo = document.createElement('a');
                a_logo.setAttribute('class', 'aht-brand-list-item');
                a_logo.setAttribute('href', handle);

                var brandName = document.createTextNode(brands.brand_id.brand_name);


                a_logo.appendChild(brandName);
                li_item.appendChild(a_logo);
                div_brand.appendChild(li_item);
            });
        } else {
            div_letter.setAttribute('data-current-brand', setting.data.alphabet_list_setting.general_setting.brand_per_character);
            value.brand.slice(0, setting.data.alphabet_list_setting.general_setting.brand_per_character).map((brands, index) => {
                var handle = '';
                if ("" != "") {
                    handle = "" + brands.brand_id.brand_key;
                } else {
                    // handle = '/pages/'+ page_title.data.url_key+'/'+ brands.brand_id.brand_key;
                   // handle = '/pages/' + page_title.data.url_key + '/' + brands.brand_id.brand_key;
                  handle = '/collections/vendors?q=' + encodeURI(brands.brand_id.brand_name);
                    handle = handle.replace('&', '%26');
                }

                var li_item = document.createElement('div');
                li_item.setAttribute('class', 'aht-alphabet-brand');
                var a_logo = document.createElement('a');
                a_logo.setAttribute('class', 'aht-brand-list-item');
                a_logo.setAttribute('href', handle);

                var brandName = document.createTextNode(brands.brand_id.brand_name);


                a_logo.appendChild(brandName);
                li_item.appendChild(a_logo);
                div_brand.appendChild(li_item);
            });
            var li_item = document.createElement('div');
            li_item.setAttribute('class', 'aht-alphabet-brand');
            var a_logo = document.createElement('a');
            a_logo.setAttribute('id', 'loadmore' + value.character);
            a_logo.setAttribute('class', 'aht-brand-list-item alphabet-loadmore');
            a_logo.addEventListener("click", function() {
                var character = this.getAttributeNode("id").value.slice((parseInt(this.getAttributeNode("id").value.length) - 8) * -1);
                var number = document.getElementById("Character" + character).getAttributeNode("data-current-brand").value;

                if (parseInt(number) <= value.brand.length) {
                    value.brand.slice(parseInt(number), parseInt(number) + 1).map((brands, index) => {
                        var handle = '';
                        if ("" != "") {
                            handle = "" + brands.brand_id.brand_key;
                        } else {
                           // handle = '/pages/' + page_title.data.url_key + '/' + brands.brand_id.brand_key;
                          handle = '/collections/vendors?q=' + encodeURI(brands.brand_id.brand_name);
                    handle = handle.replace('&', '%26');
                        }
                        var li_item = document.createElement('div');
                        li_item.setAttribute('class', 'aht-alphabet-brand');
                        var a_logo = document.createElement('a');
                        a_logo.setAttribute('class', 'aht-brand-list-item');
                        a_logo.setAttribute('href', handle);
                        var brandName = document.createTextNode(brands.brand_id.brand_name);
                        a_logo.appendChild(brandName);
                        li_item.appendChild(a_logo);
                        div_brand.insertBefore(li_item, div_brand.childNodes[parseInt(number)]);
                    });
                    document.getElementById("Character" + character).setAttribute("data-current-brand", parseInt(number) + 1);
                    if (parseInt(number) + 1 >= value.brand.length) {
                        this.style.display = 'none'
                    }
                }
            });
            var brandName = document.createTextNode(setting.data.alphabet_list_setting.general_setting.viewmore_text);

            a_logo.appendChild(brandName);
            li_item.appendChild(a_logo);
            div_brand.appendChild(li_item);
        };
        div_row.appendChild(div_brand);
        div_info.appendChild(div_letter);
        div_info.appendChild(div_row);
        div_root.appendChild(div_info);
    });
}
if (page_title.data.alphabet_list == '1' && document.getElementById("template-alphabet-list")) {
    render_alphabet_list();
}

// Search box
function autocomplete(inp, arr) {
    var currentFocus;
    inp.addEventListener("input", function(e) {
        var a, b, i, val = this.value;
        closeAllLists();
        if (!val) {
            return false;
        }
        currentFocus = -1;
        a = document.createElement("DIV");
        a.setAttribute("id", "autocomplete-list");
        a.setAttribute("class", "aht-suggestion-container");
        var list_root = document.getElementById("aht-search");
        list_root.appendChild(a);
        var brand = 0;
        for (i = 0; i < arr.length; i++) {
            var data = arr[i].brand_id.brand_name.toUpperCase();
            var compare = val.toUpperCase();
            if (data.includes(compare)) {
                b = document.createElement("DIV");
                b.setAttribute("class", "aht-suggestion-brand-name");
                if (setting.data.search_box_setting.search_suggest_setting.br_font_bold) {
                    b.innerHTML = makeBold(arr[i].brand_id.brand_name, val);
                }
                var div_left = document.createElement("DIV");
                div_left.setAttribute("class", "aht-suggestion-left");

                var div_right = document.createElement("div");
                div_right.setAttribute("class", "aht-suggestion-right");
                var handle = '';
                if ("" != "") {
                    handle = "" + arr[i].brand_id.brand_key;
                } else {
                    handle = '/pages/' + page_title.data.url_key + '/' + arr[i].brand_id.brand_key;
                }

                var a_brand = document.createElement("a");
                a_brand.setAttribute("href", handle);

                var div = document.createElement("div");
                div.setAttribute("class", "aht-autocomplete-suggestion ");


                var img_brand = document.createElement("img");
                img_brand.setAttribute("src", arr[i].brand_id.brand_logo);
                img_brand.setAttribute("alt", arr[i].brand_id.meta_keyword);

                var p = document.createElement("div");
                p.setAttribute("class", "aht-suggestion-shortdes");

                var shortdes = document.createTextNode(arr[i].brand_id.short_description);
                p.appendChild(shortdes);
                if (setting.data.search_box_setting.search_suggest_setting.show_short_description) {
                    div_right.appendChild(p);
                }
                if (setting.data.search_box_setting.search_suggest_setting.show_brand_name) {
                    div_right.appendChild(b);
                }
                if (setting.data.search_box_setting.search_suggest_setting.show_brand_image) {
                    div_left.appendChild(img_brand);
                }

                a_brand.appendChild(div_left);
                a_brand.appendChild(div_right);
                div.appendChild(a_brand);
                a.appendChild(div);

                div.addEventListener("click", function(e) {
                    window.location.href = "" + this.getElementsByTagName("a")[0].href;
                    closeAllLists();
                });
            } else {
                brand = brand + 1;
                if (brand == arr.length) {
                    z = document.createElement("DIV");
                    a.setAttribute("class", "aht-suggestion-container aht-initial");
                    z.innerHTML = "There is no brand match your require";
                    a.appendChild(z);
                }
            }
        }
    });
    inp.addEventListener("keydown", function(e) {

        var x = document.getElementById("autocomplete-list");
        if (x) x = x.getElementsByClassName("aht-autocomplete-suggestion");
        if (e.keyCode == 40) {
            currentFocus++;
            addActive(x);
        } else if (e.keyCode == 38) {
            currentFocus--;
            addActive(x);
        } else if (e.keyCode == 13) {
            e.preventDefault();
            if (currentFocus > -1) {
                if (x) x[currentFocus].click();
            }
        }
    });

    function addActive(x) {
        if (!x) return false;
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = (x.length - 1);
        x[currentFocus].classList.add("autocomplete-active");
    }

    function removeActive(x) {
        for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("autocomplete-active");
        }
    }

    function closeAllLists(elmnt) {
        var x = document.getElementsByClassName("aht-suggestion-container");
        for (var i = 0; i < x.length; i++) {
            if (elmnt != x[i] && elmnt != inp) {
                x[i].parentNode.removeChild(x[i]);
            }
        }
    }
    document.addEventListener("click", function(e) {
        closeAllLists(e.target);
    });
}
if (document.getElementById("template-search-box")) {
    document.getElementById("aht-brand").placeholder = setting.data.search_box_setting.search_input_setting.placeholder;
    autocomplete(document.getElementById("aht-brand"), brands_new);
    get_position(document.getElementById("template-search-box"), setting.data.search_box_setting.general_setting.content_align)
}

function makeBold(input, wordsToBold) {
    return input.replace(new RegExp('(' + wordsToBold + ')', 'ig'), '<b>$1</b>');
}

// End of search box

//Brand list
function render_brand_list(start, end, letter) {

    var brands = brands_new;

    if (letter) {
        var text = letter.replace("letter", "");
        if (letter != setting.data.brand_list_setting.alphabet_search_setting.text_all) {
            var check_brands = brands_new.filter(brand => {
                return brand.brand_id.brand_name.charAt(0).toLowerCase().indexOf(text.toLowerCase()) >= 0;
            })
            brands = check_brands;
        }
    }

    var handle = ''

    if (brands.length > setting.data.brand_list_setting.general_setting.limit) {
        document.getElementById("hoverLoadMore").style.display = "block";
    } else {
        document.getElementById("hoverLoadMore").style.display = "none";
    }
    const div_row = document.getElementById("aht-bl-row-wrapper");

    brands.slice(start, end).map((brand, index) => {
        var li_item = document.createElement('div');
        li_item.setAttribute('class', 'aht-brand-list-item');
        if ("" != "") {
            handle = "" + brand.brand_id.brand_key;
        } else {
            handle = '/pages/' + page_title.data.url_key + '/' + brand.brand_id.brand_key;
        }
        var img_brand = document.createElement("img");
        img_brand.setAttribute("src", brand.brand_id.brand_logo);
        img_brand.setAttribute("alt", brand.brand_id.meta_keyword ? brand.brand_id.meta_keyword : brand.brand_id.brand_key);

        var a_logo = document.createElement('a');
        a_logo.setAttribute('href', handle);

        var a_img = document.createElement('a');
        a_img.setAttribute('class', 'aht-brand-img');
        a_img.setAttribute('href', handle);

        var div_details = document.createElement("div");
        div_details.setAttribute("class", "aht-brand-details");

        var div_name = document.createElement("div");
        div_name.setAttribute("class", "aht-brand-name");

        var div_wrapper = document.createElement("div");
        div_wrapper.setAttribute("class", "aht-image-wrapper " + setting.data.brand_list_setting.general_setting.hover_effect);
        if (setting.data.brand_list_setting.brand_name_setting.auto_hide && setting.data.brand_list_setting.brand_name_setting.position == 1) {
            div_wrapper.classList.add("aht-auto-hide");
        } else {
            div_wrapper.classList.add("aht-normal-image")
        }


        if (setting.data.brand_list_setting.brand_name_setting.position == 1) {
            div_wrapper.classList.add("brand-inside");
        } else {
            div_wrapper.classList.add("brand-below");
        }

        var div_info = document.createElement("div");
        div_info.setAttribute("class", "aht-brand-info");

        var brandName = document.createTextNode(brand.brand_id.brand_name);

        var span_name = document.createElement("span");
        span_name.setAttribute("class", "aht-brand-name");

        var span_pc = document.createElement("span");
        span_pc.setAttribute("class", "aht-product-count");
        span_name.setAttribute("dir", "auto");
        span_pc.setAttribute("dir", "auto");
        if (setting.data.featured_brand_setting.brand_name_setting.pc_position == 2) {
            span_pc.classList.add("below");
        } else {
            span_pc.classList.add("inline");
        }

        var productCount = document.createTextNode(setting.data.brand_list_setting.brand_name_setting.pc_text_format.replace('%s', brand.products ? brand.products.length : 0))
        span_pc.appendChild(productCount);

        span_name.appendChild(brandName)
        a_logo.appendChild(span_name);


        if (setting.data.brand_list_setting.brand_name_setting.display_product_count) {
            a_logo.appendChild(span_pc);
        }
        a_img.appendChild(img_brand);
        div_name.appendChild(a_logo);
        div_details.appendChild(div_name);
        get_position(div_details, setting.data.brand_list_setting.brand_name_setting.text_align);

        div_wrapper.appendChild(a_img);
        div_wrapper.appendChild(div_details);
        div_info.appendChild(div_wrapper);
        li_item.appendChild(div_info)
        div_row.appendChild(li_item);
    })
}


function render_all() {
    const div_root = document.getElementById("brand-list-row");
    const ul = document.getElementById("aht-brand-list-content");
    const div_row = document.createElement("div");
    div_row.setAttribute("class", "aht-row-wrapper  aht-row-" + setting.data.brand_list_setting.general_setting.brand_per_row + " aht-row-mobile-" + setting.data.brand_list_setting.general_setting.brand_per_row_mobile + " aht-row-tablet-" + setting.data.brand_list_setting.general_setting.brand_per_row_tablet);
    div_row.setAttribute("id", "aht-bl-row-wrapper");

    ul.appendChild(div_row);

    var my_icon = document.createElement("i");
    my_icon.setAttribute("class", "fa left-10 fa-angle-double-right");
    my_icon.setAttribute("aria-hidden", true);

    var button_viewmore = document.createElement("button");
    button_viewmore.setAttribute("class", "btn-viewmore");
    button_viewmore.setAttribute("type", "submit");
    button_viewmore.setAttribute("id", "hoverLoadMore");
    button_viewmore.setAttribute("data-load", setting.data.brand_list_setting.general_setting.limit);
    button_viewmore.addEventListener("click", function() {
        var load_current = parseInt(this.getAttributeNode("data-load").value);
        var all_letter = document.getElementsByClassName("item-alphabet-size active");
        var x_letter = false;
        if (all_letter[0]) {
            x_letter = all_letter[0].getAttribute("data-letter");
        }
        render_brand_list(load_current, load_current + parseInt(setting.data.brand_list_setting.general_setting.load_limit), x_letter);
        this.setAttribute("data-load", load_current + parseInt(setting.data.brand_list_setting.general_setting.load_limit));
        var totalItems = brands_new.length;
        if (x_letter != false && x_letter != setting.data.brand_list_setting.alphabet_search_setting.text_all) {
            const check_exist = brands_new
                .filter(brand => {
                    return brand.brand_id.brand_name.charAt(0).toLowerCase().indexOf(x_letter.toLowerCase()) >= 0;
                })

            totalItems = check_exist.length
        }

        if (load_current + parseInt(setting.data.brand_list_setting.general_setting.load_limit) >= parseInt(totalItems)) {
            button_viewmore.style.display = "none"
        }
    });


    var brandName = document.createTextNode(setting.data.brand_list_setting.general_setting.loadmore_text);
    button_viewmore.appendChild(brandName);
    button_viewmore.appendChild(my_icon);
    if (setting.data.brand_list_setting.general_setting.loadmore_font_bold) {
        button_viewmore.classList.add("font-bold");
    }
    div_root.appendChild(button_viewmore);

    if (setting.data.brand_list_setting.alphabet_search_setting.display_alphabet) {
        var div_alphabet = document.createElement("div");
        div_alphabet.setAttribute("class", "alphabet-search-bar");

        var div_alphabet_wrapper = document.createElement("ul");
        div_alphabet_wrapper.setAttribute("class", "alphabet-search-wrapper");

        if (setting.data.brand_list_setting.alphabet_search_setting.alphabet != '') {
            var li = document.createElement("li");
            li.setAttribute("class", "item-alphabet-size active");
            li.setAttribute("data-letter", setting.data.brand_list_setting.alphabet_search_setting.text_all);

            var x = document.createTextNode(setting.data.brand_list_setting.alphabet_search_setting.text_all);
            li.appendChild(x);
            li.addEventListener("click", function() {
                var cur_columns = document.getElementsByClassName('item-alphabet-size');
                for (var i = 0; i < cur_columns.length; i++) {
                    cur_columns[i].classList.remove('active');
                }
                this.classList.add('active')
                var letter = this.getAttributeNode("data-letter").value;
                document.getElementById("aht-bl-row-wrapper").innerHTML = "";
                document.getElementById("hoverLoadMore").setAttribute("data-load", setting.data.brand_list_setting.general_setting.limit);
                render_brand_list(0, setting.data.brand_list_setting.general_setting.limit, letter)
            });
            div_alphabet_wrapper.appendChild(li);

            var alphabet_list = [];
            setting.data.brand_list_setting.alphabet_search_setting.alphabet.split(',').map((value, index) => {
                if (value != '') {
                    const check_exist = brands_new
                        .filter(brand => {
                            return brand.brand_id.brand_name.charAt(0).toLowerCase().indexOf(value.toLowerCase()) >= 0;
                        })

                    if (check_exist.length <= 0) {
                        alphabet_list.push(value.toLowerCase());
                    };
                }
            })

            setting.data.brand_list_setting.alphabet_search_setting.alphabet.split(",").map((current_letter, index) => {
                var li = document.createElement("li");
                li.setAttribute("data-letter", current_letter);

                if (alphabet_list.includes(current_letter.toLowerCase())) {

                    li.setAttribute("class", "item-alphabet-size disable");
                } else {
                    li.setAttribute("class", "item-alphabet-size");
                    li.addEventListener("click", function() {
                        var cur_columns = document.getElementsByClassName('item-alphabet-size');
                        for (var i = 0; i < cur_columns.length; i++) {
                            cur_columns[i].classList.remove('active');
                        }
                        this.classList.add('active')
                        var letter = this.getAttributeNode("data-letter").value;
                        document.getElementById("aht-bl-row-wrapper").innerHTML = "";
                        document.getElementById("hoverLoadMore").setAttribute("data-load", setting.data.brand_list_setting.general_setting.limit);
                        render_brand_list(0, setting.data.brand_list_setting.general_setting.limit, letter)
                    });
                }

                var x = document.createTextNode(current_letter);
                li.appendChild(x);

                div_alphabet_wrapper.appendChild(li)
            })
        }
        div_alphabet.appendChild(div_alphabet_wrapper)
        ul.prepend(div_alphabet);
    }
    render_brand_list(0, setting.data.brand_list_setting.general_setting.limit);

}


if (page_title.data.brand_list == '1' && document.getElementById("template-brand-list")) {

    render_all();
}
//End of brand list

// Feature brand

var feature_brand = brands_new.filter(function(brand) {
    if (brand.brand_id.is_feature == false) {
        return false;
    }
    return true;
});

if (document.getElementById("template-featured-brand")) {
    if (feature_brand.length) {
        document.getElementById("featured-brand-title").appendChild(fb_title);
        if (setting.data.featured_brand_setting.title_setting.font_bold) {
            document.getElementById("featured-brand-title").classList.add("aht-bold");
        }
        get_position(document.getElementById("featured-brand-title"), setting.data.featured_brand_setting.title_setting.align);
    } else {
        document.getElementById("template-featured-brand").style.display = "none";
        document.getElementById("template-featured-brand").style.margin = "0px";
        document.getElementById("template-featured-brand").style.padding = "0px";
    }
}


jq213 = jQuery.noConflict(true);

function sliderInit() {
    const number = (setting.data.featured_brand_setting.brand_setting.brand_per_row >= feature_brand.length) ? ((feature_brand.length - 1 == 0) ? 1 : feature_brand.length - 1) : setting.data.featured_brand_setting.brand_setting.brand_per_row;
    const tablet_number = (setting.data.featured_brand_setting.brand_setting.brand_per_row_tablet >= feature_brand.length) ? ((feature_brand.length - 1 == 0) ? 1 : feature_brand.length - 1) : setting.data.featured_brand_setting.brand_setting.brand_per_row_tablet;
    const mobile_number = (setting.data.featured_brand_setting.brand_setting.brand_per_row_mobile >= feature_brand.length) ? ((feature_brand.length - 1 == 0) ? 1 : feature_brand.length - 1) : setting.data.featured_brand_setting.brand_setting.brand_per_row_mobile;

    jq213('#aht-featured-brand-content').slick({
        slidesToShow: number,
        slidesToScroll: setting.data.featured_brand_setting.brand_setting.slide_by,
        rtl: setting.data.featured_brand_setting.brand_setting.rtl,
        infinite: setting.data.featured_brand_setting.brand_setting.loop,
        arrows: (feature_brand.length) ? setting.data.featured_brand_setting.brand_setting.display_navigation : false,
        dots: (feature_brand.length) ? setting.data.featured_brand_setting.brand_setting.display_Pagination : false,
        prevArrow: `<div class="slick-arrow rtl slick-prev" id="aht-arrow-prev"></div>`,
        nextArrow: `<div class="slick-arrow rtl slick-next" id="aht-arrow-next"></div>`,
        autoplay: setting.data.featured_brand_setting.brand_setting.autoplay,
        speed: 1000,
        autoplaySpeed: setting.data.featured_brand_setting.brand_setting.autoplay_timeout,
        dotsClass: "aht-slick-dots",
        customPaging: function(slick, index) {
            return '<div class="slick-dot" ></div>';
        },
        responsive: [{
                breakpoint: 980, // tablet breakpoint
                settings: {
                    slidesToShow: tablet_number,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480, // mobile breakpoint
                settings: {
                    slidesToShow: mobile_number,
                    slidesToScroll: 1
                }
            }
        ]
    });

    switch (number) {
        case 1:
            document.getElementById("aht-featured-brand-content").style.width = '20%';
            break;
        case 2:
            document.getElementById("aht-featured-brand-content").style.width = '40%';
            break;
        case 3:
            document.getElementById("aht-featured-brand-content").style.width = '60%';
            break;
        case 4:
            document.getElementById("aht-featured-brand-content").style.width = '80%';
            break;
        default:
            document.getElementById("aht-featured-brand-content").style.width = '100%';
            break;
    }
};


jq213(document).on('ready', function() {
    if (document.getElementById("aht-featured-brand-content")) {
        if (setting.data.featured_brand_setting.brand_setting.use_slider) {
            sliderInit();
            if (setting.data.featured_brand_setting.brand_setting.hide_navigation && document.getElementById("aht-arrow-prev")) {
                document.getElementById("aht-arrow-prev").classList.add("hide-navigation");
                document.getElementById("aht-arrow-next").classList.add("hide-navigation");
            };
            if (document.getElementById("aht-arrow-prev")) {
                if (setting.data.featured_brand_setting.brand_setting.navigation_position == 2) {
                    document.getElementById("aht-arrow-prev").classList.add("outside-arrow");
                    document.getElementById("aht-arrow-next").classList.add("outside-arrow");
                } else {
                    document.getElementById("aht-arrow-prev").classList.add("inside-arrow");
                    document.getElementById("aht-arrow-next").classList.add("inside-arrow");
                }
            };
        } else {
            document.getElementById("aht-featured-brand-content").classList.add("aht-grid");
        }
    }
});

function get_featured_brand() {
    const div_origin = document.getElementById("aht-featured-brand-content");
    if (setting.data.featured_brand_setting.brand_setting.rtl && setting.data.featured_brand_setting.brand_setting.use_slider) {
        div_origin.setAttribute("dir", "rtl");
    }

    var handle;

    if (setting.data.featured_brand_setting.brand_setting.use_slider) {
        feature_brand.slice(0, setting.data.featured_brand_setting.brand_setting.limit).map((brand, index) => {
            var li_item = document.createElement('div');
            li_item.setAttribute('class', 'aht-fb-item');
            if (setting.data.featured_brand_setting.brand_setting.rtl && setting.data.featured_brand_setting.brand_setting.use_slider) {
                li_item.setAttribute('dir', 'rtl');
            }
            var img_brand = document.createElement("img");
            img_brand.setAttribute("src", brand.brand_id.brand_logo);
            img_brand.setAttribute("alt", brand.brand_id.meta_keyword);

            if ("" != "") {
                handle = "" + brand.brand_id.brand_key;
            } else {
                // var str = brand.brand_id.brand_key+'WOW';
                // handle = '/pages/'+ page_title.data.url_key+'/'+str;
                handle = '/pages/' + page_title.data.url_key + '/' + brand.brand_id.brand_key;
            }
            var a_logo = document.createElement('a');
            a_logo.setAttribute('href', handle);

            var a_img = document.createElement('a');
            a_img.setAttribute('class', 'aht-brand-img');
            a_img.setAttribute('href', handle);

            var div_details = document.createElement("div");
            div_details.setAttribute("class", "aht-brand-details");

            var div_name = document.createElement("div");
            div_name.setAttribute("class", "aht-brand-name");

            var div_wrapper = document.createElement("div");
            div_wrapper.setAttribute("class", "aht-image-wrapper " + setting.data.featured_brand_setting.brand_setting.hover_efect);
            if (setting.data.featured_brand_setting.brand_name_setting.auto_hide && setting.data.featured_brand_setting.brand_name_setting.position == 1) {
                div_wrapper.classList.add("aht-auto-hide");
            }


            if (setting.data.featured_brand_setting.brand_name_setting.position == 1) {
                div_wrapper.classList.add("brand-inside");
            } else {
                div_wrapper.classList.add("brand-below");
            }

            var div_info = document.createElement("div");
            div_info.setAttribute("class", "aht-brand-info");

            var span_name = document.createElement("span");
            span_name.setAttribute("class", "aht-brand-name");
            span_name.setAttribute("dir", "auto");

            var span_pc = document.createElement("span");
            span_pc.setAttribute("class", "aht-product-count");
            span_pc.setAttribute("dir", "auto");

            if (setting.data.featured_brand_setting.brand_name_setting.pc_position == 2) {
                span_pc.classList.add("below");
            } else {
                span_pc.classList.add("inline");
            }

            var brandName = document.createTextNode(brand.brand_id.brand_name + " ");


            var productCount = document.createTextNode(setting.data.featured_brand_setting.brand_name_setting.pc_text_format.replace('%s', brand.products ? brand.products.length : 0))
            span_pc.appendChild(productCount);

            span_name.appendChild(brandName)
            a_logo.appendChild(span_name);


            if (setting.data.featured_brand_setting.brand_name_setting.display_product_count) {
                a_logo.appendChild(span_pc);
            }

            a_img.appendChild(img_brand);
            div_details.appendChild(div_name);
            div_name.appendChild(a_logo);
            div_wrapper.appendChild(a_img);
            if (setting.data.featured_brand_setting.brand_name_setting.display) {
                div_wrapper.appendChild(div_details);
                get_position(div_details, setting.data.featured_brand_setting.brand_name_setting.text_align);
            }


            div_info.appendChild(div_wrapper);
            li_item.appendChild(div_info);
            div_origin.appendChild(li_item);
        });
    } else {
        const div_row = document.createElement("div");
        div_row.setAttribute("class", "aht-row-wrapper aht-row-" + setting.data.featured_brand_setting.brand_setting.brand_per_row + " aht-row-mobile-" + setting.data.featured_brand_setting.brand_setting.brand_per_row_mobile + " aht-row-tablet-" + setting.data.featured_brand_setting.brand_setting.brand_per_row_tablet);

        div_origin.appendChild(div_row);
        feature_brand.slice(0, setting.data.featured_brand_setting.brand_setting.limit).map((brand, index) => {
            var li_item = document.createElement('div');
            li_item.setAttribute('class', 'aht-fb-item');

            var img_brand = document.createElement("img");
            img_brand.setAttribute("src", brand.brand_id.brand_logo);
            img_brand.setAttribute("alt", brand.brand_id.meta_keyword);

            if ("" != "") {
                handle = "" + brand.brand_id.brand_key;
            } else {
                handle = '/pages/' + page_title.data.url_key + '/' + brand.brand_id.brand_key;
            }
            var a_logo = document.createElement('a');
            a_logo.setAttribute('href', handle);

            var a_img = document.createElement('a');
            a_img.setAttribute('class', 'aht-brand-img');
            a_img.setAttribute('href', handle);

            var div_details = document.createElement("div");
            div_details.setAttribute("class", "aht-brand-details");

            var div_name = document.createElement("div");
            div_name.setAttribute("class", "aht-brand-name");

            var div_wrapper = document.createElement("div");
            div_wrapper.setAttribute("class", "aht-image-wrapper " + setting.data.featured_brand_setting.brand_setting.hover_efect);
            if (setting.data.featured_brand_setting.brand_name_setting.auto_hide && setting.data.featured_brand_setting.brand_name_setting.position == 1) {
                div_wrapper.classList.add("aht-auto-hide");
            }

            if (setting.data.featured_brand_setting.brand_name_setting.position == 1) {
                div_wrapper.classList.add("brand-inside");
            } else {
                div_wrapper.classList.add("brand-below");
            }

            var div_info = document.createElement("div");
            div_info.setAttribute("class", "aht-brand-info");

            var brandName = document.createTextNode(brand.brand_id.brand_name);

            var span_name = document.createElement("span");
            span_name.setAttribute("class", "aht-brand-name");

            var span_pc = document.createElement("span");
            span_pc.setAttribute("class", "aht-product-count");

            span_name.setAttribute("dir", "auto");
            span_pc.setAttribute("dir", "auto");

            if (setting.data.featured_brand_setting.brand_name_setting.pc_position == 2) {
                span_pc.classList.add("below");
            } else {
                span_pc.classList.add("inline");
            }


            var productCount = document.createTextNode(setting.data.featured_brand_setting.brand_name_setting.pc_text_format.replace('%s', brand.products ? brand.products.length : 0))
            span_pc.appendChild(productCount);

            span_name.appendChild(brandName)
            a_logo.appendChild(span_name);

            if (setting.data.featured_brand_setting.brand_name_setting.display_product_count) {
                a_logo.appendChild(span_pc);
            }
            a_img.appendChild(img_brand);
            div_details.appendChild(div_name);
            div_name.appendChild(a_logo);
            div_wrapper.appendChild(a_img);
            if (setting.data.featured_brand_setting.brand_name_setting.display) {
                div_wrapper.appendChild(div_details);
                get_position(div_details, setting.data.featured_brand_setting.brand_name_setting.text_align);
            }
            div_info.appendChild(div_wrapper);
            li_item.appendChild(div_info);
            div_row.appendChild(li_item);
        });
    }

}
if (page_title.data.featured_brand == '1' && document.getElementById("template-featured-brand")) {
    get_featured_brand();
}